// Master Daily Tasks List generated from Google Spreadsheet
// Spreadsheet ID: 1omO-ZV6eNns56OpoifD3T75PrAouWhSf6bYdByHs-Cg (Tab: Master Daily Task List)
// Includes matched Drive URLs and verified file access permissions.

export interface DailyTaskEntry {
  id?: string;
  name: string;
  description: string;
  url: string;
  team: string;
  categories?: string[];
  accessEmails?: string[];
  assignee?: string;
  code?: string;
  customDisplayName?: string;
}

export const MASTER_DAILY_TASKS_ENTRIES: DailyTaskEntry[] = [
  {
    "name": "Start of Day Front Desk Checklist",
    "description": "Daily Task for Front Desk (FD-1)",
    "url": "https://docs.google.com/spreadsheets/d/11MKo1xLdUGreNniy5QxKFIJ-zk7dhgYkLKW_bqqVV1g/edit?gid=441734537#gid=441734537",
    "team": "Front Desk",
    "assignee": "Front Desk",
    "code": "FD-1",
    "accessEmails": [
      "aadwell@ssdspc.com",
      "admin@ssdspc.com",
      "adminhelp@ssdspc.com",
      "afloyd@ssdspc.com",
      "agamache@ssdspc.com",
      "agolightly@ssdspc.com",
      "agonzalez@ssdspc.com",
      "ajones@ssdspc.com",
      "aparameswaran@ssdspc.com",
      "appsheet@ssdspc.com",
      "automation@ssdspc.com",
      "awalden@ssdspc.com",
      "ayoung@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "bhammonds@ssdspc.com",
      "bherrington@ssdspc.com",
      "bwscan@ssdspc.com",
      "cmartin@ssdspc.com",
      "cthomson@ssdspc.com",
      "dderamus@ssdspc.com",
      "documents@ssdspc.com",
      "dpatel@ssdspc.com",
      "dwalters@ssdspc.com",
      "ehenegar@ssdspc.com",
      "estephens@ssdspc.com",
      "fax@ssdspc.com",
      "games@ssdspc.com",
      "gmcmahan@ssdspc.com",
      "hangouts-chat-45b23cd19217da44@ssdspc.com",
      "hangouts-chat-8cf9bcfb23006f2b@ssdspc.com",
      "hangouts-chat-92d059881c6662fc@ssdspc.com",
      "hangouts-chat-a882a3b4a05f1865@ssdspc.com",
      "hwest@ssdspc.com",
      "jhagan@ssdspc.com",
      "jniblack@ssdspc.com",
      "jpayton@ssdspc.com",
      "jreynolds@ssdspc.com",
      "kcharles@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmcmurray@ssdspc.com",
      "kparker@ssdspc.com",
      "kparton@ssdspc.com",
      "lmarsh@ssdspc.com",
      "lsanford@ssdspc.com",
      "mbaker@ssdspc.com",
      "mbivins@ssdspc.com",
      "mdowning@ssdspc.com",
      "mfortner@ssdspc.com",
      "mgonzalez@ssdspc.com",
      "mhornsby@ssdspc.com",
      "mm@ssdspc.com",
      "mstewart@ssdspc.com",
      "nteague@ssdspc.com",
      "powen@ssdspc.com",
      "rhead@ssdspc.com",
      "rkhan@ssdspc.com",
      "romar@ssdspc.com",
      "scripts@ssdspc.com",
      "skhan@ssdspc.com",
      "sriggins@ssdspc.com",
      "ssawyer@ssdspc.com",
      "ssd-automation-service-account@workspace-automation-ssdspc.iam.gserviceaccount.com",
      "sync-sa@ssd-intranet-sync.iam.gserviceaccount.com",
      "tbunton@ssdspc.com",
      "tplatts@ssdspc.com",
      "twood@ssdspc.com",
      "voicemail@ssdspc.com"
    ]
  },
  {
    "name": "Start of Day - Clean and Setup Waiting Room",
    "description": "Daily Task for Front Desk (FD-7)",
    "url": "https://docs.google.com/spreadsheets/d/11MKo1xLdUGreNniy5QxKFIJ-zk7dhgYkLKW_bqqVV1g/edit?gid=441734537#gid=441734537",
    "team": "Front Desk",
    "assignee": "Front Desk",
    "code": "FD-7",
    "accessEmails": [
      "aadwell@ssdspc.com",
      "admin@ssdspc.com",
      "adminhelp@ssdspc.com",
      "afloyd@ssdspc.com",
      "agamache@ssdspc.com",
      "agolightly@ssdspc.com",
      "agonzalez@ssdspc.com",
      "ajones@ssdspc.com",
      "aparameswaran@ssdspc.com",
      "appsheet@ssdspc.com",
      "automation@ssdspc.com",
      "awalden@ssdspc.com",
      "ayoung@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "bhammonds@ssdspc.com",
      "bherrington@ssdspc.com",
      "bwscan@ssdspc.com",
      "cmartin@ssdspc.com",
      "cthomson@ssdspc.com",
      "dderamus@ssdspc.com",
      "documents@ssdspc.com",
      "dpatel@ssdspc.com",
      "dwalters@ssdspc.com",
      "ehenegar@ssdspc.com",
      "estephens@ssdspc.com",
      "fax@ssdspc.com",
      "games@ssdspc.com",
      "gmcmahan@ssdspc.com",
      "hangouts-chat-45b23cd19217da44@ssdspc.com",
      "hangouts-chat-8cf9bcfb23006f2b@ssdspc.com",
      "hangouts-chat-92d059881c6662fc@ssdspc.com",
      "hangouts-chat-a882a3b4a05f1865@ssdspc.com",
      "hwest@ssdspc.com",
      "jhagan@ssdspc.com",
      "jniblack@ssdspc.com",
      "jpayton@ssdspc.com",
      "jreynolds@ssdspc.com",
      "kcharles@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmcmurray@ssdspc.com",
      "kparker@ssdspc.com",
      "kparton@ssdspc.com",
      "lmarsh@ssdspc.com",
      "lsanford@ssdspc.com",
      "mbaker@ssdspc.com",
      "mbivins@ssdspc.com",
      "mdowning@ssdspc.com",
      "mfortner@ssdspc.com",
      "mgonzalez@ssdspc.com",
      "mhornsby@ssdspc.com",
      "mm@ssdspc.com",
      "mstewart@ssdspc.com",
      "nteague@ssdspc.com",
      "powen@ssdspc.com",
      "rhead@ssdspc.com",
      "rkhan@ssdspc.com",
      "romar@ssdspc.com",
      "scripts@ssdspc.com",
      "skhan@ssdspc.com",
      "sriggins@ssdspc.com",
      "ssawyer@ssdspc.com",
      "ssd-automation-service-account@workspace-automation-ssdspc.iam.gserviceaccount.com",
      "sync-sa@ssd-intranet-sync.iam.gserviceaccount.com",
      "tbunton@ssdspc.com",
      "tplatts@ssdspc.com",
      "twood@ssdspc.com",
      "voicemail@ssdspc.com"
    ]
  },
  {
    "name": "Start of Day - Check if iPads need updates",
    "description": "Daily Task for Front Desk (FD-19)",
    "url": "https://docs.google.com/spreadsheets/d/11MKo1xLdUGreNniy5QxKFIJ-zk7dhgYkLKW_bqqVV1g/edit?gid=441734537#gid=441734537",
    "team": "Front Desk",
    "assignee": "Front Desk",
    "code": "FD-19",
    "accessEmails": [
      "aadwell@ssdspc.com",
      "admin@ssdspc.com",
      "adminhelp@ssdspc.com",
      "afloyd@ssdspc.com",
      "agamache@ssdspc.com",
      "agolightly@ssdspc.com",
      "agonzalez@ssdspc.com",
      "ajones@ssdspc.com",
      "aparameswaran@ssdspc.com",
      "appsheet@ssdspc.com",
      "automation@ssdspc.com",
      "awalden@ssdspc.com",
      "ayoung@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "bhammonds@ssdspc.com",
      "bherrington@ssdspc.com",
      "bwscan@ssdspc.com",
      "cmartin@ssdspc.com",
      "cthomson@ssdspc.com",
      "dderamus@ssdspc.com",
      "documents@ssdspc.com",
      "dpatel@ssdspc.com",
      "dwalters@ssdspc.com",
      "ehenegar@ssdspc.com",
      "estephens@ssdspc.com",
      "fax@ssdspc.com",
      "games@ssdspc.com",
      "gmcmahan@ssdspc.com",
      "hangouts-chat-45b23cd19217da44@ssdspc.com",
      "hangouts-chat-8cf9bcfb23006f2b@ssdspc.com",
      "hangouts-chat-92d059881c6662fc@ssdspc.com",
      "hangouts-chat-a882a3b4a05f1865@ssdspc.com",
      "hwest@ssdspc.com",
      "jhagan@ssdspc.com",
      "jniblack@ssdspc.com",
      "jpayton@ssdspc.com",
      "jreynolds@ssdspc.com",
      "kcharles@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmcmurray@ssdspc.com",
      "kparker@ssdspc.com",
      "kparton@ssdspc.com",
      "lmarsh@ssdspc.com",
      "lsanford@ssdspc.com",
      "mbaker@ssdspc.com",
      "mbivins@ssdspc.com",
      "mdowning@ssdspc.com",
      "mfortner@ssdspc.com",
      "mgonzalez@ssdspc.com",
      "mhornsby@ssdspc.com",
      "mm@ssdspc.com",
      "mstewart@ssdspc.com",
      "nteague@ssdspc.com",
      "powen@ssdspc.com",
      "rhead@ssdspc.com",
      "rkhan@ssdspc.com",
      "romar@ssdspc.com",
      "scripts@ssdspc.com",
      "skhan@ssdspc.com",
      "sriggins@ssdspc.com",
      "ssawyer@ssdspc.com",
      "ssd-automation-service-account@workspace-automation-ssdspc.iam.gserviceaccount.com",
      "sync-sa@ssd-intranet-sync.iam.gserviceaccount.com",
      "tbunton@ssdspc.com",
      "tplatts@ssdspc.com",
      "twood@ssdspc.com",
      "voicemail@ssdspc.com"
    ]
  },
  {
    "name": "Print and Distribute Patient Summary Sheets",
    "description": "Daily Task for Front Desk (FD-2)",
    "url": "https://docs.google.com/spreadsheets/d/1pYayiiye16Sf4NRnF9QaP06-UpdSeuRZJWiIKY2alMg/edit?gid=0#gid=0",
    "team": "Front Desk",
    "assignee": "Front Desk",
    "code": "FD-2",
    "accessEmails": [
      "aadwell@ssdspc.com",
      "admin@ssdspc.com",
      "adminhelp@ssdspc.com",
      "afloyd@ssdspc.com",
      "agamache@ssdspc.com",
      "agolightly@ssdspc.com",
      "agonzalez@ssdspc.com",
      "ajones@ssdspc.com",
      "aparameswaran@ssdspc.com",
      "appsheet@ssdspc.com",
      "automation@ssdspc.com",
      "awalden@ssdspc.com",
      "ayoung@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "bhammonds@ssdspc.com",
      "bherrington@ssdspc.com",
      "bwscan@ssdspc.com",
      "cmartin@ssdspc.com",
      "cthomson@ssdspc.com",
      "dderamus@ssdspc.com",
      "documents@ssdspc.com",
      "dpatel@ssdspc.com",
      "dwalters@ssdspc.com",
      "ehenegar@ssdspc.com",
      "estephens@ssdspc.com",
      "fax@ssdspc.com",
      "games@ssdspc.com",
      "gmcmahan@ssdspc.com",
      "hangouts-chat-45b23cd19217da44@ssdspc.com",
      "hangouts-chat-8cf9bcfb23006f2b@ssdspc.com",
      "hangouts-chat-92d059881c6662fc@ssdspc.com",
      "hangouts-chat-a882a3b4a05f1865@ssdspc.com",
      "hwest@ssdspc.com",
      "jhagan@ssdspc.com",
      "jniblack@ssdspc.com",
      "jpayton@ssdspc.com",
      "jreynolds@ssdspc.com",
      "kcharles@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmcmurray@ssdspc.com",
      "kparker@ssdspc.com",
      "kparton@ssdspc.com",
      "lmarsh@ssdspc.com",
      "lsanford@ssdspc.com",
      "mbaker@ssdspc.com",
      "mbivins@ssdspc.com",
      "mdowning@ssdspc.com",
      "mfortner@ssdspc.com",
      "mgonzalez@ssdspc.com",
      "mhornsby@ssdspc.com",
      "mm@ssdspc.com",
      "mstewart@ssdspc.com",
      "nteague@ssdspc.com",
      "powen@ssdspc.com",
      "rhead@ssdspc.com",
      "rkhan@ssdspc.com",
      "romar@ssdspc.com",
      "scripts@ssdspc.com",
      "skhan@ssdspc.com",
      "sriggins@ssdspc.com",
      "ssawyer@ssdspc.com",
      "ssd-automation-service-account@workspace-automation-ssdspc.iam.gserviceaccount.com",
      "sync-sa@ssd-intranet-sync.iam.gserviceaccount.com",
      "tbunton@ssdspc.com",
      "tplatts@ssdspc.com",
      "twood@ssdspc.com",
      "voicemail@ssdspc.com"
    ]
  },
  {
    "name": "Front Desk Morning Huddle on Google Meet",
    "description": "Daily Task for Front Desk (FD-3)",
    "url": "https://docs.google.com/spreadsheets/d/11MKo1xLdUGreNniy5QxKFIJ-zk7dhgYkLKW_bqqVV1g/edit?gid=441734537#gid=441734537",
    "team": "Front Desk",
    "assignee": "Front Desk",
    "code": "FD-3",
    "accessEmails": [
      "aadwell@ssdspc.com",
      "admin@ssdspc.com",
      "adminhelp@ssdspc.com",
      "afloyd@ssdspc.com",
      "agamache@ssdspc.com",
      "agolightly@ssdspc.com",
      "agonzalez@ssdspc.com",
      "ajones@ssdspc.com",
      "aparameswaran@ssdspc.com",
      "appsheet@ssdspc.com",
      "automation@ssdspc.com",
      "awalden@ssdspc.com",
      "ayoung@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "bhammonds@ssdspc.com",
      "bherrington@ssdspc.com",
      "bwscan@ssdspc.com",
      "cmartin@ssdspc.com",
      "cthomson@ssdspc.com",
      "dderamus@ssdspc.com",
      "documents@ssdspc.com",
      "dpatel@ssdspc.com",
      "dwalters@ssdspc.com",
      "ehenegar@ssdspc.com",
      "estephens@ssdspc.com",
      "fax@ssdspc.com",
      "games@ssdspc.com",
      "gmcmahan@ssdspc.com",
      "hangouts-chat-45b23cd19217da44@ssdspc.com",
      "hangouts-chat-8cf9bcfb23006f2b@ssdspc.com",
      "hangouts-chat-92d059881c6662fc@ssdspc.com",
      "hangouts-chat-a882a3b4a05f1865@ssdspc.com",
      "hwest@ssdspc.com",
      "jhagan@ssdspc.com",
      "jniblack@ssdspc.com",
      "jpayton@ssdspc.com",
      "jreynolds@ssdspc.com",
      "kcharles@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmcmurray@ssdspc.com",
      "kparker@ssdspc.com",
      "kparton@ssdspc.com",
      "lmarsh@ssdspc.com",
      "lsanford@ssdspc.com",
      "mbaker@ssdspc.com",
      "mbivins@ssdspc.com",
      "mdowning@ssdspc.com",
      "mfortner@ssdspc.com",
      "mgonzalez@ssdspc.com",
      "mhornsby@ssdspc.com",
      "mm@ssdspc.com",
      "mstewart@ssdspc.com",
      "nteague@ssdspc.com",
      "powen@ssdspc.com",
      "rhead@ssdspc.com",
      "rkhan@ssdspc.com",
      "romar@ssdspc.com",
      "scripts@ssdspc.com",
      "skhan@ssdspc.com",
      "sriggins@ssdspc.com",
      "ssawyer@ssdspc.com",
      "ssd-automation-service-account@workspace-automation-ssdspc.iam.gserviceaccount.com",
      "sync-sa@ssd-intranet-sync.iam.gserviceaccount.com",
      "tbunton@ssdspc.com",
      "tplatts@ssdspc.com",
      "twood@ssdspc.com",
      "voicemail@ssdspc.com"
    ]
  },
  {
    "name": "Call patients with \u201cPending\u201d appt statuses to \"confirm\" their appts",
    "description": "Daily Task for Front Desk (FD-4) - Need to call all patients not only the surgery ones",
    "url": "https://docs.google.com/spreadsheets/d/11MKo1xLdUGreNniy5QxKFIJ-zk7dhgYkLKW_bqqVV1g/edit?gid=441734537#gid=441734537",
    "team": "Front Desk",
    "assignee": "Front Desk",
    "code": "FD-4",
    "accessEmails": [
      "aadwell@ssdspc.com",
      "admin@ssdspc.com",
      "adminhelp@ssdspc.com",
      "afloyd@ssdspc.com",
      "agamache@ssdspc.com",
      "agolightly@ssdspc.com",
      "agonzalez@ssdspc.com",
      "ajones@ssdspc.com",
      "aparameswaran@ssdspc.com",
      "appsheet@ssdspc.com",
      "automation@ssdspc.com",
      "awalden@ssdspc.com",
      "ayoung@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "bhammonds@ssdspc.com",
      "bherrington@ssdspc.com",
      "bwscan@ssdspc.com",
      "cmartin@ssdspc.com",
      "cthomson@ssdspc.com",
      "dderamus@ssdspc.com",
      "documents@ssdspc.com",
      "dpatel@ssdspc.com",
      "dwalters@ssdspc.com",
      "ehenegar@ssdspc.com",
      "estephens@ssdspc.com",
      "fax@ssdspc.com",
      "games@ssdspc.com",
      "gmcmahan@ssdspc.com",
      "hangouts-chat-45b23cd19217da44@ssdspc.com",
      "hangouts-chat-8cf9bcfb23006f2b@ssdspc.com",
      "hangouts-chat-92d059881c6662fc@ssdspc.com",
      "hangouts-chat-a882a3b4a05f1865@ssdspc.com",
      "hwest@ssdspc.com",
      "jhagan@ssdspc.com",
      "jniblack@ssdspc.com",
      "jpayton@ssdspc.com",
      "jreynolds@ssdspc.com",
      "kcharles@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmcmurray@ssdspc.com",
      "kparker@ssdspc.com",
      "kparton@ssdspc.com",
      "lmarsh@ssdspc.com",
      "lsanford@ssdspc.com",
      "mbaker@ssdspc.com",
      "mbivins@ssdspc.com",
      "mdowning@ssdspc.com",
      "mfortner@ssdspc.com",
      "mgonzalez@ssdspc.com",
      "mhornsby@ssdspc.com",
      "mm@ssdspc.com",
      "mstewart@ssdspc.com",
      "nteague@ssdspc.com",
      "powen@ssdspc.com",
      "rhead@ssdspc.com",
      "rkhan@ssdspc.com",
      "romar@ssdspc.com",
      "scripts@ssdspc.com",
      "skhan@ssdspc.com",
      "sriggins@ssdspc.com",
      "ssawyer@ssdspc.com",
      "ssd-automation-service-account@workspace-automation-ssdspc.iam.gserviceaccount.com",
      "sync-sa@ssd-intranet-sync.iam.gserviceaccount.com",
      "tbunton@ssdspc.com",
      "tplatts@ssdspc.com",
      "twood@ssdspc.com",
      "voicemail@ssdspc.com"
    ]
  },
  {
    "name": "Work on rescheduling Sheets",
    "description": "Daily Task for Front Desk (FD-14)",
    "url": "https://docs.google.com/spreadsheets/d/11MKo1xLdUGreNniy5QxKFIJ-zk7dhgYkLKW_bqqVV1g/edit?gid=678314630#gid=678314630",
    "team": "Front Desk",
    "assignee": "Front Desk",
    "code": "FD-14",
    "accessEmails": [
      "aadwell@ssdspc.com",
      "admin@ssdspc.com",
      "adminhelp@ssdspc.com",
      "afloyd@ssdspc.com",
      "agamache@ssdspc.com",
      "agolightly@ssdspc.com",
      "agonzalez@ssdspc.com",
      "ajones@ssdspc.com",
      "aparameswaran@ssdspc.com",
      "appsheet@ssdspc.com",
      "automation@ssdspc.com",
      "awalden@ssdspc.com",
      "ayoung@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "bhammonds@ssdspc.com",
      "bherrington@ssdspc.com",
      "bwscan@ssdspc.com",
      "cmartin@ssdspc.com",
      "cthomson@ssdspc.com",
      "dderamus@ssdspc.com",
      "documents@ssdspc.com",
      "dpatel@ssdspc.com",
      "dwalters@ssdspc.com",
      "ehenegar@ssdspc.com",
      "estephens@ssdspc.com",
      "fax@ssdspc.com",
      "games@ssdspc.com",
      "gmcmahan@ssdspc.com",
      "hangouts-chat-45b23cd19217da44@ssdspc.com",
      "hangouts-chat-8cf9bcfb23006f2b@ssdspc.com",
      "hangouts-chat-92d059881c6662fc@ssdspc.com",
      "hangouts-chat-a882a3b4a05f1865@ssdspc.com",
      "hwest@ssdspc.com",
      "jhagan@ssdspc.com",
      "jniblack@ssdspc.com",
      "jpayton@ssdspc.com",
      "jreynolds@ssdspc.com",
      "kcharles@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmcmurray@ssdspc.com",
      "kparker@ssdspc.com",
      "kparton@ssdspc.com",
      "lmarsh@ssdspc.com",
      "lsanford@ssdspc.com",
      "mbaker@ssdspc.com",
      "mbivins@ssdspc.com",
      "mdowning@ssdspc.com",
      "mfortner@ssdspc.com",
      "mgonzalez@ssdspc.com",
      "mhornsby@ssdspc.com",
      "mm@ssdspc.com",
      "mstewart@ssdspc.com",
      "nteague@ssdspc.com",
      "powen@ssdspc.com",
      "rhead@ssdspc.com",
      "rkhan@ssdspc.com",
      "romar@ssdspc.com",
      "scripts@ssdspc.com",
      "skhan@ssdspc.com",
      "sriggins@ssdspc.com",
      "ssawyer@ssdspc.com",
      "ssd-automation-service-account@workspace-automation-ssdspc.iam.gserviceaccount.com",
      "sync-sa@ssd-intranet-sync.iam.gserviceaccount.com",
      "tbunton@ssdspc.com",
      "tplatts@ssdspc.com",
      "twood@ssdspc.com",
      "voicemail@ssdspc.com"
    ]
  },
  {
    "name": "Patient Active insurance check for next 2 weeks",
    "description": "Daily Task for Front Desk (FD-15)",
    "url": "https://docs.google.com/spreadsheets/d/11MKo1xLdUGreNniy5QxKFIJ-zk7dhgYkLKW_bqqVV1g/edit?gid=441734537#gid=441734537",
    "team": "Front Desk",
    "assignee": "Front Desk",
    "code": "FD-15",
    "accessEmails": [
      "aadwell@ssdspc.com",
      "admin@ssdspc.com",
      "adminhelp@ssdspc.com",
      "afloyd@ssdspc.com",
      "agamache@ssdspc.com",
      "agolightly@ssdspc.com",
      "agonzalez@ssdspc.com",
      "ajones@ssdspc.com",
      "aparameswaran@ssdspc.com",
      "appsheet@ssdspc.com",
      "automation@ssdspc.com",
      "awalden@ssdspc.com",
      "ayoung@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "bhammonds@ssdspc.com",
      "bherrington@ssdspc.com",
      "bwscan@ssdspc.com",
      "cmartin@ssdspc.com",
      "cthomson@ssdspc.com",
      "dderamus@ssdspc.com",
      "documents@ssdspc.com",
      "dpatel@ssdspc.com",
      "dwalters@ssdspc.com",
      "ehenegar@ssdspc.com",
      "estephens@ssdspc.com",
      "fax@ssdspc.com",
      "games@ssdspc.com",
      "gmcmahan@ssdspc.com",
      "hangouts-chat-45b23cd19217da44@ssdspc.com",
      "hangouts-chat-8cf9bcfb23006f2b@ssdspc.com",
      "hangouts-chat-92d059881c6662fc@ssdspc.com",
      "hangouts-chat-a882a3b4a05f1865@ssdspc.com",
      "hwest@ssdspc.com",
      "jhagan@ssdspc.com",
      "jniblack@ssdspc.com",
      "jpayton@ssdspc.com",
      "jreynolds@ssdspc.com",
      "kcharles@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmcmurray@ssdspc.com",
      "kparker@ssdspc.com",
      "kparton@ssdspc.com",
      "lmarsh@ssdspc.com",
      "lsanford@ssdspc.com",
      "mbaker@ssdspc.com",
      "mbivins@ssdspc.com",
      "mdowning@ssdspc.com",
      "mfortner@ssdspc.com",
      "mgonzalez@ssdspc.com",
      "mhornsby@ssdspc.com",
      "mm@ssdspc.com",
      "mstewart@ssdspc.com",
      "nteague@ssdspc.com",
      "powen@ssdspc.com",
      "rhead@ssdspc.com",
      "rkhan@ssdspc.com",
      "romar@ssdspc.com",
      "scripts@ssdspc.com",
      "skhan@ssdspc.com",
      "sriggins@ssdspc.com",
      "ssawyer@ssdspc.com",
      "ssd-automation-service-account@workspace-automation-ssdspc.iam.gserviceaccount.com",
      "sync-sa@ssd-intranet-sync.iam.gserviceaccount.com",
      "tbunton@ssdspc.com",
      "tplatts@ssdspc.com",
      "twood@ssdspc.com",
      "voicemail@ssdspc.com"
    ]
  },
  {
    "name": "Package Delivery Log - Log all packages",
    "description": "Daily Task for Front Desk (FD-10) - There is a separate tab for each clinic",
    "url": "https://docs.google.com/spreadsheets/d/1Z2fgQLQmxoCxkpOhB56ZumPY4iYKFoRyKmyn6SL2fhw/edit?gid=1061396652#gid=1061396652",
    "team": "Front Desk",
    "assignee": "Front Desk",
    "code": "FD-10",
    "accessEmails": [
      "aadwell@ssdspc.com",
      "admin@ssdspc.com",
      "adminhelp@ssdspc.com",
      "afloyd@ssdspc.com",
      "agamache@ssdspc.com",
      "agolightly@ssdspc.com",
      "agonzalez@ssdspc.com",
      "ajones@ssdspc.com",
      "aparameswaran@ssdspc.com",
      "appsheet@ssdspc.com",
      "automation@ssdspc.com",
      "awalden@ssdspc.com",
      "ayoung@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "bhammonds@ssdspc.com",
      "bherrington@ssdspc.com",
      "bwscan@ssdspc.com",
      "cmartin@ssdspc.com",
      "cthomson@ssdspc.com",
      "dderamus@ssdspc.com",
      "documents@ssdspc.com",
      "dpatel@ssdspc.com",
      "dwalters@ssdspc.com",
      "ehenegar@ssdspc.com",
      "estephens@ssdspc.com",
      "fax@ssdspc.com",
      "games@ssdspc.com",
      "gmcmahan@ssdspc.com",
      "hangouts-chat-45b23cd19217da44@ssdspc.com",
      "hangouts-chat-8cf9bcfb23006f2b@ssdspc.com",
      "hangouts-chat-92d059881c6662fc@ssdspc.com",
      "hangouts-chat-a882a3b4a05f1865@ssdspc.com",
      "hwest@ssdspc.com",
      "jhagan@ssdspc.com",
      "jniblack@ssdspc.com",
      "jpayton@ssdspc.com",
      "jreynolds@ssdspc.com",
      "kcharles@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmcmurray@ssdspc.com",
      "kparker@ssdspc.com",
      "kparton@ssdspc.com",
      "lmarsh@ssdspc.com",
      "lsanford@ssdspc.com",
      "mbaker@ssdspc.com",
      "mbivins@ssdspc.com",
      "mdowning@ssdspc.com",
      "mfortner@ssdspc.com",
      "mgonzalez@ssdspc.com",
      "mhornsby@ssdspc.com",
      "mm@ssdspc.com",
      "mstewart@ssdspc.com",
      "nteague@ssdspc.com",
      "powen@ssdspc.com",
      "rhead@ssdspc.com",
      "rkhan@ssdspc.com",
      "romar@ssdspc.com",
      "scripts@ssdspc.com",
      "skhan@ssdspc.com",
      "sriggins@ssdspc.com",
      "ssawyer@ssdspc.com",
      "ssd-automation-service-account@workspace-automation-ssdspc.iam.gserviceaccount.com",
      "sync-sa@ssd-intranet-sync.iam.gserviceaccount.com",
      "tbunton@ssdspc.com",
      "tplatts@ssdspc.com",
      "twood@ssdspc.com",
      "voicemail@ssdspc.com"
    ]
  },
  {
    "name": "Breakdown Delivery Boxes & place in trash area",
    "description": "Daily Task for Front Desk (FD-11)",
    "url": "https://docs.google.com/spreadsheets/d/11MKo1xLdUGreNniy5QxKFIJ-zk7dhgYkLKW_bqqVV1g/edit?gid=441734537#gid=441734537",
    "team": "Front Desk",
    "assignee": "Front Desk",
    "code": "FD-11",
    "accessEmails": [
      "aadwell@ssdspc.com",
      "admin@ssdspc.com",
      "adminhelp@ssdspc.com",
      "afloyd@ssdspc.com",
      "agamache@ssdspc.com",
      "agolightly@ssdspc.com",
      "agonzalez@ssdspc.com",
      "ajones@ssdspc.com",
      "aparameswaran@ssdspc.com",
      "appsheet@ssdspc.com",
      "automation@ssdspc.com",
      "awalden@ssdspc.com",
      "ayoung@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "bhammonds@ssdspc.com",
      "bherrington@ssdspc.com",
      "bwscan@ssdspc.com",
      "cmartin@ssdspc.com",
      "cthomson@ssdspc.com",
      "dderamus@ssdspc.com",
      "documents@ssdspc.com",
      "dpatel@ssdspc.com",
      "dwalters@ssdspc.com",
      "ehenegar@ssdspc.com",
      "estephens@ssdspc.com",
      "fax@ssdspc.com",
      "games@ssdspc.com",
      "gmcmahan@ssdspc.com",
      "hangouts-chat-45b23cd19217da44@ssdspc.com",
      "hangouts-chat-8cf9bcfb23006f2b@ssdspc.com",
      "hangouts-chat-92d059881c6662fc@ssdspc.com",
      "hangouts-chat-a882a3b4a05f1865@ssdspc.com",
      "hwest@ssdspc.com",
      "jhagan@ssdspc.com",
      "jniblack@ssdspc.com",
      "jpayton@ssdspc.com",
      "jreynolds@ssdspc.com",
      "kcharles@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmcmurray@ssdspc.com",
      "kparker@ssdspc.com",
      "kparton@ssdspc.com",
      "lmarsh@ssdspc.com",
      "lsanford@ssdspc.com",
      "mbaker@ssdspc.com",
      "mbivins@ssdspc.com",
      "mdowning@ssdspc.com",
      "mfortner@ssdspc.com",
      "mgonzalez@ssdspc.com",
      "mhornsby@ssdspc.com",
      "mm@ssdspc.com",
      "mstewart@ssdspc.com",
      "nteague@ssdspc.com",
      "powen@ssdspc.com",
      "rhead@ssdspc.com",
      "rkhan@ssdspc.com",
      "romar@ssdspc.com",
      "scripts@ssdspc.com",
      "skhan@ssdspc.com",
      "sriggins@ssdspc.com",
      "ssawyer@ssdspc.com",
      "ssd-automation-service-account@workspace-automation-ssdspc.iam.gserviceaccount.com",
      "sync-sa@ssd-intranet-sync.iam.gserviceaccount.com",
      "tbunton@ssdspc.com",
      "tplatts@ssdspc.com",
      "twood@ssdspc.com",
      "voicemail@ssdspc.com"
    ]
  },
  {
    "name": "Repeat Caller Log - Reach out to patients that have called multiple times",
    "description": "Daily Task for Front Desk (FD-12)",
    "url": "https://docs.google.com/spreadsheets/d/1Ej8wzt6U6C-x5Ex9bv0ZRBZs5RFff0Xpi3Zak4r8u4E/edit?gid=693737332#gid=693737332",
    "team": "Front Desk",
    "assignee": "Front Desk",
    "code": "FD-12",
    "accessEmails": [
      "aadwell@ssdspc.com",
      "admin@ssdspc.com",
      "adminhelp@ssdspc.com",
      "afloyd@ssdspc.com",
      "agamache@ssdspc.com",
      "agolightly@ssdspc.com",
      "agonzalez@ssdspc.com",
      "ajones@ssdspc.com",
      "aparameswaran@ssdspc.com",
      "appsheet@ssdspc.com",
      "automation@ssdspc.com",
      "awalden@ssdspc.com",
      "ayoung@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "bhammonds@ssdspc.com",
      "bherrington@ssdspc.com",
      "bwscan@ssdspc.com",
      "cmartin@ssdspc.com",
      "cthomson@ssdspc.com",
      "dderamus@ssdspc.com",
      "documents@ssdspc.com",
      "dpatel@ssdspc.com",
      "dwalters@ssdspc.com",
      "ehenegar@ssdspc.com",
      "estephens@ssdspc.com",
      "fax@ssdspc.com",
      "games@ssdspc.com",
      "gmcmahan@ssdspc.com",
      "hangouts-chat-45b23cd19217da44@ssdspc.com",
      "hangouts-chat-8cf9bcfb23006f2b@ssdspc.com",
      "hangouts-chat-92d059881c6662fc@ssdspc.com",
      "hangouts-chat-a882a3b4a05f1865@ssdspc.com",
      "hwest@ssdspc.com",
      "jhagan@ssdspc.com",
      "jniblack@ssdspc.com",
      "jpayton@ssdspc.com",
      "jreynolds@ssdspc.com",
      "kcharles@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmcmurray@ssdspc.com",
      "kparker@ssdspc.com",
      "kparton@ssdspc.com",
      "lmarsh@ssdspc.com",
      "lsanford@ssdspc.com",
      "mbaker@ssdspc.com",
      "mbivins@ssdspc.com",
      "mdowning@ssdspc.com",
      "mfortner@ssdspc.com",
      "mgonzalez@ssdspc.com",
      "mhornsby@ssdspc.com",
      "mm@ssdspc.com",
      "mstewart@ssdspc.com",
      "nteague@ssdspc.com",
      "powen@ssdspc.com",
      "rhead@ssdspc.com",
      "rkhan@ssdspc.com",
      "romar@ssdspc.com",
      "scripts@ssdspc.com",
      "skhan@ssdspc.com",
      "sriggins@ssdspc.com",
      "ssawyer@ssdspc.com",
      "ssd-automation-service-account@workspace-automation-ssdspc.iam.gserviceaccount.com",
      "sync-sa@ssd-intranet-sync.iam.gserviceaccount.com",
      "tbunton@ssdspc.com",
      "tplatts@ssdspc.com",
      "twood@ssdspc.com",
      "voicemail@ssdspc.com"
    ]
  },
  {
    "name": "Voicemail Log - Address all voicemails",
    "description": "Daily Task for Front Desk (FD-13) - Mark this task as complete until 3:30 PM when everything should have been reviewed",
    "url": "https://docs.google.com/spreadsheets/d/1Ej8wzt6U6C-x5Ex9bv0ZRBZs5RFff0Xpi3Zak4r8u4E/edit?gid=611001893#gid=611001893",
    "team": "Front Desk",
    "assignee": "Front Desk",
    "code": "FD-13",
    "accessEmails": [
      "aadwell@ssdspc.com",
      "admin@ssdspc.com",
      "adminhelp@ssdspc.com",
      "afloyd@ssdspc.com",
      "agamache@ssdspc.com",
      "agolightly@ssdspc.com",
      "agonzalez@ssdspc.com",
      "ajones@ssdspc.com",
      "aparameswaran@ssdspc.com",
      "appsheet@ssdspc.com",
      "automation@ssdspc.com",
      "awalden@ssdspc.com",
      "ayoung@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "bhammonds@ssdspc.com",
      "bherrington@ssdspc.com",
      "bwscan@ssdspc.com",
      "cmartin@ssdspc.com",
      "cthomson@ssdspc.com",
      "dderamus@ssdspc.com",
      "documents@ssdspc.com",
      "dpatel@ssdspc.com",
      "dwalters@ssdspc.com",
      "ehenegar@ssdspc.com",
      "estephens@ssdspc.com",
      "fax@ssdspc.com",
      "games@ssdspc.com",
      "gmcmahan@ssdspc.com",
      "hangouts-chat-45b23cd19217da44@ssdspc.com",
      "hangouts-chat-8cf9bcfb23006f2b@ssdspc.com",
      "hangouts-chat-92d059881c6662fc@ssdspc.com",
      "hangouts-chat-a882a3b4a05f1865@ssdspc.com",
      "hwest@ssdspc.com",
      "jhagan@ssdspc.com",
      "jniblack@ssdspc.com",
      "jpayton@ssdspc.com",
      "jreynolds@ssdspc.com",
      "kcharles@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmcmurray@ssdspc.com",
      "kparker@ssdspc.com",
      "kparton@ssdspc.com",
      "lmarsh@ssdspc.com",
      "lsanford@ssdspc.com",
      "mbaker@ssdspc.com",
      "mbivins@ssdspc.com",
      "mdowning@ssdspc.com",
      "mfortner@ssdspc.com",
      "mgonzalez@ssdspc.com",
      "mhornsby@ssdspc.com",
      "mm@ssdspc.com",
      "mstewart@ssdspc.com",
      "nteague@ssdspc.com",
      "powen@ssdspc.com",
      "rhead@ssdspc.com",
      "rkhan@ssdspc.com",
      "romar@ssdspc.com",
      "scripts@ssdspc.com",
      "skhan@ssdspc.com",
      "sriggins@ssdspc.com",
      "ssawyer@ssdspc.com",
      "ssd-automation-service-account@workspace-automation-ssdspc.iam.gserviceaccount.com",
      "sync-sa@ssd-intranet-sync.iam.gserviceaccount.com",
      "tbunton@ssdspc.com",
      "tplatts@ssdspc.com",
      "twood@ssdspc.com",
      "voicemail@ssdspc.com"
    ]
  },
  {
    "name": "Stock beverages everyday",
    "description": "Daily Task for Front Desk (FD-17)",
    "url": "https://docs.google.com/spreadsheets/d/11MKo1xLdUGreNniy5QxKFIJ-zk7dhgYkLKW_bqqVV1g/edit?gid=441734537#gid=441734537",
    "team": "Front Desk",
    "assignee": "Front Desk",
    "code": "FD-17",
    "accessEmails": [
      "aadwell@ssdspc.com",
      "admin@ssdspc.com",
      "adminhelp@ssdspc.com",
      "afloyd@ssdspc.com",
      "agamache@ssdspc.com",
      "agolightly@ssdspc.com",
      "agonzalez@ssdspc.com",
      "ajones@ssdspc.com",
      "aparameswaran@ssdspc.com",
      "appsheet@ssdspc.com",
      "automation@ssdspc.com",
      "awalden@ssdspc.com",
      "ayoung@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "bhammonds@ssdspc.com",
      "bherrington@ssdspc.com",
      "bwscan@ssdspc.com",
      "cmartin@ssdspc.com",
      "cthomson@ssdspc.com",
      "dderamus@ssdspc.com",
      "documents@ssdspc.com",
      "dpatel@ssdspc.com",
      "dwalters@ssdspc.com",
      "ehenegar@ssdspc.com",
      "estephens@ssdspc.com",
      "fax@ssdspc.com",
      "games@ssdspc.com",
      "gmcmahan@ssdspc.com",
      "hangouts-chat-45b23cd19217da44@ssdspc.com",
      "hangouts-chat-8cf9bcfb23006f2b@ssdspc.com",
      "hangouts-chat-92d059881c6662fc@ssdspc.com",
      "hangouts-chat-a882a3b4a05f1865@ssdspc.com",
      "hwest@ssdspc.com",
      "jhagan@ssdspc.com",
      "jniblack@ssdspc.com",
      "jpayton@ssdspc.com",
      "jreynolds@ssdspc.com",
      "kcharles@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmcmurray@ssdspc.com",
      "kparker@ssdspc.com",
      "kparton@ssdspc.com",
      "lmarsh@ssdspc.com",
      "lsanford@ssdspc.com",
      "mbaker@ssdspc.com",
      "mbivins@ssdspc.com",
      "mdowning@ssdspc.com",
      "mfortner@ssdspc.com",
      "mgonzalez@ssdspc.com",
      "mhornsby@ssdspc.com",
      "mm@ssdspc.com",
      "mstewart@ssdspc.com",
      "nteague@ssdspc.com",
      "powen@ssdspc.com",
      "rhead@ssdspc.com",
      "rkhan@ssdspc.com",
      "romar@ssdspc.com",
      "scripts@ssdspc.com",
      "skhan@ssdspc.com",
      "sriggins@ssdspc.com",
      "ssawyer@ssdspc.com",
      "ssd-automation-service-account@workspace-automation-ssdspc.iam.gserviceaccount.com",
      "sync-sa@ssd-intranet-sync.iam.gserviceaccount.com",
      "tbunton@ssdspc.com",
      "tplatts@ssdspc.com",
      "twood@ssdspc.com",
      "voicemail@ssdspc.com"
    ]
  },
  {
    "name": "End of Day - Fill in the biopsy counts to the daily biopsy file.",
    "description": "Daily Task for Front Desk (FD-18)",
    "url": "https://docs.google.com/spreadsheets/d/1N6mIHNoV1rjyzZI1LZDTpV-oKRJy4thQw70xfSJiHWc/edit?gid=47037837#gid=47037837",
    "team": "Front Desk",
    "assignee": "Front Desk",
    "code": "FD-18",
    "accessEmails": [
      "aadwell@ssdspc.com",
      "admin@ssdspc.com",
      "adminhelp@ssdspc.com",
      "afloyd@ssdspc.com",
      "agamache@ssdspc.com",
      "agolightly@ssdspc.com",
      "agonzalez@ssdspc.com",
      "ajones@ssdspc.com",
      "aparameswaran@ssdspc.com",
      "appsheet@ssdspc.com",
      "automation@ssdspc.com",
      "awalden@ssdspc.com",
      "ayoung@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "bhammonds@ssdspc.com",
      "bherrington@ssdspc.com",
      "bwscan@ssdspc.com",
      "cmartin@ssdspc.com",
      "cthomson@ssdspc.com",
      "dderamus@ssdspc.com",
      "documents@ssdspc.com",
      "dpatel@ssdspc.com",
      "dwalters@ssdspc.com",
      "ehenegar@ssdspc.com",
      "estephens@ssdspc.com",
      "fax@ssdspc.com",
      "games@ssdspc.com",
      "gmcmahan@ssdspc.com",
      "hangouts-chat-45b23cd19217da44@ssdspc.com",
      "hangouts-chat-8cf9bcfb23006f2b@ssdspc.com",
      "hangouts-chat-92d059881c6662fc@ssdspc.com",
      "hangouts-chat-a882a3b4a05f1865@ssdspc.com",
      "hwest@ssdspc.com",
      "jhagan@ssdspc.com",
      "jniblack@ssdspc.com",
      "jpayton@ssdspc.com",
      "jreynolds@ssdspc.com",
      "kcharles@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmcmurray@ssdspc.com",
      "kparker@ssdspc.com",
      "kparton@ssdspc.com",
      "lmarsh@ssdspc.com",
      "lsanford@ssdspc.com",
      "mbaker@ssdspc.com",
      "mbivins@ssdspc.com",
      "mdowning@ssdspc.com",
      "mfortner@ssdspc.com",
      "mgonzalez@ssdspc.com",
      "mhornsby@ssdspc.com",
      "mm@ssdspc.com",
      "mstewart@ssdspc.com",
      "nteague@ssdspc.com",
      "powen@ssdspc.com",
      "rhead@ssdspc.com",
      "rkhan@ssdspc.com",
      "romar@ssdspc.com",
      "scripts@ssdspc.com",
      "skhan@ssdspc.com",
      "sriggins@ssdspc.com",
      "ssawyer@ssdspc.com",
      "ssd-automation-service-account@workspace-automation-ssdspc.iam.gserviceaccount.com",
      "sync-sa@ssd-intranet-sync.iam.gserviceaccount.com",
      "tbunton@ssdspc.com",
      "tplatts@ssdspc.com",
      "twood@ssdspc.com",
      "voicemail@ssdspc.com"
    ]
  },
  {
    "name": "End of day - Breakroom cleaning checklist",
    "description": "Daily Task for Front Desk (FD-5)",
    "url": "https://docs.google.com/spreadsheets/d/11MKo1xLdUGreNniy5QxKFIJ-zk7dhgYkLKW_bqqVV1g/edit?gid=441734537#gid=441734537",
    "team": "Front Desk",
    "assignee": "Front Desk",
    "code": "FD-5",
    "accessEmails": [
      "aadwell@ssdspc.com",
      "admin@ssdspc.com",
      "adminhelp@ssdspc.com",
      "afloyd@ssdspc.com",
      "agamache@ssdspc.com",
      "agolightly@ssdspc.com",
      "agonzalez@ssdspc.com",
      "ajones@ssdspc.com",
      "aparameswaran@ssdspc.com",
      "appsheet@ssdspc.com",
      "automation@ssdspc.com",
      "awalden@ssdspc.com",
      "ayoung@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "bhammonds@ssdspc.com",
      "bherrington@ssdspc.com",
      "bwscan@ssdspc.com",
      "cmartin@ssdspc.com",
      "cthomson@ssdspc.com",
      "dderamus@ssdspc.com",
      "documents@ssdspc.com",
      "dpatel@ssdspc.com",
      "dwalters@ssdspc.com",
      "ehenegar@ssdspc.com",
      "estephens@ssdspc.com",
      "fax@ssdspc.com",
      "games@ssdspc.com",
      "gmcmahan@ssdspc.com",
      "hangouts-chat-45b23cd19217da44@ssdspc.com",
      "hangouts-chat-8cf9bcfb23006f2b@ssdspc.com",
      "hangouts-chat-92d059881c6662fc@ssdspc.com",
      "hangouts-chat-a882a3b4a05f1865@ssdspc.com",
      "hwest@ssdspc.com",
      "jhagan@ssdspc.com",
      "jniblack@ssdspc.com",
      "jpayton@ssdspc.com",
      "jreynolds@ssdspc.com",
      "kcharles@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmcmurray@ssdspc.com",
      "kparker@ssdspc.com",
      "kparton@ssdspc.com",
      "lmarsh@ssdspc.com",
      "lsanford@ssdspc.com",
      "mbaker@ssdspc.com",
      "mbivins@ssdspc.com",
      "mdowning@ssdspc.com",
      "mfortner@ssdspc.com",
      "mgonzalez@ssdspc.com",
      "mhornsby@ssdspc.com",
      "mm@ssdspc.com",
      "mstewart@ssdspc.com",
      "nteague@ssdspc.com",
      "powen@ssdspc.com",
      "rhead@ssdspc.com",
      "rkhan@ssdspc.com",
      "romar@ssdspc.com",
      "scripts@ssdspc.com",
      "skhan@ssdspc.com",
      "sriggins@ssdspc.com",
      "ssawyer@ssdspc.com",
      "ssd-automation-service-account@workspace-automation-ssdspc.iam.gserviceaccount.com",
      "sync-sa@ssd-intranet-sync.iam.gserviceaccount.com",
      "tbunton@ssdspc.com",
      "tplatts@ssdspc.com",
      "twood@ssdspc.com",
      "voicemail@ssdspc.com"
    ]
  },
  {
    "name": "End of day front desk checklist",
    "description": "Daily Task for Front Desk (FD-9)",
    "url": "https://docs.google.com/spreadsheets/d/11MKo1xLdUGreNniy5QxKFIJ-zk7dhgYkLKW_bqqVV1g/edit?gid=441734537#gid=441734537",
    "team": "Front Desk",
    "assignee": "Front Desk",
    "code": "FD-9",
    "accessEmails": [
      "aadwell@ssdspc.com",
      "admin@ssdspc.com",
      "adminhelp@ssdspc.com",
      "afloyd@ssdspc.com",
      "agamache@ssdspc.com",
      "agolightly@ssdspc.com",
      "agonzalez@ssdspc.com",
      "ajones@ssdspc.com",
      "aparameswaran@ssdspc.com",
      "appsheet@ssdspc.com",
      "automation@ssdspc.com",
      "awalden@ssdspc.com",
      "ayoung@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "bhammonds@ssdspc.com",
      "bherrington@ssdspc.com",
      "bwscan@ssdspc.com",
      "cmartin@ssdspc.com",
      "cthomson@ssdspc.com",
      "dderamus@ssdspc.com",
      "documents@ssdspc.com",
      "dpatel@ssdspc.com",
      "dwalters@ssdspc.com",
      "ehenegar@ssdspc.com",
      "estephens@ssdspc.com",
      "fax@ssdspc.com",
      "games@ssdspc.com",
      "gmcmahan@ssdspc.com",
      "hangouts-chat-45b23cd19217da44@ssdspc.com",
      "hangouts-chat-8cf9bcfb23006f2b@ssdspc.com",
      "hangouts-chat-92d059881c6662fc@ssdspc.com",
      "hangouts-chat-a882a3b4a05f1865@ssdspc.com",
      "hwest@ssdspc.com",
      "jhagan@ssdspc.com",
      "jniblack@ssdspc.com",
      "jpayton@ssdspc.com",
      "jreynolds@ssdspc.com",
      "kcharles@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmcmurray@ssdspc.com",
      "kparker@ssdspc.com",
      "kparton@ssdspc.com",
      "lmarsh@ssdspc.com",
      "lsanford@ssdspc.com",
      "mbaker@ssdspc.com",
      "mbivins@ssdspc.com",
      "mdowning@ssdspc.com",
      "mfortner@ssdspc.com",
      "mgonzalez@ssdspc.com",
      "mhornsby@ssdspc.com",
      "mm@ssdspc.com",
      "mstewart@ssdspc.com",
      "nteague@ssdspc.com",
      "powen@ssdspc.com",
      "rhead@ssdspc.com",
      "rkhan@ssdspc.com",
      "romar@ssdspc.com",
      "scripts@ssdspc.com",
      "skhan@ssdspc.com",
      "sriggins@ssdspc.com",
      "ssawyer@ssdspc.com",
      "ssd-automation-service-account@workspace-automation-ssdspc.iam.gserviceaccount.com",
      "sync-sa@ssd-intranet-sync.iam.gserviceaccount.com",
      "tbunton@ssdspc.com",
      "tplatts@ssdspc.com",
      "twood@ssdspc.com",
      "voicemail@ssdspc.com"
    ]
  },
  {
    "name": "End of Day - Clean, restock, shut down Waiting Room",
    "description": "Daily Task for Front Desk (FD-8)",
    "url": "https://docs.google.com/spreadsheets/d/11MKo1xLdUGreNniy5QxKFIJ-zk7dhgYkLKW_bqqVV1g/edit?gid=441734537#gid=441734537",
    "team": "Front Desk",
    "assignee": "Front Desk",
    "code": "FD-8",
    "accessEmails": [
      "aadwell@ssdspc.com",
      "admin@ssdspc.com",
      "adminhelp@ssdspc.com",
      "afloyd@ssdspc.com",
      "agamache@ssdspc.com",
      "agolightly@ssdspc.com",
      "agonzalez@ssdspc.com",
      "ajones@ssdspc.com",
      "aparameswaran@ssdspc.com",
      "appsheet@ssdspc.com",
      "automation@ssdspc.com",
      "awalden@ssdspc.com",
      "ayoung@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "bhammonds@ssdspc.com",
      "bherrington@ssdspc.com",
      "bwscan@ssdspc.com",
      "cmartin@ssdspc.com",
      "cthomson@ssdspc.com",
      "dderamus@ssdspc.com",
      "documents@ssdspc.com",
      "dpatel@ssdspc.com",
      "dwalters@ssdspc.com",
      "ehenegar@ssdspc.com",
      "estephens@ssdspc.com",
      "fax@ssdspc.com",
      "games@ssdspc.com",
      "gmcmahan@ssdspc.com",
      "hangouts-chat-45b23cd19217da44@ssdspc.com",
      "hangouts-chat-8cf9bcfb23006f2b@ssdspc.com",
      "hangouts-chat-92d059881c6662fc@ssdspc.com",
      "hangouts-chat-a882a3b4a05f1865@ssdspc.com",
      "hwest@ssdspc.com",
      "jhagan@ssdspc.com",
      "jniblack@ssdspc.com",
      "jpayton@ssdspc.com",
      "jreynolds@ssdspc.com",
      "kcharles@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmcmurray@ssdspc.com",
      "kparker@ssdspc.com",
      "kparton@ssdspc.com",
      "lmarsh@ssdspc.com",
      "lsanford@ssdspc.com",
      "mbaker@ssdspc.com",
      "mbivins@ssdspc.com",
      "mdowning@ssdspc.com",
      "mfortner@ssdspc.com",
      "mgonzalez@ssdspc.com",
      "mhornsby@ssdspc.com",
      "mm@ssdspc.com",
      "mstewart@ssdspc.com",
      "nteague@ssdspc.com",
      "powen@ssdspc.com",
      "rhead@ssdspc.com",
      "rkhan@ssdspc.com",
      "romar@ssdspc.com",
      "scripts@ssdspc.com",
      "skhan@ssdspc.com",
      "sriggins@ssdspc.com",
      "ssawyer@ssdspc.com",
      "ssd-automation-service-account@workspace-automation-ssdspc.iam.gserviceaccount.com",
      "sync-sa@ssd-intranet-sync.iam.gserviceaccount.com",
      "tbunton@ssdspc.com",
      "tplatts@ssdspc.com",
      "twood@ssdspc.com",
      "voicemail@ssdspc.com"
    ]
  },
  {
    "name": "End of Day - Front Desk Area Cleaning",
    "description": "Daily Task for Front Desk (FD-6)",
    "url": "https://docs.google.com/spreadsheets/d/11MKo1xLdUGreNniy5QxKFIJ-zk7dhgYkLKW_bqqVV1g/edit?gid=441734537#gid=441734537",
    "team": "Front Desk",
    "assignee": "Front Desk",
    "code": "FD-6",
    "accessEmails": [
      "aadwell@ssdspc.com",
      "admin@ssdspc.com",
      "adminhelp@ssdspc.com",
      "afloyd@ssdspc.com",
      "agamache@ssdspc.com",
      "agolightly@ssdspc.com",
      "agonzalez@ssdspc.com",
      "ajones@ssdspc.com",
      "aparameswaran@ssdspc.com",
      "appsheet@ssdspc.com",
      "automation@ssdspc.com",
      "awalden@ssdspc.com",
      "ayoung@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "bhammonds@ssdspc.com",
      "bherrington@ssdspc.com",
      "bwscan@ssdspc.com",
      "cmartin@ssdspc.com",
      "cthomson@ssdspc.com",
      "dderamus@ssdspc.com",
      "documents@ssdspc.com",
      "dpatel@ssdspc.com",
      "dwalters@ssdspc.com",
      "ehenegar@ssdspc.com",
      "estephens@ssdspc.com",
      "fax@ssdspc.com",
      "games@ssdspc.com",
      "gmcmahan@ssdspc.com",
      "hangouts-chat-45b23cd19217da44@ssdspc.com",
      "hangouts-chat-8cf9bcfb23006f2b@ssdspc.com",
      "hangouts-chat-92d059881c6662fc@ssdspc.com",
      "hangouts-chat-a882a3b4a05f1865@ssdspc.com",
      "hwest@ssdspc.com",
      "jhagan@ssdspc.com",
      "jniblack@ssdspc.com",
      "jpayton@ssdspc.com",
      "jreynolds@ssdspc.com",
      "kcharles@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmcmurray@ssdspc.com",
      "kparker@ssdspc.com",
      "kparton@ssdspc.com",
      "lmarsh@ssdspc.com",
      "lsanford@ssdspc.com",
      "mbaker@ssdspc.com",
      "mbivins@ssdspc.com",
      "mdowning@ssdspc.com",
      "mfortner@ssdspc.com",
      "mgonzalez@ssdspc.com",
      "mhornsby@ssdspc.com",
      "mm@ssdspc.com",
      "mstewart@ssdspc.com",
      "nteague@ssdspc.com",
      "powen@ssdspc.com",
      "rhead@ssdspc.com",
      "rkhan@ssdspc.com",
      "romar@ssdspc.com",
      "scripts@ssdspc.com",
      "skhan@ssdspc.com",
      "sriggins@ssdspc.com",
      "ssawyer@ssdspc.com",
      "ssd-automation-service-account@workspace-automation-ssdspc.iam.gserviceaccount.com",
      "sync-sa@ssd-intranet-sync.iam.gserviceaccount.com",
      "tbunton@ssdspc.com",
      "tplatts@ssdspc.com",
      "twood@ssdspc.com",
      "voicemail@ssdspc.com"
    ]
  },
  {
    "name": "Send pictures or video of the areas cleaned at the end of the day to the Admin Help line",
    "description": "Daily Task for Front Desk (FD-16)",
    "url": "https://docs.google.com/spreadsheets/d/11MKo1xLdUGreNniy5QxKFIJ-zk7dhgYkLKW_bqqVV1g/edit?gid=441734537#gid=441734537",
    "team": "Front Desk",
    "assignee": "Front Desk",
    "code": "FD-16",
    "accessEmails": [
      "aadwell@ssdspc.com",
      "admin@ssdspc.com",
      "adminhelp@ssdspc.com",
      "afloyd@ssdspc.com",
      "agamache@ssdspc.com",
      "agolightly@ssdspc.com",
      "agonzalez@ssdspc.com",
      "ajones@ssdspc.com",
      "aparameswaran@ssdspc.com",
      "appsheet@ssdspc.com",
      "automation@ssdspc.com",
      "awalden@ssdspc.com",
      "ayoung@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "bhammonds@ssdspc.com",
      "bherrington@ssdspc.com",
      "bwscan@ssdspc.com",
      "cmartin@ssdspc.com",
      "cthomson@ssdspc.com",
      "dderamus@ssdspc.com",
      "documents@ssdspc.com",
      "dpatel@ssdspc.com",
      "dwalters@ssdspc.com",
      "ehenegar@ssdspc.com",
      "estephens@ssdspc.com",
      "fax@ssdspc.com",
      "games@ssdspc.com",
      "gmcmahan@ssdspc.com",
      "hangouts-chat-45b23cd19217da44@ssdspc.com",
      "hangouts-chat-8cf9bcfb23006f2b@ssdspc.com",
      "hangouts-chat-92d059881c6662fc@ssdspc.com",
      "hangouts-chat-a882a3b4a05f1865@ssdspc.com",
      "hwest@ssdspc.com",
      "jhagan@ssdspc.com",
      "jniblack@ssdspc.com",
      "jpayton@ssdspc.com",
      "jreynolds@ssdspc.com",
      "kcharles@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmcmurray@ssdspc.com",
      "kparker@ssdspc.com",
      "kparton@ssdspc.com",
      "lmarsh@ssdspc.com",
      "lsanford@ssdspc.com",
      "mbaker@ssdspc.com",
      "mbivins@ssdspc.com",
      "mdowning@ssdspc.com",
      "mfortner@ssdspc.com",
      "mgonzalez@ssdspc.com",
      "mhornsby@ssdspc.com",
      "mm@ssdspc.com",
      "mstewart@ssdspc.com",
      "nteague@ssdspc.com",
      "powen@ssdspc.com",
      "rhead@ssdspc.com",
      "rkhan@ssdspc.com",
      "romar@ssdspc.com",
      "scripts@ssdspc.com",
      "skhan@ssdspc.com",
      "sriggins@ssdspc.com",
      "ssawyer@ssdspc.com",
      "ssd-automation-service-account@workspace-automation-ssdspc.iam.gserviceaccount.com",
      "sync-sa@ssd-intranet-sync.iam.gserviceaccount.com",
      "tbunton@ssdspc.com",
      "tplatts@ssdspc.com",
      "twood@ssdspc.com",
      "voicemail@ssdspc.com"
    ]
  },
  {
    "name": "Add the Provider's Open Spots count in the sheet at the end of the day",
    "description": "Daily Task for Front Desk (FD-20)",
    "url": "https://docs.google.com/spreadsheets/d/11MKo1xLdUGreNniy5QxKFIJ-zk7dhgYkLKW_bqqVV1g/edit?gid=1354709876#gid=1354709876",
    "team": "Front Desk",
    "assignee": "Front Desk",
    "code": "FD-20",
    "accessEmails": [
      "aadwell@ssdspc.com",
      "admin@ssdspc.com",
      "adminhelp@ssdspc.com",
      "afloyd@ssdspc.com",
      "agamache@ssdspc.com",
      "agolightly@ssdspc.com",
      "agonzalez@ssdspc.com",
      "ajones@ssdspc.com",
      "aparameswaran@ssdspc.com",
      "appsheet@ssdspc.com",
      "automation@ssdspc.com",
      "awalden@ssdspc.com",
      "ayoung@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "bhammonds@ssdspc.com",
      "bherrington@ssdspc.com",
      "bwscan@ssdspc.com",
      "cmartin@ssdspc.com",
      "cthomson@ssdspc.com",
      "dderamus@ssdspc.com",
      "documents@ssdspc.com",
      "dpatel@ssdspc.com",
      "dwalters@ssdspc.com",
      "ehenegar@ssdspc.com",
      "estephens@ssdspc.com",
      "fax@ssdspc.com",
      "games@ssdspc.com",
      "gmcmahan@ssdspc.com",
      "hangouts-chat-45b23cd19217da44@ssdspc.com",
      "hangouts-chat-8cf9bcfb23006f2b@ssdspc.com",
      "hangouts-chat-92d059881c6662fc@ssdspc.com",
      "hangouts-chat-a882a3b4a05f1865@ssdspc.com",
      "hwest@ssdspc.com",
      "jhagan@ssdspc.com",
      "jniblack@ssdspc.com",
      "jpayton@ssdspc.com",
      "jreynolds@ssdspc.com",
      "kcharles@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmcmurray@ssdspc.com",
      "kparker@ssdspc.com",
      "kparton@ssdspc.com",
      "lmarsh@ssdspc.com",
      "lsanford@ssdspc.com",
      "mbaker@ssdspc.com",
      "mbivins@ssdspc.com",
      "mdowning@ssdspc.com",
      "mfortner@ssdspc.com",
      "mgonzalez@ssdspc.com",
      "mhornsby@ssdspc.com",
      "mm@ssdspc.com",
      "mstewart@ssdspc.com",
      "nteague@ssdspc.com",
      "powen@ssdspc.com",
      "rhead@ssdspc.com",
      "rkhan@ssdspc.com",
      "romar@ssdspc.com",
      "scripts@ssdspc.com",
      "skhan@ssdspc.com",
      "sriggins@ssdspc.com",
      "ssawyer@ssdspc.com",
      "ssd-automation-service-account@workspace-automation-ssdspc.iam.gserviceaccount.com",
      "sync-sa@ssd-intranet-sync.iam.gserviceaccount.com",
      "tbunton@ssdspc.com",
      "tplatts@ssdspc.com",
      "twood@ssdspc.com",
      "voicemail@ssdspc.com"
    ]
  },
  {
    "name": "Staff Schedules - Update Schedule Synopsis",
    "description": "Daily Task for Taegan Bunton (SA-28)",
    "url": "https://docs.google.com/spreadsheets/d/1Ap-p3S3mTh0Jf4NNqkaLXUIvIrfPpjuEoHxIbyAasx0/edit?gid=551656944#gid=551656944",
    "team": "Admin Team, SuperAdmin",
    "assignee": "Taegan Bunton",
    "code": "SA-28",
    "accessEmails": [
      "admin@ssdspc.com",
      "adminhelp@ssdspc.com",
      "agolightly@ssdspc.com",
      "agonzalez@ssdspc.com",
      "arodriguez@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "bwscan@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "documents@ssdspc.com",
      "hangouts-chat-45b23cd19217da44@ssdspc.com",
      "hangouts-chat-a882a3b4a05f1865@ssdspc.com",
      "input-outpu-log@pure-silicon-377718.iam.gserviceaccount.com",
      "jsaluja@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmatthews@ssdspc.com",
      "lsanford@ssdspc.com",
      "mm@ssdspc.com",
      "rkhan@ssdspc.com",
      "scripts@ssdspc.com",
      "skhan@ssdspc.com",
      "ssd-automation-service-account@workspace-automation-ssdspc.iam.gserviceaccount.com",
      "sync-sa@ssd-intranet-sync.iam.gserviceaccount.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Staff Schedules - Unplanned Absence Tab - Log unplanned absences or tardies",
    "description": "Daily Task for Taegan Bunton (SA-29)",
    "url": "https://docs.google.com/spreadsheets/d/1Ap-p3S3mTh0Jf4NNqkaLXUIvIrfPpjuEoHxIbyAasx0/edit?gid=1899669990#gid=1899669990",
    "team": "Admin Team, SuperAdmin",
    "assignee": "Taegan Bunton",
    "code": "SA-29",
    "accessEmails": [
      "admin@ssdspc.com",
      "adminhelp@ssdspc.com",
      "agolightly@ssdspc.com",
      "agonzalez@ssdspc.com",
      "arodriguez@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "bwscan@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "documents@ssdspc.com",
      "hangouts-chat-45b23cd19217da44@ssdspc.com",
      "hangouts-chat-a882a3b4a05f1865@ssdspc.com",
      "input-outpu-log@pure-silicon-377718.iam.gserviceaccount.com",
      "jsaluja@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmatthews@ssdspc.com",
      "lsanford@ssdspc.com",
      "mm@ssdspc.com",
      "rkhan@ssdspc.com",
      "scripts@ssdspc.com",
      "skhan@ssdspc.com",
      "ssd-automation-service-account@workspace-automation-ssdspc.iam.gserviceaccount.com",
      "sync-sa@ssd-intranet-sync.iam.gserviceaccount.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Staff Schedules - Update the schedules to reflect most recent changes",
    "description": "Daily Task for Taegan Bunton (SA-30)",
    "url": "https://docs.google.com/spreadsheets/d/1Ap-p3S3mTh0Jf4NNqkaLXUIvIrfPpjuEoHxIbyAasx0/edit?gid=1257380749#gid=1257380749",
    "team": "Admin Team, SuperAdmin",
    "assignee": "Taegan Bunton",
    "code": "SA-30",
    "accessEmails": [
      "admin@ssdspc.com",
      "adminhelp@ssdspc.com",
      "agolightly@ssdspc.com",
      "agonzalez@ssdspc.com",
      "arodriguez@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "bwscan@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "documents@ssdspc.com",
      "hangouts-chat-45b23cd19217da44@ssdspc.com",
      "hangouts-chat-a882a3b4a05f1865@ssdspc.com",
      "input-outpu-log@pure-silicon-377718.iam.gserviceaccount.com",
      "jsaluja@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmatthews@ssdspc.com",
      "lsanford@ssdspc.com",
      "mm@ssdspc.com",
      "rkhan@ssdspc.com",
      "scripts@ssdspc.com",
      "skhan@ssdspc.com",
      "ssd-automation-service-account@workspace-automation-ssdspc.iam.gserviceaccount.com",
      "sync-sa@ssd-intranet-sync.iam.gserviceaccount.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Staff Schedules - Public Sync Tab - Make sure Public Staff Schedule is up to date",
    "description": "Daily Task for Taegan Bunton (SA-31)",
    "url": "https://docs.google.com/spreadsheets/d/1Ap-p3S3mTh0Jf4NNqkaLXUIvIrfPpjuEoHxIbyAasx0/edit?gid=932476357#gid=932476357",
    "team": "Admin Team, SuperAdmin",
    "assignee": "Taegan Bunton",
    "code": "SA-31",
    "accessEmails": [
      "admin@ssdspc.com",
      "adminhelp@ssdspc.com",
      "agolightly@ssdspc.com",
      "agonzalez@ssdspc.com",
      "arodriguez@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "bwscan@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "documents@ssdspc.com",
      "hangouts-chat-45b23cd19217da44@ssdspc.com",
      "hangouts-chat-a882a3b4a05f1865@ssdspc.com",
      "input-outpu-log@pure-silicon-377718.iam.gserviceaccount.com",
      "jsaluja@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmatthews@ssdspc.com",
      "lsanford@ssdspc.com",
      "mm@ssdspc.com",
      "rkhan@ssdspc.com",
      "scripts@ssdspc.com",
      "skhan@ssdspc.com",
      "ssd-automation-service-account@workspace-automation-ssdspc.iam.gserviceaccount.com",
      "sync-sa@ssd-intranet-sync.iam.gserviceaccount.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Staff Requests Log - Respond to all requests & close them on the log",
    "description": "Daily Task for Taegan Bunton (SA-32)",
    "url": "https://docs.google.com/spreadsheets/d/1U5PP-XixpSB-LrAP14r4py3onXvq4rgEiq5Hywxkg70/edit?gid=0#gid=0",
    "team": "Admin Team, SuperAdmin",
    "assignee": "Taegan Bunton",
    "code": "SA-32",
    "accessEmails": [
      "admin@ssdspc.com",
      "adminhelp@ssdspc.com",
      "agolightly@ssdspc.com",
      "agonzalez@ssdspc.com",
      "arodriguez@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "bwscan@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "documents@ssdspc.com",
      "hangouts-chat-a882a3b4a05f1865@ssdspc.com",
      "jsaluja@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmatthews@ssdspc.com",
      "lsanford@ssdspc.com",
      "mm@ssdspc.com",
      "rkhan@ssdspc.com",
      "scripts@ssdspc.com",
      "skhan@ssdspc.com",
      "ssd-automation-service-account@workspace-automation-ssdspc.iam.gserviceaccount.com",
      "sync-sa@ssd-intranet-sync.iam.gserviceaccount.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Send start of day group text to Dr. M and Alvaro by 9 AM - No Delays",
    "description": "Daily Task for Taegan Bunton (SA-33)",
    "url": "https://docs.google.com/spreadsheets/d/1omO-ZV6eNns56OpoifD3T75PrAouWhSf6bYdByHs-Cg/edit?gid=1774295471#gid=1774295471",
    "team": "Admin Team, SuperAdmin",
    "assignee": "Taegan Bunton",
    "code": "SA-33",
    "accessEmails": [
      "admin@ssdspc.com",
      "agonzalez@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Send EOD group text to Dr. M and Alvaro by 4pm",
    "description": "Daily Task for Taegan Bunton (SA-57)",
    "url": "https://docs.google.com/spreadsheets/d/1omO-ZV6eNns56OpoifD3T75PrAouWhSf6bYdByHs-Cg/edit?gid=1774295471#gid=1774295471",
    "team": "Admin Team, SuperAdmin",
    "assignee": "Taegan Bunton",
    "code": "SA-57",
    "accessEmails": [
      "admin@ssdspc.com",
      "agonzalez@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Inbox Zero - tbunton@ssdspc.com - get inbox to zero and review follow up and waiting labels",
    "description": "Daily Task for Taegan Bunton (SA-34)",
    "url": "https://www.jeffsu.org/inbox-zero-tutorial-for-gmail/",
    "team": "Admin Team, SuperAdmin",
    "assignee": "Taegan Bunton",
    "code": "SA-34",
    "accessEmails": [
      "admin@ssdspc.com",
      "agonzalez@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Inbox Zero - admin@ssdspc.com - get inbox to zero and review follow up and waiting labels",
    "description": "Daily Task for Taegan Bunton (SA-35)",
    "url": "https://www.jeffsu.org/inbox-zero-tutorial-for-gmail/",
    "team": "Admin Team, SuperAdmin",
    "assignee": "Taegan Bunton",
    "code": "SA-35",
    "accessEmails": [
      "admin@ssdspc.com",
      "agonzalez@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Generate rescheduling sheets 2 weeks in advance and add plans to each date.",
    "description": "Daily Task for Taegan Bunton (SA-36)",
    "url": "https://docs.google.com/spreadsheets/d/11MKo1xLdUGreNniy5QxKFIJ-zk7dhgYkLKW_bqqVV1g/edit?usp=drivesdkgid=678314630#gid=678314630",
    "team": "Admin Team, SuperAdmin",
    "assignee": "Taegan Bunton",
    "code": "SA-36",
    "accessEmails": [
      "aadwell@ssdspc.com",
      "acochran@ssdspc.com",
      "admin@ssdspc.com",
      "adminhelp@ssdspc.com",
      "afloyd@ssdspc.com",
      "agamache@ssdspc.com",
      "agolightly@ssdspc.com",
      "agonzalez@ssdspc.com",
      "ajones@ssdspc.com",
      "aparameswaran@ssdspc.com",
      "appsheet@ssdspc.com",
      "arodriguez@ssdspc.com",
      "automation@ssdspc.com",
      "awalden@ssdspc.com",
      "ayoung@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "bhammonds@ssdspc.com",
      "bherrington@ssdspc.com",
      "bwscan@ssdspc.com",
      "cmartin@ssdspc.com",
      "cthomson@ssdspc.com",
      "dderamus@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "documents@ssdspc.com",
      "dpatel@ssdspc.com",
      "dwalters@ssdspc.com",
      "dyearwood@ssdspc.com",
      "ehenegar@ssdspc.com",
      "estephens@ssdspc.com",
      "fax@ssdspc.com",
      "games@ssdspc.com",
      "gmcmahan@ssdspc.com",
      "hangouts-chat-45b23cd19217da44@ssdspc.com",
      "hangouts-chat-8cf9bcfb23006f2b@ssdspc.com",
      "hangouts-chat-92d059881c6662fc@ssdspc.com",
      "hangouts-chat-a882a3b4a05f1865@ssdspc.com",
      "hdavlin@ssdspc.com",
      "hnicholson@ssdspc.com",
      "hwest@ssdspc.com",
      "jhagan@ssdspc.com",
      "jhamilton@ssdspc.com",
      "jniblack@ssdspc.com",
      "jpayton@ssdspc.com",
      "jreynolds@ssdspc.com",
      "jsaluja@ssdspc.com",
      "kcharles@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmcmurray@ssdspc.com",
      "kparker@ssdspc.com",
      "kparton@ssdspc.com",
      "lmarsh@ssdspc.com",
      "lsanford@ssdspc.com",
      "mbaker@ssdspc.com",
      "mbivins@ssdspc.com",
      "mdowning@ssdspc.com",
      "medmondson@ssdspc.com",
      "mfortner@ssdspc.com",
      "mgonzalez@ssdspc.com",
      "mhornsby@ssdspc.com",
      "mm@ssdspc.com",
      "mstewart@ssdspc.com",
      "nteague@ssdspc.com",
      "ocarter@ssdspc.com",
      "powen@ssdspc.com",
      "rhead@ssdspc.com",
      "rkhan@ssdspc.com",
      "romar@ssdspc.com",
      "scripts@ssdspc.com",
      "skhan@ssdspc.com",
      "sriggins@ssdspc.com",
      "ssawyer@ssdspc.com",
      "ssd-automation-service-account@workspace-automation-ssdspc.iam.gserviceaccount.com",
      "sync-sa@ssd-intranet-sync.iam.gserviceaccount.com",
      "tbunton@ssdspc.com",
      "tplatts@ssdspc.com",
      "tthompson@ssdspc.com",
      "twood@ssdspc.com",
      "voicemail@ssdspc.com"
    ]
  },
  {
    "name": "Invoice Dashboard - Categorize all documents on the Consolidated Log",
    "description": "Daily Task for Taegan Bunton (SA-37)",
    "url": "https://docs.google.com/spreadsheets/d/1litcuGtcoQcsiVGA56_Lc_oDhCOBT7sIEyqt0Gerigw/edit?gid=0#gid=0",
    "team": "Admin Team, SuperAdmin",
    "assignee": "Taegan Bunton",
    "code": "SA-37",
    "accessEmails": [
      "admin@ssdspc.com",
      "adminhelp@ssdspc.com",
      "agonzalez@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "bwscan@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "documents@ssdspc.com",
      "hangouts-chat-45b23cd19217da44@ssdspc.com",
      "hangouts-chat-92d059881c6662fc@ssdspc.com",
      "hangouts-chat-a882a3b4a05f1865@ssdspc.com",
      "hangouts-chat-f97baa00f008d03f@ssdspc.com",
      "khenriquez@ssdspc.com",
      "lsanford@ssdspc.com",
      "mm@ssdspc.com",
      "scripts@ssdspc.com",
      "skhan@ssdspc.com",
      "ssd-automation-service-account@workspace-automation-ssdspc.iam.gserviceaccount.com",
      "sync-sa@ssd-intranet-sync.iam.gserviceaccount.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Invoice Dashboard- Confirm no recurring bills are due or past due",
    "description": "Daily Task for Taegan Bunton (SA-38)",
    "url": "https://docs.google.com/spreadsheets/d/1litcuGtcoQcsiVGA56_Lc_oDhCOBT7sIEyqt0Gerigw/edit?gid=1483896010#gid=1483896010",
    "team": "Admin Team, SuperAdmin",
    "assignee": "Taegan Bunton",
    "code": "SA-38",
    "accessEmails": [
      "admin@ssdspc.com",
      "adminhelp@ssdspc.com",
      "agonzalez@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "bwscan@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "documents@ssdspc.com",
      "hangouts-chat-45b23cd19217da44@ssdspc.com",
      "hangouts-chat-92d059881c6662fc@ssdspc.com",
      "hangouts-chat-a882a3b4a05f1865@ssdspc.com",
      "hangouts-chat-f97baa00f008d03f@ssdspc.com",
      "khenriquez@ssdspc.com",
      "lsanford@ssdspc.com",
      "mm@ssdspc.com",
      "scripts@ssdspc.com",
      "skhan@ssdspc.com",
      "ssd-automation-service-account@workspace-automation-ssdspc.iam.gserviceaccount.com",
      "sync-sa@ssd-intranet-sync.iam.gserviceaccount.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Invoice Dashboard - Process unpaid invoices",
    "description": "Daily Task for Taegan Bunton (SA-39)",
    "url": "https://docs.google.com/spreadsheets/d/1litcuGtcoQcsiVGA56_Lc_oDhCOBT7sIEyqt0Gerigw/edit?gid=776743796#gid=776743796",
    "team": "Admin Team, SuperAdmin",
    "assignee": "Taegan Bunton",
    "code": "SA-39",
    "accessEmails": [
      "admin@ssdspc.com",
      "adminhelp@ssdspc.com",
      "agonzalez@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "bwscan@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "documents@ssdspc.com",
      "hangouts-chat-45b23cd19217da44@ssdspc.com",
      "hangouts-chat-92d059881c6662fc@ssdspc.com",
      "hangouts-chat-a882a3b4a05f1865@ssdspc.com",
      "hangouts-chat-f97baa00f008d03f@ssdspc.com",
      "khenriquez@ssdspc.com",
      "lsanford@ssdspc.com",
      "mm@ssdspc.com",
      "scripts@ssdspc.com",
      "skhan@ssdspc.com",
      "ssd-automation-service-account@workspace-automation-ssdspc.iam.gserviceaccount.com",
      "sync-sa@ssd-intranet-sync.iam.gserviceaccount.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Review Time Off / PTO Requests in Paycor",
    "description": "Daily Task for Taegan Bunton (SA-40)",
    "url": "https://www.paycor.com/",
    "team": "Admin Team, SuperAdmin",
    "assignee": "Taegan Bunton",
    "code": "SA-40",
    "accessEmails": [
      "admin@ssdspc.com",
      "agonzalez@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Enter Orders from miscellaneous vendors in the Order Log",
    "description": "Daily Task for Taegan Bunton (SA-41)",
    "url": "https://docs.google.com/spreadsheets/d/1HMeabGRigVSXEV7uJdnG28a5McerH2ulEds_7Bk1NOE/edit?gid=952292078#gid=952292078",
    "team": "Admin Team, SuperAdmin",
    "assignee": "Taegan Bunton",
    "code": "SA-41",
    "accessEmails": [
      "aadwell@ssdspc.com",
      "admin@ssdspc.com",
      "adminhelp@ssdspc.com",
      "agonzalez@ssdspc.com",
      "arodriguez@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "bwscan@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "documents@ssdspc.com",
      "hangouts-chat-a882a3b4a05f1865@ssdspc.com",
      "jsaluja@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmatthews@ssdspc.com",
      "lsanford@ssdspc.com",
      "mm@ssdspc.com",
      "rkhan@ssdspc.com",
      "scripts@ssdspc.com",
      "skhan@ssdspc.com",
      "ssd-automation-service-account@workspace-automation-ssdspc.iam.gserviceaccount.com",
      "sync-sa@ssd-intranet-sync.iam.gserviceaccount.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Review the admin help email through out the day for possible staff requests",
    "description": "Daily Task for Taegan Bunton (SA-47)",
    "url": "https://docs.google.com/spreadsheets/d/1omO-ZV6eNns56OpoifD3T75PrAouWhSf6bYdByHs-Cg/edit?gid=1774295471#gid=1774295471",
    "team": "Admin Team, SuperAdmin",
    "assignee": "Taegan Bunton",
    "code": "SA-47",
    "accessEmails": [
      "admin@ssdspc.com",
      "agonzalez@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Number of invoices past \"To be Paid by\" date (User Note Input)",
    "description": "Daily Task for Taegan Bunton (SA-50) \u2014 To be added to the daily end of day text",
    "url": "https://docs.google.com/spreadsheets/d/1omO-ZV6eNns56OpoifD3T75PrAouWhSf6bYdByHs-Cg/edit?gid=1774295471#gid=1774295471",
    "team": "Admin Team, SuperAdmin",
    "assignee": "Taegan Bunton",
    "code": "SA-50",
    "accessEmails": [
      "admin@ssdspc.com",
      "agonzalez@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Go over the candidates for any open possition",
    "description": "Daily Task for Taegan Bunton (SA-55) \u2014 Zip Recruiter / https://docs.google.com/spreadsheets/d/1I1J-PhJOyNgnbIcngHAbcTuWhMSrF1FopAEPLna7zgs/edit?gid=1282560062#gid=1282560062",
    "url": "Zip Recruiter / https://docs.google.com/spreadsheets/d/1I1J-PhJOyNgnbIcngHAbcTuWhMSrF1FopAEPLna7zgs/edit?gid=1282560062#gid=1282560062",
    "team": "Admin Team, SuperAdmin",
    "assignee": "Taegan Bunton",
    "code": "SA-55",
    "accessEmails": [
      "admin@ssdspc.com",
      "adminhelp@ssdspc.com",
      "agolightly@ssdspc.com",
      "agonzalez@ssdspc.com",
      "arodriguez@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "bwscan@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "documents@ssdspc.com",
      "hangouts-chat-a882a3b4a05f1865@ssdspc.com",
      "jsaluja@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmatthews@ssdspc.com",
      "lsanford@ssdspc.com",
      "mm@ssdspc.com",
      "powen@ssdspc.com",
      "rkhan@ssdspc.com",
      "scripts@ssdspc.com",
      "skhan@ssdspc.com",
      "ssd-automation-service-account@workspace-automation-ssdspc.iam.gserviceaccount.com",
      "sync-sa@ssd-intranet-sync.iam.gserviceaccount.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Review unassigned messages in Klara and assign them to the appropriate team",
    "description": "Daily Task for Taegan Bunton (SA-48)",
    "url": "https://doctor.klara.com/#/login",
    "team": "Admin Team, SuperAdmin",
    "assignee": "Taegan Bunton",
    "code": "SA-48",
    "accessEmails": [
      "admin@ssdspc.com",
      "agonzalez@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Review provider days off and patients still pending to be resceduled for providers' with days off",
    "description": "Daily Task for Taegan Bunton (SA-61)",
    "url": "https://docs.google.com/spreadsheets/d/1_DKhMaASywqewhlCbjkPqN3N7frxWXIfk0fWEIws41I/edit?gid=888798205#gid=888798205",
    "team": "Admin Team, SuperAdmin",
    "assignee": "Taegan Bunton",
    "code": "SA-61",
    "accessEmails": [
      "admin@ssdspc.com",
      "agonzalez@ssdspc.com",
      "arodriguez@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "hangouts-chat-45b23cd19217da44@ssdspc.com",
      "jsaluja@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmatthews@ssdspc.com",
      "mm@ssdspc.com",
      "rkhan@ssdspc.com",
      "skhan@ssdspc.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Review with front desk which patients still need to be rescheduled based on upcoming provider days off",
    "description": "Daily Task for Taegan Bunton (SA-62)",
    "url": "https://docs.google.com/spreadsheets/d/1U-NCToYo2fSAgvW6IPysreusH_I5AGQ1k8BWevTY3HE/edit?gid=2139670133#gid=2139670133",
    "team": "Admin Team, SuperAdmin",
    "assignee": "Taegan Bunton",
    "code": "SA-62",
    "accessEmails": [
      "admin@ssdspc.com",
      "adminhelp@ssdspc.com",
      "agonzalez@ssdspc.com",
      "arodriguez@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "bwscan@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "documents@ssdspc.com",
      "hangouts-chat-a882a3b4a05f1865@ssdspc.com",
      "jsaluja@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmatthews@ssdspc.com",
      "lsanford@ssdspc.com",
      "mm@ssdspc.com",
      "rkhan@ssdspc.com",
      "scripts@ssdspc.com",
      "skhan@ssdspc.com",
      "ssd-automation-service-account@workspace-automation-ssdspc.iam.gserviceaccount.com",
      "sync-sa@ssd-intranet-sync.iam.gserviceaccount.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "EOD - Voicemail Log - Make sure all voicemails have been responded to by 4pm",
    "description": "Daily Task for Taegan Bunton (SA-42)",
    "url": "https://docs.google.com/spreadsheets/d/1Ej8wzt6U6C-x5Ex9bv0ZRBZs5RFff0Xpi3Zak4r8u4E/edit?gid=611001893#gid=611001893",
    "team": "Admin Team, SuperAdmin",
    "assignee": "Taegan Bunton",
    "code": "SA-42",
    "accessEmails": [
      "aadwell@ssdspc.com",
      "acochran@ssdspc.com",
      "admin@ssdspc.com",
      "adminhelp@ssdspc.com",
      "afloyd@ssdspc.com",
      "agamache@ssdspc.com",
      "agolightly@ssdspc.com",
      "agonzalez@ssdspc.com",
      "ajones@ssdspc.com",
      "aparameswaran@ssdspc.com",
      "appsheet@ssdspc.com",
      "arodriguez@ssdspc.com",
      "automation@ssdspc.com",
      "awalden@ssdspc.com",
      "ayoung@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "bhammonds@ssdspc.com",
      "bherrington@ssdspc.com",
      "bwscan@ssdspc.com",
      "cmartin@ssdspc.com",
      "cthomson@ssdspc.com",
      "dderamus@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "documents@ssdspc.com",
      "dpatel@ssdspc.com",
      "dwalters@ssdspc.com",
      "dyearwood@ssdspc.com",
      "ehenegar@ssdspc.com",
      "estephens@ssdspc.com",
      "fax@ssdspc.com",
      "games@ssdspc.com",
      "gmcmahan@ssdspc.com",
      "hangouts-chat-3548cceb17795147@ssdspc.com",
      "hangouts-chat-45b23cd19217da44@ssdspc.com",
      "hangouts-chat-8d3ba818a2189894@ssdspc.com",
      "hangouts-chat-a882a3b4a05f1865@ssdspc.com",
      "hdavlin@ssdspc.com",
      "hnicholson@ssdspc.com",
      "hwest@ssdspc.com",
      "jhagan@ssdspc.com",
      "jhamilton@ssdspc.com",
      "jniblack@ssdspc.com",
      "jpayton@ssdspc.com",
      "jreynolds@ssdspc.com",
      "jsaluja@ssdspc.com",
      "kcharles@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmcmurray@ssdspc.com",
      "kparker@ssdspc.com",
      "kparton@ssdspc.com",
      "lmarsh@ssdspc.com",
      "lsanford@ssdspc.com",
      "mbaker@ssdspc.com",
      "mbivins@ssdspc.com",
      "mdowning@ssdspc.com",
      "medmondson@ssdspc.com",
      "mfortner@ssdspc.com",
      "mgonzalez@ssdspc.com",
      "mhornsby@ssdspc.com",
      "mm@ssdspc.com",
      "mstewart@ssdspc.com",
      "nteague@ssdspc.com",
      "ocarter@ssdspc.com",
      "powen@ssdspc.com",
      "rhead@ssdspc.com",
      "rkhan@ssdspc.com",
      "romar@ssdspc.com",
      "scripts@ssdspc.com",
      "skhan@ssdspc.com",
      "sriggins@ssdspc.com",
      "ssawyer@ssdspc.com",
      "ssd-automation-service-account@workspace-automation-ssdspc.iam.gserviceaccount.com",
      "sync-sa@ssd-intranet-sync.iam.gserviceaccount.com",
      "tbunton@ssdspc.com",
      "tplatts@ssdspc.com",
      "tthompson@ssdspc.com",
      "twood@ssdspc.com",
      "voicemail@ssdspc.com"
    ]
  },
  {
    "name": "Attend Jim's questions related to transactions.",
    "description": "Daily Task for Taegan Bunton (SA-64)",
    "url": "https://docs.google.com/spreadsheets/d/1omO-ZV6eNns56OpoifD3T75PrAouWhSf6bYdByHs-Cg/edit?gid=1774295471#gid=1774295471",
    "team": "Admin Team, SuperAdmin",
    "assignee": "Taegan Bunton",
    "code": "SA-64",
    "accessEmails": [
      "admin@ssdspc.com",
      "agonzalez@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Send Alvaro a list of your top 3 priority tasks for the day.",
    "description": "Daily Task for Kevin Henriquez (RT-101)",
    "url": "https://docs.google.com/spreadsheets/d/1omO-ZV6eNns56OpoifD3T75PrAouWhSf6bYdByHs-Cg/edit?gid=1774295471#gid=1774295471",
    "team": "Admin Team, SuperAdmin",
    "assignee": "Kevin Henriquez",
    "code": "RT-101",
    "accessEmails": [
      "admin@ssdspc.com",
      "agonzalez@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "khenriquez@ssdspc.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Data Download & Dump - EMA Appointment Data",
    "description": "Daily Task for Kevin Henriquez (RT-69)",
    "url": "https://docs.google.com/spreadsheets/d/10itZumv5xj-LkjfiajY97HMcq-63cXvd4zgZfiQyCxU/edit?gid=0#gid=0",
    "team": "Admin Team, SuperAdmin",
    "assignee": "Kevin Henriquez",
    "code": "RT-69",
    "accessEmails": [
      "admin@ssdspc.com",
      "adminhelp@ssdspc.com",
      "agonzalez@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "bwscan@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "documents@ssdspc.com",
      "hangouts-chat-45b23cd19217da44@ssdspc.com",
      "hangouts-chat-a882a3b4a05f1865@ssdspc.com",
      "khenriquez@ssdspc.com",
      "lsanford@ssdspc.com",
      "mm@ssdspc.com",
      "scripts@ssdspc.com",
      "skhan@ssdspc.com",
      "ssd-automation-service-account@workspace-automation-ssdspc.iam.gserviceaccount.com",
      "ssdteam@ssdspc.com",
      "sync-sa@ssd-intranet-sync.iam.gserviceaccount.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Patient Summary Docs - Run the script to generate Bulk Docs by provider",
    "description": "Daily Task for Kevin Henriquez (RT-80)",
    "url": "https://docs.google.com/spreadsheets/d/1pYayiiye16Sf4NRnF9QaP06-UpdSeuRZJWiIKY2alMg/edit?gid=0#gid=0",
    "team": "Admin Team, SuperAdmin",
    "assignee": "Kevin Henriquez",
    "code": "RT-80",
    "accessEmails": [
      "aadwell@ssdspc.com",
      "acochran@ssdspc.com",
      "admin@ssdspc.com",
      "agolightly@ssdspc.com",
      "agonzalez@ssdspc.com",
      "ajones@ssdspc.com",
      "appsheet@ssdspc.com",
      "arodriguez@ssdspc.com",
      "awalden@ssdspc.com",
      "bcurren@ssdspc.com",
      "bhammonds@ssdspc.com",
      "bherrington@ssdspc.com",
      "cthomson@ssdspc.com",
      "dderamus@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "dyearwood@ssdspc.com",
      "estephens@ssdspc.com",
      "fax@ssdspc.com",
      "gmcmahan@ssdspc.com",
      "hdavlin@ssdspc.com",
      "hnicholson@ssdspc.com",
      "jhagan@ssdspc.com",
      "jhamilton@ssdspc.com",
      "jniblack@ssdspc.com",
      "jpayton@ssdspc.com",
      "jreynolds@ssdspc.com",
      "jsaluja@ssdspc.com",
      "kcharles@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmcmurray@ssdspc.com",
      "kparker@ssdspc.com",
      "lmarsh@ssdspc.com",
      "mdowning@ssdspc.com",
      "medmondson@ssdspc.com",
      "mfortner@ssdspc.com",
      "mgonzalez@ssdspc.com",
      "mm@ssdspc.com",
      "mstewart@ssdspc.com",
      "ocarter@ssdspc.com",
      "powen@ssdspc.com",
      "rkhan@ssdspc.com",
      "romar@ssdspc.com",
      "ssawyer@ssdspc.com",
      "tbunton@ssdspc.com",
      "tplatts@ssdspc.com",
      "tthompson@ssdspc.com",
      "twood@ssdspc.com",
      "voicemail@ssdspc.com"
    ]
  },
  {
    "name": "Pre-Generated Surgery Maps List - Run Custom Script for Updating Untreated malignancies maps",
    "description": "Daily Task for Kevin Henriquez (RT-40)",
    "url": "https://docs.google.com/spreadsheets/d/1ifDXtZwCd8CK1Ag76MqomvIIm5IGx9qoliyKapzc9WE/edit?gid=0#gid=0",
    "team": "Admin Team, SuperAdmin",
    "assignee": "Kevin Henriquez",
    "code": "RT-40",
    "accessEmails": [
      "aadwell@ssdspc.com",
      "acochran@ssdspc.com",
      "admin@ssdspc.com",
      "agolightly@ssdspc.com",
      "agonzalez@ssdspc.com",
      "ajones@ssdspc.com",
      "appsheet@ssdspc.com",
      "arodriguez@ssdspc.com",
      "awalden@ssdspc.com",
      "bcurren@ssdspc.com",
      "bhammonds@ssdspc.com",
      "bherrington@ssdspc.com",
      "cthomson@ssdspc.com",
      "dderamus@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "dyearwood@ssdspc.com",
      "estephens@ssdspc.com",
      "fax@ssdspc.com",
      "gmcmahan@ssdspc.com",
      "hangouts-chat-45b23cd19217da44@ssdspc.com",
      "hangouts-chat-a882a3b4a05f1865@ssdspc.com",
      "hdavlin@ssdspc.com",
      "hnicholson@ssdspc.com",
      "jhagan@ssdspc.com",
      "jhamilton@ssdspc.com",
      "jniblack@ssdspc.com",
      "jpayton@ssdspc.com",
      "jreynolds@ssdspc.com",
      "jsaluja@ssdspc.com",
      "kcharles@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmcmurray@ssdspc.com",
      "kparker@ssdspc.com",
      "lmarsh@ssdspc.com",
      "mdowning@ssdspc.com",
      "medmondson@ssdspc.com",
      "mfortner@ssdspc.com",
      "mgonzalez@ssdspc.com",
      "mm@ssdspc.com",
      "mstewart@ssdspc.com",
      "ocarter@ssdspc.com",
      "powen@ssdspc.com",
      "rkhan@ssdspc.com",
      "romar@ssdspc.com",
      "ssawyer@ssdspc.com",
      "tbunton@ssdspc.com",
      "tplatts@ssdspc.com",
      "tthompson@ssdspc.com",
      "twood@ssdspc.com",
      "voicemail@ssdspc.com"
    ]
  },
  {
    "name": "Download Data & Dump - EMA Collections Data",
    "description": "Daily Task for Kevin Henriquez (RT-81)",
    "url": "https://docs.google.com/spreadsheets/d/1HH-9RmQ9YsksTFXj1AumCHJ0_bhEgRHIVfpi4aRD35o/edit?gid=2036597910#gid=2036597910",
    "team": "Admin Team, SuperAdmin",
    "assignee": "Kevin Henriquez",
    "code": "RT-81",
    "accessEmails": [
      "admin@ssdspc.com",
      "adminhelp@ssdspc.com",
      "agonzalez@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "bwscan@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "documents@ssdspc.com",
      "khenriquez@ssdspc.com",
      "lsanford@ssdspc.com",
      "mm@ssdspc.com",
      "scripts@ssdspc.com",
      "skhan@ssdspc.com",
      "ssd-automation-service-account@workspace-automation-ssdspc.iam.gserviceaccount.com",
      "sync-sa@ssd-intranet-sync.iam.gserviceaccount.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Download Data & Dump - Billing data for Practice Summary Dashboard",
    "description": "Daily Task for Kevin Henriquez (RT-82)",
    "url": "https://docs.google.com/spreadsheets/d/1BGbjaoom9jBr3Z9LhAa8UQlzvH5XePVOfkpFPqkYhug/edit?gid=561612481#gid=561612481",
    "team": "Admin Team, SuperAdmin",
    "assignee": "Kevin Henriquez",
    "code": "RT-82",
    "accessEmails": [
      "admin@ssdspc.com",
      "adminhelp@ssdspc.com",
      "agonzalez@ssdspc.com",
      "arodriguez@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "bwscan@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "documents@ssdspc.com",
      "hangouts-chat-a882a3b4a05f1865@ssdspc.com",
      "jimrwhisler@gmail.com",
      "jsaluja@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmatthews@ssdspc.com",
      "lsanford@ssdspc.com",
      "mm@ssdspc.com",
      "rkhan@ssdspc.com",
      "scripts@ssdspc.com",
      "skhan@ssdspc.com",
      "ssd-automation-service-account@workspace-automation-ssdspc.iam.gserviceaccount.com",
      "sync-sa@ssd-intranet-sync.iam.gserviceaccount.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Data Download & Dump - Master Biopsy Dashboard Data from EMA",
    "description": "Daily Task for Kevin Henriquez (RT-32)",
    "url": "https://docs.google.com/spreadsheets/d/1SJM5-Gk1QdIcDxN1NMZB0d9yr-mULBKUI_DWdzz3Ebo/edit?gid=0#gid=0",
    "team": "Admin Team, SuperAdmin",
    "assignee": "Kevin Henriquez",
    "code": "RT-32",
    "accessEmails": [
      "aadwell@ssdspc.com",
      "acochran@ssdspc.com",
      "admin@ssdspc.com",
      "adminhelp@ssdspc.com",
      "afloyd@ssdspc.com",
      "agamache@ssdspc.com",
      "agolightly@ssdspc.com",
      "agonzalez@ssdspc.com",
      "ajones@ssdspc.com",
      "aparameswaran@ssdspc.com",
      "appsheet@ssdspc.com",
      "arodriguez@ssdspc.com",
      "automation@ssdspc.com",
      "awalden@ssdspc.com",
      "ayoung@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "bhammonds@ssdspc.com",
      "bherrington@ssdspc.com",
      "bwscan@ssdspc.com",
      "cmartin@ssdspc.com",
      "cthomson@ssdspc.com",
      "dderamus@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "documents@ssdspc.com",
      "dpatel@ssdspc.com",
      "dwalters@ssdspc.com",
      "dyearwood@ssdspc.com",
      "ehenegar@ssdspc.com",
      "estephens@ssdspc.com",
      "fax@ssdspc.com",
      "games@ssdspc.com",
      "gmcmahan@ssdspc.com",
      "hangouts-chat-a882a3b4a05f1865@ssdspc.com",
      "hdavlin@ssdspc.com",
      "hnicholson@ssdspc.com",
      "hwest@ssdspc.com",
      "jhagan@ssdspc.com",
      "jhamilton@ssdspc.com",
      "jniblack@ssdspc.com",
      "jpayton@ssdspc.com",
      "jreynolds@ssdspc.com",
      "jsaluja@ssdspc.com",
      "kcharles@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmcmurray@ssdspc.com",
      "kparker@ssdspc.com",
      "kparton@ssdspc.com",
      "lmarsh@ssdspc.com",
      "lsanford@ssdspc.com",
      "mbaker@ssdspc.com",
      "mbivins@ssdspc.com",
      "mdowning@ssdspc.com",
      "medmondson@ssdspc.com",
      "mfortner@ssdspc.com",
      "mgonzalez@ssdspc.com",
      "mhornsby@ssdspc.com",
      "mm@ssdspc.com",
      "mstewart@ssdspc.com",
      "nteague@ssdspc.com",
      "ocarter@ssdspc.com",
      "powen@ssdspc.com",
      "rhead@ssdspc.com",
      "rkhan@ssdspc.com",
      "romar@ssdspc.com",
      "scripts@ssdspc.com",
      "skhan@ssdspc.com",
      "sriggins@ssdspc.com",
      "ssawyer@ssdspc.com",
      "ssd-automation-service-account@workspace-automation-ssdspc.iam.gserviceaccount.com",
      "sync-sa@ssd-intranet-sync.iam.gserviceaccount.com",
      "tbunton@ssdspc.com",
      "tplatts@ssdspc.com",
      "tthompson@ssdspc.com",
      "twood@ssdspc.com",
      "voicemail@ssdspc.com"
    ]
  },
  {
    "name": "Data Download & Dump - EMA Prescription data",
    "description": "Daily Task for Kevin Henriquez (RT-59)",
    "url": "https://docs.google.com/spreadsheets/d/1PKEJl95eGau7zaBIkbKb5sMCDob2H4W63yF769qUXyU/edit?gid=815140024#gid=815140024",
    "team": "Admin Team, SuperAdmin",
    "assignee": "Kevin Henriquez",
    "code": "RT-59",
    "accessEmails": [
      "admin@ssdspc.com",
      "agonzalez@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "khenriquez@ssdspc.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Data Download & Dump - A/R Patient's Dashboard Data from EMA",
    "description": "Daily Task for Kevin Henriquez (RT-30)",
    "url": "https://docs.google.com/spreadsheets/d/1O0L4e8vJcJjI3RG0F5TyRboBqemzNol22220iroJZ9A/edit?gid=527600531#gid=527600531",
    "team": "Admin Team, SuperAdmin",
    "assignee": "Kevin Henriquez",
    "code": "RT-30",
    "accessEmails": [
      "admin@ssdspc.com",
      "agonzalez@ssdspc.com",
      "bcurren@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "jsaluja@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmatthews@ssdspc.com",
      "mgonzalez@ssdspc.com",
      "mm@ssdspc.com",
      "rkhan@ssdspc.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Data Download & Dump - Unallocated Patient Payments",
    "description": "Daily Task for Kevin Henriquez (RT-100)",
    "url": "https://docs.google.com/spreadsheets/d/1MeUzkKalGwhdqJ3B5usGVrz51kPRoD_6nOxuYzdd4Ew/edit?gid=0#gid=0",
    "team": "Admin Team, SuperAdmin",
    "assignee": "Kevin Henriquez",
    "code": "RT-100",
    "accessEmails": [
      "admin@ssdspc.com",
      "agonzalez@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "jhagan@ssdspc.com",
      "khenriquez@ssdspc.com",
      "lmarsh@ssdspc.com",
      "mm@ssdspc.com",
      "rkhan@ssdspc.com",
      "scripts@ssdspc.com",
      "ssd-automation-service-account@workspace-automation-ssdspc.iam.gserviceaccount.com",
      "sync-sa@ssd-intranet-sync.iam.gserviceaccount.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Data Download & Dump - Skin Substitute Reimbursement Data from EMA",
    "description": "Daily Task for Kevin Henriquez (RT-26)",
    "url": "https://docs.google.com/spreadsheets/d/1xVJWRqdgRRLMSjXptMt97LuTC_dluWj1yfsN8ynCrf4/edit?gid=23001889#gid=23001889",
    "team": "Admin Team, SuperAdmin",
    "assignee": "Kevin Henriquez",
    "code": "RT-26",
    "accessEmails": [
      "admin@ssdspc.com",
      "adminhelp@ssdspc.com",
      "agonzalez@ssdspc.com",
      "arodriguez@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "bwscan@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "documents@ssdspc.com",
      "hangouts-chat-a882a3b4a05f1865@ssdspc.com",
      "jsaluja@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmatthews@ssdspc.com",
      "lsanford@ssdspc.com",
      "mm@ssdspc.com",
      "rkhan@ssdspc.com",
      "scripts@ssdspc.com",
      "skhan@ssdspc.com",
      "ssd-automation-service-account@workspace-automation-ssdspc.iam.gserviceaccount.com",
      "sync-sa@ssd-intranet-sync.iam.gserviceaccount.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Data Download & Dump - Cosmetics Reimbursement Data from EMA",
    "description": "Daily Task for Kevin Henriquez (RT-25)",
    "url": "https://docs.google.com/spreadsheets/d/1fhwC9gMDolAWQXjaGauTE25alhezTGTGxDFz6Y8UiC4/edit?gid=435177006#gid=435177006",
    "team": "Admin Team, SuperAdmin",
    "assignee": "Kevin Henriquez",
    "code": "RT-25",
    "accessEmails": [
      "admin@ssdspc.com",
      "adminhelp@ssdspc.com",
      "agonzalez@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "bwscan@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "documents@ssdspc.com",
      "khenriquez@ssdspc.com",
      "lsanford@ssdspc.com",
      "mm@ssdspc.com",
      "scripts@ssdspc.com",
      "skhan@ssdspc.com",
      "ssd-automation-service-account@workspace-automation-ssdspc.iam.gserviceaccount.com",
      "sync-sa@ssd-intranet-sync.iam.gserviceaccount.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Data Download & Dump - Surgery Dashboard Data from EMA",
    "description": "Daily Task for Kevin Henriquez (RT-27)",
    "url": "https://docs.google.com/spreadsheets/d/1DE5JwiBoT23ygp-ufQCdQ3JYkBR9pl3Whod4__zLpPA/edit?gid=116542024#gid=116542024",
    "team": "Admin Team, SuperAdmin",
    "assignee": "Kevin Henriquez",
    "code": "RT-27",
    "accessEmails": [
      "aadwell@ssdspc.com",
      "acochran@ssdspc.com",
      "admin@ssdspc.com",
      "agolightly@ssdspc.com",
      "agonzalez@ssdspc.com",
      "ajones@ssdspc.com",
      "appsheet@ssdspc.com",
      "arodriguez@ssdspc.com",
      "awalden@ssdspc.com",
      "bcurren@ssdspc.com",
      "bhammonds@ssdspc.com",
      "bherrington@ssdspc.com",
      "cthomson@ssdspc.com",
      "dderamus@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "dyearwood@ssdspc.com",
      "estephens@ssdspc.com",
      "fax@ssdspc.com",
      "gmcmahan@ssdspc.com",
      "hangouts-chat-45b23cd19217da44@ssdspc.com",
      "hangouts-chat-592f30e745662f04@ssdspc.com",
      "hangouts-chat-684d4ab8b6dcf50@ssdspc.com",
      "hdavlin@ssdspc.com",
      "hnicholson@ssdspc.com",
      "jhagan@ssdspc.com",
      "jhamilton@ssdspc.com",
      "jniblack@ssdspc.com",
      "jpayton@ssdspc.com",
      "jreynolds@ssdspc.com",
      "jsaluja@ssdspc.com",
      "kcharles@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmcmurray@ssdspc.com",
      "kparker@ssdspc.com",
      "lmarsh@ssdspc.com",
      "mdowning@ssdspc.com",
      "medmondson@ssdspc.com",
      "mfortner@ssdspc.com",
      "mgonzalez@ssdspc.com",
      "mm@ssdspc.com",
      "mstewart@ssdspc.com",
      "ocarter@ssdspc.com",
      "powen@ssdspc.com",
      "rkhan@ssdspc.com",
      "romar@ssdspc.com",
      "ssawyer@ssdspc.com",
      "tbunton@ssdspc.com",
      "tplatts@ssdspc.com",
      "tthompson@ssdspc.com",
      "twood@ssdspc.com",
      "voicemail@ssdspc.com"
    ]
  },
  {
    "name": "Data Download & Dump - Patients Demographics Data from EMA",
    "description": "Daily Task for Kevin Henriquez",
    "url": "https://docs.google.com/spreadsheets/d/1nYzpVskLjQfaSBYbt-y_CZzAJfqLmh37Wqw9FHmvd1c/edit",
    "team": "Admin Team, SuperAdmin",
    "assignee": "Kevin Henriquez",
    "code": "",
    "accessEmails": [
      "admin@ssdspc.com",
      "adminhelp@ssdspc.com",
      "agonzalez@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "bwscan@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "documents@ssdspc.com",
      "domain:ssdspc.com",
      "khenriquez@ssdspc.com",
      "lsanford@ssdspc.com",
      "mm@ssdspc.com",
      "scripts@ssdspc.com",
      "skhan@ssdspc.com",
      "ssd-automation-service-account@workspace-automation-ssdspc.iam.gserviceaccount.com",
      "sync-sa@ssd-intranet-sync.iam.gserviceaccount.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Raw Data & Processing Dashboard - Confirm all downloaded data was successfully uploaded",
    "description": "Daily Task for Kevin Henriquez (RT-88)",
    "url": "https://docs.google.com/spreadsheets/d/1K8AnRcR6INmL_gAJMB5S9IAuq8psHX3dSonn3wRFpxw/edit?gid=0#gid=0",
    "team": "Admin Team, SuperAdmin",
    "assignee": "Kevin Henriquez",
    "code": "RT-88",
    "accessEmails": [
      "admin@ssdspc.com",
      "adminhelp@ssdspc.com",
      "agonzalez@ssdspc.com",
      "arodriguez@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "bwscan@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "documents@ssdspc.com",
      "hangouts-chat-45b23cd19217da44@ssdspc.com",
      "hangouts-chat-a882a3b4a05f1865@ssdspc.com",
      "jsaluja@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmatthews@ssdspc.com",
      "lsanford@ssdspc.com",
      "mm@ssdspc.com",
      "rkhan@ssdspc.com",
      "scripts@ssdspc.com",
      "skhan@ssdspc.com",
      "ssd-automation-service-account@workspace-automation-ssdspc.iam.gserviceaccount.com",
      "sync-sa@ssd-intranet-sync.iam.gserviceaccount.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Practice Summary Dashboard - Verify accuracy of billing data",
    "description": "Daily Task for Kevin Henriquez (RT-2)",
    "url": "https://docs.google.com/spreadsheets/d/1BGbjaoom9jBr3Z9LhAa8UQlzvH5XePVOfkpFPqkYhug/edit?gid=1342395189#gid=1342395189",
    "team": "Admin Team, SuperAdmin",
    "assignee": "Kevin Henriquez",
    "code": "RT-2",
    "accessEmails": [
      "admin@ssdspc.com",
      "adminhelp@ssdspc.com",
      "agonzalez@ssdspc.com",
      "arodriguez@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "bwscan@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "documents@ssdspc.com",
      "hangouts-chat-a882a3b4a05f1865@ssdspc.com",
      "jimrwhisler@gmail.com",
      "jsaluja@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmatthews@ssdspc.com",
      "lsanford@ssdspc.com",
      "mm@ssdspc.com",
      "rkhan@ssdspc.com",
      "scripts@ssdspc.com",
      "skhan@ssdspc.com",
      "ssd-automation-service-account@workspace-automation-ssdspc.iam.gserviceaccount.com",
      "sync-sa@ssd-intranet-sync.iam.gserviceaccount.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Practice Summary Dashboard - Verify accuracy of appointment data",
    "description": "Daily Task for Kevin Henriquez (RT-3)",
    "url": "https://docs.google.com/spreadsheets/d/1BGbjaoom9jBr3Z9LhAa8UQlzvH5XePVOfkpFPqkYhug/edit?gid=1342395189#gid=1342395189",
    "team": "Admin Team, SuperAdmin",
    "assignee": "Kevin Henriquez",
    "code": "RT-3",
    "accessEmails": [
      "admin@ssdspc.com",
      "adminhelp@ssdspc.com",
      "agonzalez@ssdspc.com",
      "arodriguez@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "bwscan@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "documents@ssdspc.com",
      "hangouts-chat-a882a3b4a05f1865@ssdspc.com",
      "jimrwhisler@gmail.com",
      "jsaluja@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmatthews@ssdspc.com",
      "lsanford@ssdspc.com",
      "mm@ssdspc.com",
      "rkhan@ssdspc.com",
      "scripts@ssdspc.com",
      "skhan@ssdspc.com",
      "ssd-automation-service-account@workspace-automation-ssdspc.iam.gserviceaccount.com",
      "sync-sa@ssd-intranet-sync.iam.gserviceaccount.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Practice Summary Dashboard - Verify accuracy of collections data.",
    "description": "Daily Task for Kevin Henriquez (RT-1)",
    "url": "https://docs.google.com/spreadsheets/d/1BGbjaoom9jBr3Z9LhAa8UQlzvH5XePVOfkpFPqkYhug/edit?gid=1342395189#gid=1342395189",
    "team": "Admin Team, SuperAdmin",
    "assignee": "Kevin Henriquez",
    "code": "RT-1",
    "accessEmails": [
      "admin@ssdspc.com",
      "adminhelp@ssdspc.com",
      "agonzalez@ssdspc.com",
      "arodriguez@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "bwscan@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "documents@ssdspc.com",
      "hangouts-chat-a882a3b4a05f1865@ssdspc.com",
      "jimrwhisler@gmail.com",
      "jsaluja@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmatthews@ssdspc.com",
      "lsanford@ssdspc.com",
      "mm@ssdspc.com",
      "rkhan@ssdspc.com",
      "scripts@ssdspc.com",
      "skhan@ssdspc.com",
      "ssd-automation-service-account@workspace-automation-ssdspc.iam.gserviceaccount.com",
      "sync-sa@ssd-intranet-sync.iam.gserviceaccount.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Practice Summary Dashboard - Verify accuracy of biopsy counts",
    "description": "Daily Task for Kevin Henriquez (RT-4)",
    "url": "https://docs.google.com/spreadsheets/d/1BGbjaoom9jBr3Z9LhAa8UQlzvH5XePVOfkpFPqkYhug/edit?gid=1342395189#gid=1342395189",
    "team": "Admin Team, SuperAdmin",
    "assignee": "Kevin Henriquez",
    "code": "RT-4",
    "accessEmails": [
      "admin@ssdspc.com",
      "adminhelp@ssdspc.com",
      "agonzalez@ssdspc.com",
      "arodriguez@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "bwscan@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "documents@ssdspc.com",
      "hangouts-chat-a882a3b4a05f1865@ssdspc.com",
      "jimrwhisler@gmail.com",
      "jsaluja@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmatthews@ssdspc.com",
      "lsanford@ssdspc.com",
      "mm@ssdspc.com",
      "rkhan@ssdspc.com",
      "scripts@ssdspc.com",
      "skhan@ssdspc.com",
      "ssd-automation-service-account@workspace-automation-ssdspc.iam.gserviceaccount.com",
      "sync-sa@ssd-intranet-sync.iam.gserviceaccount.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Skin Sub Cycle Management - Review dashboard for any formula errors",
    "description": "Daily Task for Kevin Henriquez (RT-6)",
    "url": "https://docs.google.com/spreadsheets/d/1xVJWRqdgRRLMSjXptMt97LuTC_dluWj1yfsN8ynCrf4/edit?gid=532075934#gid=532075934",
    "team": "Admin Team, SuperAdmin",
    "assignee": "Kevin Henriquez",
    "code": "RT-6",
    "accessEmails": [
      "admin@ssdspc.com",
      "adminhelp@ssdspc.com",
      "agonzalez@ssdspc.com",
      "arodriguez@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "bwscan@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "documents@ssdspc.com",
      "hangouts-chat-a882a3b4a05f1865@ssdspc.com",
      "jsaluja@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmatthews@ssdspc.com",
      "lsanford@ssdspc.com",
      "mm@ssdspc.com",
      "rkhan@ssdspc.com",
      "scripts@ssdspc.com",
      "skhan@ssdspc.com",
      "ssd-automation-service-account@workspace-automation-ssdspc.iam.gserviceaccount.com",
      "sync-sa@ssd-intranet-sync.iam.gserviceaccount.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Skin Substitute Inventory -  Log all newly received grafts into inventory",
    "description": "Daily Task for Kevin Henriquez (RT-7)",
    "url": "https://docs.google.com/spreadsheets/d/1IYW-xxuLKe59vbBIh3wL9DZPMZlz7HZYy-vMWh-cXZI/edit?gid=80392462#gid=80392462",
    "team": "Admin Team, SuperAdmin",
    "assignee": "Kevin Henriquez",
    "code": "RT-7",
    "accessEmails": [
      "aadwell@ssdspc.com",
      "acochran@ssdspc.com",
      "admin@ssdspc.com",
      "agolightly@ssdspc.com",
      "agonzalez@ssdspc.com",
      "ajones@ssdspc.com",
      "appsheet@ssdspc.com",
      "arodriguez@ssdspc.com",
      "awalden@ssdspc.com",
      "bcurren@ssdspc.com",
      "bhammonds@ssdspc.com",
      "bherrington@ssdspc.com",
      "cthomson@ssdspc.com",
      "dderamus@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "dyearwood@ssdspc.com",
      "estephens@ssdspc.com",
      "fax@ssdspc.com",
      "gmcmahan@ssdspc.com",
      "hangouts-chat-45b23cd19217da44@ssdspc.com",
      "hangouts-chat-592f30e745662f04@ssdspc.com",
      "hangouts-chat-f97baa00f008d03f@ssdspc.com",
      "hdavlin@ssdspc.com",
      "hnicholson@ssdspc.com",
      "jhagan@ssdspc.com",
      "jhamilton@ssdspc.com",
      "jniblack@ssdspc.com",
      "jpayton@ssdspc.com",
      "jreynolds@ssdspc.com",
      "jsaluja@ssdspc.com",
      "kcharles@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmcmurray@ssdspc.com",
      "kparker@ssdspc.com",
      "lmarsh@ssdspc.com",
      "mdowning@ssdspc.com",
      "medmondson@ssdspc.com",
      "mfortner@ssdspc.com",
      "mgonzalez@ssdspc.com",
      "mm@ssdspc.com",
      "mstewart@ssdspc.com",
      "ocarter@ssdspc.com",
      "powen@ssdspc.com",
      "rkhan@ssdspc.com",
      "romar@ssdspc.com",
      "ssawyer@ssdspc.com",
      "tbunton@ssdspc.com",
      "tplatts@ssdspc.com",
      "tthompson@ssdspc.com",
      "twood@ssdspc.com",
      "voicemail@ssdspc.com"
    ]
  },
  {
    "name": "Surgery Scheduling Dashboard - Send email with cancers that were sheduled for surgery and then cancelled or no-showed, update their status in EMA accordingly.",
    "description": "Daily Task for Kevin Henriquez (RT-99)",
    "url": "https://docs.google.com/spreadsheets/d/1o2RepD8AokxYj3wxC4z0Fem-WDzoV2pZDr_CX7DoE8Y/edit?gid=1293540524#gid=1293540524",
    "team": "Admin Team, SuperAdmin",
    "assignee": "Kevin Henriquez",
    "code": "RT-99",
    "accessEmails": [
      "aadwell@ssdspc.com",
      "acochran@ssdspc.com",
      "admin@ssdspc.com",
      "agolightly@ssdspc.com",
      "agonzalez@ssdspc.com",
      "ajones@ssdspc.com",
      "appsheet@ssdspc.com",
      "arodriguez@ssdspc.com",
      "awalden@ssdspc.com",
      "bcurren@ssdspc.com",
      "bhammonds@ssdspc.com",
      "bherrington@ssdspc.com",
      "cthomson@ssdspc.com",
      "dderamus@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "dyearwood@ssdspc.com",
      "estephens@ssdspc.com",
      "fax@ssdspc.com",
      "gmcmahan@ssdspc.com",
      "hangouts-chat-a882a3b4a05f1865@ssdspc.com",
      "hdavlin@ssdspc.com",
      "hnicholson@ssdspc.com",
      "jhagan@ssdspc.com",
      "jhamilton@ssdspc.com",
      "jniblack@ssdspc.com",
      "jpayton@ssdspc.com",
      "jreynolds@ssdspc.com",
      "jsaluja@ssdspc.com",
      "kcharles@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmcmurray@ssdspc.com",
      "kparker@ssdspc.com",
      "lmarsh@ssdspc.com",
      "mdowning@ssdspc.com",
      "medmondson@ssdspc.com",
      "mfortner@ssdspc.com",
      "mgonzalez@ssdspc.com",
      "mm@ssdspc.com",
      "mstewart@ssdspc.com",
      "ocarter@ssdspc.com",
      "powen@ssdspc.com",
      "rkhan@ssdspc.com",
      "romar@ssdspc.com",
      "ssawyer@ssdspc.com",
      "tbunton@ssdspc.com",
      "tplatts@ssdspc.com",
      "tthompson@ssdspc.com",
      "twood@ssdspc.com",
      "voicemail@ssdspc.com"
    ]
  },
  {
    "name": "EMA - Review path reports sent by SkinDx through EMA that were not assigned into each patient chart.",
    "description": "Daily Task for Kevin Henriquez (RT-15)",
    "url": "https://ssd.ema.md/ema/app/lab/ELab.action",
    "team": "Admin Team, SuperAdmin",
    "assignee": "Kevin Henriquez",
    "code": "RT-15",
    "accessEmails": [
      "admin@ssdspc.com",
      "agonzalez@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "khenriquez@ssdspc.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "EMA - Review lab results received through EMA that were not assigned into each patient chart.",
    "description": "Daily Task for Kevin Henriquez (RT-55)",
    "url": "https://docs.google.com/spreadsheets/d/1o6QFZz9Cld6F7C4MI7KQtVlhGBbrzH0HLX2zgiTXSIU/edit?gid=0#gid=0",
    "team": "Admin Team, SuperAdmin",
    "assignee": "Kevin Henriquez",
    "code": "RT-55",
    "accessEmails": [
      "admin@ssdspc.com",
      "agonzalez@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "khenriquez@ssdspc.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "2025 MIPS Master Dashboard - Review fixed MIPS visits for the day per provider and send email to remind teams to fix MIPS visits to be fixed",
    "description": "Daily Task for Kevin Henriquez (RT-48)",
    "url": "https://docs.google.com/spreadsheets/d/1WdMe_QKAjO25mXKrNIOf75mRUDXdoo7n0KOuyBOJZNw/edit?gid=0#gid=0",
    "team": "Admin Team, SuperAdmin",
    "assignee": "Kevin Henriquez",
    "code": "RT-48",
    "accessEmails": [
      "admin@ssdspc.com",
      "agonzalez@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "khenriquez@ssdspc.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "MIPS RD File - Copy and Paste updated MIPS Visits Data to Raw Data sheet.",
    "description": "Daily Task for Kevin Henriquez (RT-12)",
    "url": "https://docs.google.com/spreadsheets/d/1ff3FS6TC-2R5CHJXidKg8IdqW_u5G6xvYM6uGCUIs6Q/edit?gid=888266503#gid=888266503",
    "team": "Admin Team, SuperAdmin",
    "assignee": "Kevin Henriquez",
    "code": "RT-12",
    "accessEmails": [
      "admin@ssdspc.com",
      "agonzalez@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "khenriquez@ssdspc.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "MIPS Processing Sheet - Process MIPS Visits Data from Raw Data to Processing Sheet.",
    "description": "Daily Task for Kevin Henriquez (RT-13)",
    "url": "https://docs.google.com/spreadsheets/d/1zp4b4XTpeUzv7VfA3aRKFYo2rV1W09IIHxufEe1Uco0/edit?gid=1654574359#gid=1654574359",
    "team": "Admin Team, SuperAdmin",
    "assignee": "Kevin Henriquez",
    "code": "RT-13",
    "accessEmails": [
      "admin@ssdspc.com",
      "adminhelp@ssdspc.com",
      "agonzalez@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "bwscan@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "documents@ssdspc.com",
      "hangouts-chat-a882a3b4a05f1865@ssdspc.com",
      "khenriquez@ssdspc.com",
      "lsanford@ssdspc.com",
      "mm@ssdspc.com",
      "scripts@ssdspc.com",
      "skhan@ssdspc.com",
      "ssd-automation-service-account@workspace-automation-ssdspc.iam.gserviceaccount.com",
      "sync-sa@ssd-intranet-sync.iam.gserviceaccount.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "2025 MIPS Master Dashboard - Group updated MIPS Visits and MIPS Visits to Fix by week.",
    "description": "Daily Task for Kevin Henriquez (RT-14)",
    "url": "https://docs.google.com/spreadsheets/d/1SB0MzcN7ybZe6IyvMT3ODyqHqvopA2QVDgdoPQdoHSI/edit?gid=2036189220#gid=2036189220",
    "team": "Admin Team, SuperAdmin",
    "assignee": "Kevin Henriquez",
    "code": "RT-14",
    "accessEmails": [
      "admin@ssdspc.com",
      "adminhelp@ssdspc.com",
      "agonzalez@ssdspc.com",
      "arodriguez@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "bwscan@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "documents@ssdspc.com",
      "jsaluja@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmatthews@ssdspc.com",
      "lsanford@ssdspc.com",
      "mm@ssdspc.com",
      "rkhan@ssdspc.com",
      "scripts@ssdspc.com",
      "skhan@ssdspc.com",
      "ssd-automation-service-account@workspace-automation-ssdspc.iam.gserviceaccount.com",
      "sync-sa@ssd-intranet-sync.iam.gserviceaccount.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Data Download & Dump EOD - Visit Notes from EMA",
    "description": "Daily Task for Kevin Henriquez (RT-11)",
    "url": "https://docs.google.com/spreadsheets/d/1MfMs9UglAHt55zhL5lTHa_ytFcCi3u1cbdn4f4G4ARo/edit?gid=696592899#gid=696592899",
    "team": "Admin Team, SuperAdmin",
    "assignee": "Kevin Henriquez",
    "code": "RT-11",
    "accessEmails": [
      "admin@ssdspc.com",
      "adminhelp@ssdspc.com",
      "agonzalez@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "bwscan@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "documents@ssdspc.com",
      "khenriquez@ssdspc.com",
      "lsanford@ssdspc.com",
      "mm@ssdspc.com",
      "scripts@ssdspc.com",
      "skhan@ssdspc.com",
      "ssd-automation-service-account@workspace-automation-ssdspc.iam.gserviceaccount.com",
      "sync-sa@ssd-intranet-sync.iam.gserviceaccount.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Review the count of Germ Derm and Spot checks before the Front Desk team leaves. They need to ask MAs so they can update th sheet.",
    "description": "Daily Task for Kevin Henriquez (RT-111)",
    "url": "https://docs.google.com/spreadsheets/d/1N6mIHNoV1rjyzZI1LZDTpV-oKRJy4thQw70xfSJiHWc/edit?gid=47037837#gid=47037837",
    "team": "Admin Team, SuperAdmin",
    "assignee": "Kevin Henriquez",
    "code": "RT-111",
    "accessEmails": [
      "aadwell@ssdspc.com",
      "acochran@ssdspc.com",
      "admin@ssdspc.com",
      "adminhelp@ssdspc.com",
      "afloyd@ssdspc.com",
      "agamache@ssdspc.com",
      "agolightly@ssdspc.com",
      "agonzalez@ssdspc.com",
      "ajones@ssdspc.com",
      "aparameswaran@ssdspc.com",
      "appsheet@ssdspc.com",
      "arodriguez@ssdspc.com",
      "automation@ssdspc.com",
      "awalden@ssdspc.com",
      "ayoung@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "bhammonds@ssdspc.com",
      "bherrington@ssdspc.com",
      "bwscan@ssdspc.com",
      "cmartin@ssdspc.com",
      "cthomson@ssdspc.com",
      "dderamus@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "documents@ssdspc.com",
      "dpatel@ssdspc.com",
      "dwalters@ssdspc.com",
      "dyearwood@ssdspc.com",
      "ehenegar@ssdspc.com",
      "estephens@ssdspc.com",
      "fax@ssdspc.com",
      "games@ssdspc.com",
      "gmcmahan@ssdspc.com",
      "hangouts-chat-8cf9bcfb23006f2b@ssdspc.com",
      "hangouts-chat-8d3ba818a2189894@ssdspc.com",
      "hangouts-chat-a882a3b4a05f1865@ssdspc.com",
      "hdavlin@ssdspc.com",
      "hnicholson@ssdspc.com",
      "hwest@ssdspc.com",
      "jhagan@ssdspc.com",
      "jhamilton@ssdspc.com",
      "jniblack@ssdspc.com",
      "jpayton@ssdspc.com",
      "jreynolds@ssdspc.com",
      "jsaluja@ssdspc.com",
      "kcharles@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmcmurray@ssdspc.com",
      "kparker@ssdspc.com",
      "kparton@ssdspc.com",
      "lmarsh@ssdspc.com",
      "lsanford@ssdspc.com",
      "mbaker@ssdspc.com",
      "mbivins@ssdspc.com",
      "mdowning@ssdspc.com",
      "medmondson@ssdspc.com",
      "mfortner@ssdspc.com",
      "mgonzalez@ssdspc.com",
      "mhornsby@ssdspc.com",
      "mm@ssdspc.com",
      "mstewart@ssdspc.com",
      "nteague@ssdspc.com",
      "ocarter@ssdspc.com",
      "powen@ssdspc.com",
      "rhead@ssdspc.com",
      "rkhan@ssdspc.com",
      "romar@ssdspc.com",
      "scripts@ssdspc.com",
      "skhan@ssdspc.com",
      "sriggins@ssdspc.com",
      "ssawyer@ssdspc.com",
      "ssd-automation-service-account@workspace-automation-ssdspc.iam.gserviceaccount.com",
      "sync-sa@ssd-intranet-sync.iam.gserviceaccount.com",
      "tbunton@ssdspc.com",
      "tplatts@ssdspc.com",
      "tthompson@ssdspc.com",
      "twood@ssdspc.com",
      "voicemail@ssdspc.com"
    ]
  },
  {
    "name": "Review the Lab errors every day and based on what Amie describes contact the MAs involved and provide feedback,",
    "description": "Daily Task for Kevin Henriquez (RT-112)",
    "url": "https://docs.google.com/spreadsheets/d/15iCDpgVSD7imHkmfn1Hfvre3qdmooTgD88X-jVzHzpU/edit?gid=327868728#gid=327868728",
    "team": "Admin Team, SuperAdmin",
    "assignee": "Kevin Henriquez",
    "code": "RT-112",
    "accessEmails": [
      "aadwell@ssdspc.com",
      "acochran@ssdspc.com",
      "admin@ssdspc.com",
      "adminhelp@ssdspc.com",
      "afloyd@ssdspc.com",
      "agamache@ssdspc.com",
      "agolightly@ssdspc.com",
      "agonzalez@ssdspc.com",
      "ajones@ssdspc.com",
      "aparameswaran@ssdspc.com",
      "appsheet@ssdspc.com",
      "arodriguez@ssdspc.com",
      "automation@ssdspc.com",
      "awalden@ssdspc.com",
      "ayoung@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "bhammonds@ssdspc.com",
      "bherrington@ssdspc.com",
      "bwscan@ssdspc.com",
      "cmartin@ssdspc.com",
      "cthomson@ssdspc.com",
      "dderamus@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "documents@ssdspc.com",
      "dpatel@ssdspc.com",
      "dwalters@ssdspc.com",
      "dyearwood@ssdspc.com",
      "ehenegar@ssdspc.com",
      "estephens@ssdspc.com",
      "fax@ssdspc.com",
      "games@ssdspc.com",
      "gmcmahan@ssdspc.com",
      "hangouts-chat-a882a3b4a05f1865@ssdspc.com",
      "hdavlin@ssdspc.com",
      "hnicholson@ssdspc.com",
      "hwest@ssdspc.com",
      "jhagan@ssdspc.com",
      "jhamilton@ssdspc.com",
      "jniblack@ssdspc.com",
      "jpayton@ssdspc.com",
      "jreynolds@ssdspc.com",
      "jsaluja@ssdspc.com",
      "kcharles@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmcmurray@ssdspc.com",
      "kparker@ssdspc.com",
      "kparton@ssdspc.com",
      "lmarsh@ssdspc.com",
      "lsanford@ssdspc.com",
      "mbaker@ssdspc.com",
      "mbivins@ssdspc.com",
      "mdowning@ssdspc.com",
      "medmondson@ssdspc.com",
      "mfortner@ssdspc.com",
      "mgonzalez@ssdspc.com",
      "mhornsby@ssdspc.com",
      "mm@ssdspc.com",
      "mstewart@ssdspc.com",
      "nteague@ssdspc.com",
      "ocarter@ssdspc.com",
      "powen@ssdspc.com",
      "rhead@ssdspc.com",
      "rkhan@ssdspc.com",
      "romar@ssdspc.com",
      "scripts@ssdspc.com",
      "skhan@ssdspc.com",
      "sriggins@ssdspc.com",
      "ssawyer@ssdspc.com",
      "ssd-automation-service-account@workspace-automation-ssdspc.iam.gserviceaccount.com",
      "sync-sa@ssd-intranet-sync.iam.gserviceaccount.com",
      "tbunton@ssdspc.com",
      "tplatts@ssdspc.com",
      "tthompson@ssdspc.com",
      "twood@ssdspc.com",
      "voicemail@ssdspc.com"
    ]
  },
  {
    "name": "Need to make sure the Front Desk adds the provider's open appointment spots every day by the end of the day.",
    "description": "Daily Task for Kevin Henriquez (RT-113)",
    "url": "https://docs.google.com/spreadsheets/d/11MKo1xLdUGreNniy5QxKFIJ-zk7dhgYkLKW_bqqVV1g/edit?gid=1354709876#gid=1354709876",
    "team": "Admin Team, SuperAdmin",
    "assignee": "Kevin Henriquez",
    "code": "RT-113",
    "accessEmails": [
      "aadwell@ssdspc.com",
      "acochran@ssdspc.com",
      "admin@ssdspc.com",
      "adminhelp@ssdspc.com",
      "afloyd@ssdspc.com",
      "agamache@ssdspc.com",
      "agolightly@ssdspc.com",
      "agonzalez@ssdspc.com",
      "ajones@ssdspc.com",
      "aparameswaran@ssdspc.com",
      "appsheet@ssdspc.com",
      "arodriguez@ssdspc.com",
      "automation@ssdspc.com",
      "awalden@ssdspc.com",
      "ayoung@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "bhammonds@ssdspc.com",
      "bherrington@ssdspc.com",
      "bwscan@ssdspc.com",
      "cmartin@ssdspc.com",
      "cthomson@ssdspc.com",
      "dderamus@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "documents@ssdspc.com",
      "dpatel@ssdspc.com",
      "dwalters@ssdspc.com",
      "dyearwood@ssdspc.com",
      "ehenegar@ssdspc.com",
      "estephens@ssdspc.com",
      "fax@ssdspc.com",
      "games@ssdspc.com",
      "gmcmahan@ssdspc.com",
      "hangouts-chat-45b23cd19217da44@ssdspc.com",
      "hangouts-chat-8cf9bcfb23006f2b@ssdspc.com",
      "hangouts-chat-92d059881c6662fc@ssdspc.com",
      "hangouts-chat-a882a3b4a05f1865@ssdspc.com",
      "hdavlin@ssdspc.com",
      "hnicholson@ssdspc.com",
      "hwest@ssdspc.com",
      "jhagan@ssdspc.com",
      "jhamilton@ssdspc.com",
      "jniblack@ssdspc.com",
      "jpayton@ssdspc.com",
      "jreynolds@ssdspc.com",
      "jsaluja@ssdspc.com",
      "kcharles@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmcmurray@ssdspc.com",
      "kparker@ssdspc.com",
      "kparton@ssdspc.com",
      "lmarsh@ssdspc.com",
      "lsanford@ssdspc.com",
      "mbaker@ssdspc.com",
      "mbivins@ssdspc.com",
      "mdowning@ssdspc.com",
      "medmondson@ssdspc.com",
      "mfortner@ssdspc.com",
      "mgonzalez@ssdspc.com",
      "mhornsby@ssdspc.com",
      "mm@ssdspc.com",
      "mstewart@ssdspc.com",
      "nteague@ssdspc.com",
      "ocarter@ssdspc.com",
      "powen@ssdspc.com",
      "rhead@ssdspc.com",
      "rkhan@ssdspc.com",
      "romar@ssdspc.com",
      "scripts@ssdspc.com",
      "skhan@ssdspc.com",
      "sriggins@ssdspc.com",
      "ssawyer@ssdspc.com",
      "ssd-automation-service-account@workspace-automation-ssdspc.iam.gserviceaccount.com",
      "sync-sa@ssd-intranet-sync.iam.gserviceaccount.com",
      "tbunton@ssdspc.com",
      "tplatts@ssdspc.com",
      "tthompson@ssdspc.com",
      "twood@ssdspc.com",
      "voicemail@ssdspc.com"
    ]
  },
  {
    "name": "Review the Rescheduling counts daily and make sure there are no pending appointments to be rescheduled for the coming two weeks",
    "description": "Daily Task for Kevin Henriquez (RT-114)",
    "url": "https://docs.google.com/spreadsheets/d/1U-NCToYo2fSAgvW6IPysreusH_I5AGQ1k8BWevTY3HE/edit?gid=2139670133#gid=2139670133",
    "team": "Admin Team, SuperAdmin",
    "assignee": "Kevin Henriquez",
    "code": "RT-114",
    "accessEmails": [
      "admin@ssdspc.com",
      "adminhelp@ssdspc.com",
      "agonzalez@ssdspc.com",
      "arodriguez@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "bwscan@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "documents@ssdspc.com",
      "hangouts-chat-a882a3b4a05f1865@ssdspc.com",
      "jsaluja@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmatthews@ssdspc.com",
      "lsanford@ssdspc.com",
      "mm@ssdspc.com",
      "rkhan@ssdspc.com",
      "scripts@ssdspc.com",
      "skhan@ssdspc.com",
      "ssd-automation-service-account@workspace-automation-ssdspc.iam.gserviceaccount.com",
      "sync-sa@ssd-intranet-sync.iam.gserviceaccount.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Review the billing errors log, check if there's an increase in the errors and if needed collect feedback from Babie and then deliver feedback to the team.",
    "description": "Daily Task for Kevin Henriquez (RT-115)",
    "url": "https://docs.google.com/spreadsheets/d/13289hdlMhe2UxkzWCDbIWYIzVNocvMu5qpPho1TIZYA/edit?gid=350283958#gid=350283958",
    "team": "Admin Team, SuperAdmin",
    "assignee": "Kevin Henriquez",
    "code": "RT-115",
    "accessEmails": [
      "admin@ssdspc.com",
      "adminhelp@ssdspc.com",
      "agonzalez@ssdspc.com",
      "arodriguez@ssdspc.com",
      "awalden@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "bwscan@ssdspc.com",
      "cmartin@ssdspc.com",
      "cthomson@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "documents@ssdspc.com",
      "ehenegar@ssdspc.com",
      "hangouts-chat-a882a3b4a05f1865@ssdspc.com",
      "jsaluja@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmatthews@ssdspc.com",
      "lsanford@ssdspc.com",
      "mbivins@ssdspc.com",
      "mgonzalez@ssdspc.com",
      "mm@ssdspc.com",
      "mstewart@ssdspc.com",
      "ocarter@ssdspc.com",
      "rkhan@ssdspc.com",
      "scripts@ssdspc.com",
      "skhan@ssdspc.com",
      "ssd-automation-service-account@workspace-automation-ssdspc.iam.gserviceaccount.com",
      "sync-sa@ssd-intranet-sync.iam.gserviceaccount.com",
      "tbunton@ssdspc.com",
      "twood@ssdspc.com"
    ]
  },
  {
    "name": "Inbox Zero \u2014 all SSD inboxes (admin@, agonzalez@) + follow-up/waiting label review",
    "description": "Daily Task for Alvaro Gonzalez (RT-140)",
    "url": "https://docs.google.com/spreadsheets/d/1_DKhMaASywqewhlCbjkPqN3N7frxWXIfk0fWEIws41I/edit?gid=0#gid=0",
    "team": "Admin Team, SuperAdmin",
    "assignee": "Alvaro Gonzalez",
    "code": "RT-140",
    "accessEmails": [
      "admin@ssdspc.com",
      "agonzalez@ssdspc.com",
      "arodriguez@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "hangouts-chat-45b23cd19217da44@ssdspc.com",
      "jsaluja@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmatthews@ssdspc.com",
      "mm@ssdspc.com",
      "rkhan@ssdspc.com",
      "skhan@ssdspc.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Morning \u2014 Review personal to-do list and identify top 3 priorities for the day",
    "description": "Daily Task for Alvaro Gonzalez (RT-141)",
    "url": "https://docs.google.com/spreadsheets/d/1omO-ZV6eNns56OpoifD3T75PrAouWhSf6bYdByHs-Cg/edit?gid=1774295471#gid=1774295471",
    "team": "Admin Team, SuperAdmin",
    "assignee": "Alvaro Gonzalez",
    "code": "RT-141",
    "accessEmails": [
      "admin@ssdspc.com",
      "agonzalez@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "8am \u2014 Send Mario domain list and top 3 priorities for the day",
    "description": "Daily Task for Alvaro Gonzalez (RT-142)",
    "url": "https://docs.google.com/spreadsheets/d/1omO-ZV6eNns56OpoifD3T75PrAouWhSf6bYdByHs-Cg/edit?gid=1774295471#gid=1774295471",
    "team": "Admin Team, SuperAdmin",
    "assignee": "Alvaro Gonzalez",
    "code": "RT-142",
    "accessEmails": [
      "admin@ssdspc.com",
      "agonzalez@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "9am \u2014 Review Kevin's top 3 priorities + verify his prior EOD email, lab/billing errors, and denial log",
    "description": "Daily Task for Alvaro Gonzalez (RT-143)",
    "url": "https://docs.google.com/spreadsheets/d/11MKo1xLdUGreNniy5QxKFIJ-zk7dhgYkLKW_bqqVV1g/edit?usp=drivesdkgid=1936079820#gid=1936079820",
    "team": "Admin Team, SuperAdmin",
    "assignee": "Alvaro Gonzalez",
    "code": "RT-143",
    "accessEmails": [
      "aadwell@ssdspc.com",
      "acochran@ssdspc.com",
      "admin@ssdspc.com",
      "adminhelp@ssdspc.com",
      "afloyd@ssdspc.com",
      "agamache@ssdspc.com",
      "agolightly@ssdspc.com",
      "agonzalez@ssdspc.com",
      "ajones@ssdspc.com",
      "aparameswaran@ssdspc.com",
      "appsheet@ssdspc.com",
      "arodriguez@ssdspc.com",
      "automation@ssdspc.com",
      "awalden@ssdspc.com",
      "ayoung@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "bhammonds@ssdspc.com",
      "bherrington@ssdspc.com",
      "bwscan@ssdspc.com",
      "cmartin@ssdspc.com",
      "cthomson@ssdspc.com",
      "dderamus@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "documents@ssdspc.com",
      "dpatel@ssdspc.com",
      "dwalters@ssdspc.com",
      "dyearwood@ssdspc.com",
      "ehenegar@ssdspc.com",
      "estephens@ssdspc.com",
      "fax@ssdspc.com",
      "games@ssdspc.com",
      "gmcmahan@ssdspc.com",
      "hangouts-chat-45b23cd19217da44@ssdspc.com",
      "hangouts-chat-8cf9bcfb23006f2b@ssdspc.com",
      "hangouts-chat-92d059881c6662fc@ssdspc.com",
      "hangouts-chat-a882a3b4a05f1865@ssdspc.com",
      "hdavlin@ssdspc.com",
      "hnicholson@ssdspc.com",
      "hwest@ssdspc.com",
      "jhagan@ssdspc.com",
      "jhamilton@ssdspc.com",
      "jniblack@ssdspc.com",
      "jpayton@ssdspc.com",
      "jreynolds@ssdspc.com",
      "jsaluja@ssdspc.com",
      "kcharles@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmcmurray@ssdspc.com",
      "kparker@ssdspc.com",
      "kparton@ssdspc.com",
      "lmarsh@ssdspc.com",
      "lsanford@ssdspc.com",
      "mbaker@ssdspc.com",
      "mbivins@ssdspc.com",
      "mdowning@ssdspc.com",
      "medmondson@ssdspc.com",
      "mfortner@ssdspc.com",
      "mgonzalez@ssdspc.com",
      "mhornsby@ssdspc.com",
      "mm@ssdspc.com",
      "mstewart@ssdspc.com",
      "nteague@ssdspc.com",
      "ocarter@ssdspc.com",
      "powen@ssdspc.com",
      "rhead@ssdspc.com",
      "rkhan@ssdspc.com",
      "romar@ssdspc.com",
      "scripts@ssdspc.com",
      "skhan@ssdspc.com",
      "sriggins@ssdspc.com",
      "ssawyer@ssdspc.com",
      "ssd-automation-service-account@workspace-automation-ssdspc.iam.gserviceaccount.com",
      "sync-sa@ssd-intranet-sync.iam.gserviceaccount.com",
      "tbunton@ssdspc.com",
      "tplatts@ssdspc.com",
      "tthompson@ssdspc.com",
      "twood@ssdspc.com",
      "voicemail@ssdspc.com"
    ]
  },
  {
    "name": "10am \u2014 Meet with Taegan (Invoices, Payroll, Docs Review, projects) and verify PTO log",
    "description": "Daily Task for Alvaro Gonzalez (RT-144)",
    "url": "https://docs.google.com/spreadsheets/d/1KMsidrbBLL_cc1vmiSozSopW4AMIGTDHMgSNDs0kGYw/edit?usp=drivesdkgid=0#gid=0",
    "team": "Admin Team, SuperAdmin",
    "assignee": "Alvaro Gonzalez",
    "code": "RT-144",
    "accessEmails": [
      "aadwell@ssdspc.com",
      "admin@ssdspc.com",
      "agonzalez@ssdspc.com",
      "arodriguez@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "jsaluja@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmatthews@ssdspc.com",
      "mm@ssdspc.com",
      "rkhan@ssdspc.com",
      "skhan@ssdspc.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "2pm \u2014 Review Master Task Dashboard for progress (Front desk, remote team, admin)",
    "description": "Daily Task for Alvaro Gonzalez (RT-146)",
    "url": "https://docs.google.com/spreadsheets/d/1O4XYjhcagusCGTQctoV9McUFUq3ZjJjB_p6zXWNqckU/edit?gid=1841171914#gid=1841171914",
    "team": "Admin Team, SuperAdmin",
    "assignee": "Alvaro Gonzalez",
    "code": "RT-146",
    "accessEmails": [
      "/namespaced-roster/l=10/chatspaces/hangouts-chat-v1-6682bf4d0f494abd@ssdspc.com",
      "aadwell@ssdspc.com",
      "acochran@ssdspc.com",
      "admin@ssdspc.com",
      "agolightly@ssdspc.com",
      "agonzalez@ssdspc.com",
      "ajones@ssdspc.com",
      "appsheet@ssdspc.com",
      "arodriguez@ssdspc.com",
      "awalden@ssdspc.com",
      "bcurren@ssdspc.com",
      "bhammonds@ssdspc.com",
      "bherrington@ssdspc.com",
      "cthomson@ssdspc.com",
      "dderamus@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "dyearwood@ssdspc.com",
      "estephens@ssdspc.com",
      "fax@ssdspc.com",
      "gmcmahan@ssdspc.com",
      "hangouts-chat-a882a3b4a05f1865@ssdspc.com",
      "hdavlin@ssdspc.com",
      "hnicholson@ssdspc.com",
      "jhagan@ssdspc.com",
      "jhamilton@ssdspc.com",
      "jniblack@ssdspc.com",
      "jpayton@ssdspc.com",
      "jreynolds@ssdspc.com",
      "jsaluja@ssdspc.com",
      "kcharles@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmcmurray@ssdspc.com",
      "kparker@ssdspc.com",
      "lmarsh@ssdspc.com",
      "mdowning@ssdspc.com",
      "medmondson@ssdspc.com",
      "mfortner@ssdspc.com",
      "mgonzalez@ssdspc.com",
      "mm@ssdspc.com",
      "mstewart@ssdspc.com",
      "ocarter@ssdspc.com",
      "powen@ssdspc.com",
      "rkhan@ssdspc.com",
      "romar@ssdspc.com",
      "ssawyer@ssdspc.com",
      "tbunton@ssdspc.com",
      "tplatts@ssdspc.com",
      "tthompson@ssdspc.com",
      "twood@ssdspc.com",
      "voicemail@ssdspc.com"
    ]
  },
  {
    "name": "EOD 3:30pm \u2014 Verify Kevin and Taegan have completed their daily tasks",
    "description": "Daily Task for Alvaro Gonzalez (RT-148)",
    "url": "https://docs.google.com/spreadsheets/d/11MKo1xLdUGreNniy5QxKFIJ-zk7dhgYkLKW_bqqVV1g/edit?usp=drivesdkgid=441734537#gid=441734537",
    "team": "Admin Team, SuperAdmin",
    "assignee": "Alvaro Gonzalez",
    "code": "RT-148",
    "accessEmails": [
      "aadwell@ssdspc.com",
      "acochran@ssdspc.com",
      "admin@ssdspc.com",
      "adminhelp@ssdspc.com",
      "afloyd@ssdspc.com",
      "agamache@ssdspc.com",
      "agolightly@ssdspc.com",
      "agonzalez@ssdspc.com",
      "ajones@ssdspc.com",
      "aparameswaran@ssdspc.com",
      "appsheet@ssdspc.com",
      "arodriguez@ssdspc.com",
      "automation@ssdspc.com",
      "awalden@ssdspc.com",
      "ayoung@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "bhammonds@ssdspc.com",
      "bherrington@ssdspc.com",
      "bwscan@ssdspc.com",
      "cmartin@ssdspc.com",
      "cthomson@ssdspc.com",
      "dderamus@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "documents@ssdspc.com",
      "dpatel@ssdspc.com",
      "dwalters@ssdspc.com",
      "dyearwood@ssdspc.com",
      "ehenegar@ssdspc.com",
      "estephens@ssdspc.com",
      "fax@ssdspc.com",
      "games@ssdspc.com",
      "gmcmahan@ssdspc.com",
      "hangouts-chat-45b23cd19217da44@ssdspc.com",
      "hangouts-chat-8cf9bcfb23006f2b@ssdspc.com",
      "hangouts-chat-92d059881c6662fc@ssdspc.com",
      "hangouts-chat-a882a3b4a05f1865@ssdspc.com",
      "hdavlin@ssdspc.com",
      "hnicholson@ssdspc.com",
      "hwest@ssdspc.com",
      "jhagan@ssdspc.com",
      "jhamilton@ssdspc.com",
      "jniblack@ssdspc.com",
      "jpayton@ssdspc.com",
      "jreynolds@ssdspc.com",
      "jsaluja@ssdspc.com",
      "kcharles@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmcmurray@ssdspc.com",
      "kparker@ssdspc.com",
      "kparton@ssdspc.com",
      "lmarsh@ssdspc.com",
      "lsanford@ssdspc.com",
      "mbaker@ssdspc.com",
      "mbivins@ssdspc.com",
      "mdowning@ssdspc.com",
      "medmondson@ssdspc.com",
      "mfortner@ssdspc.com",
      "mgonzalez@ssdspc.com",
      "mhornsby@ssdspc.com",
      "mm@ssdspc.com",
      "mstewart@ssdspc.com",
      "nteague@ssdspc.com",
      "ocarter@ssdspc.com",
      "powen@ssdspc.com",
      "rhead@ssdspc.com",
      "rkhan@ssdspc.com",
      "romar@ssdspc.com",
      "scripts@ssdspc.com",
      "skhan@ssdspc.com",
      "sriggins@ssdspc.com",
      "ssawyer@ssdspc.com",
      "ssd-automation-service-account@workspace-automation-ssdspc.iam.gserviceaccount.com",
      "sync-sa@ssd-intranet-sync.iam.gserviceaccount.com",
      "tbunton@ssdspc.com",
      "tplatts@ssdspc.com",
      "tthompson@ssdspc.com",
      "twood@ssdspc.com",
      "voicemail@ssdspc.com"
    ]
  },
  {
    "name": "Review daily biopsy log + provider template utilization (90% target) + MA disease-specific protocols",
    "description": "Daily Task for Alvaro Gonzalez (RT-150)",
    "url": "https://docs.google.com/spreadsheets/d/1E86joKsNre89Nx3zUUY6sKawZTLgaF2_wk_blYewgjo/edit?usp=drivesdkgid=19200226#gid=19200226",
    "team": "Admin Team, SuperAdmin",
    "assignee": "Alvaro Gonzalez",
    "code": "RT-150",
    "accessEmails": [
      "aadwell@ssdspc.com",
      "acochran@ssdspc.com",
      "admin@ssdspc.com",
      "agolightly@ssdspc.com",
      "agonzalez@ssdspc.com",
      "ajones@ssdspc.com",
      "appsheet@ssdspc.com",
      "arodriguez@ssdspc.com",
      "awalden@ssdspc.com",
      "bcurren@ssdspc.com",
      "bhammonds@ssdspc.com",
      "bherrington@ssdspc.com",
      "cthomson@ssdspc.com",
      "dderamus@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "dyearwood@ssdspc.com",
      "estephens@ssdspc.com",
      "fax@ssdspc.com",
      "gmcmahan@ssdspc.com",
      "hdavlin@ssdspc.com",
      "hnicholson@ssdspc.com",
      "jhagan@ssdspc.com",
      "jhamilton@ssdspc.com",
      "jniblack@ssdspc.com",
      "jpayton@ssdspc.com",
      "jreynolds@ssdspc.com",
      "jsaluja@ssdspc.com",
      "kcharles@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmcmurray@ssdspc.com",
      "kparker@ssdspc.com",
      "lmarsh@ssdspc.com",
      "mdowning@ssdspc.com",
      "medmondson@ssdspc.com",
      "mfortner@ssdspc.com",
      "mgonzalez@ssdspc.com",
      "mm@ssdspc.com",
      "mstewart@ssdspc.com",
      "ocarter@ssdspc.com",
      "powen@ssdspc.com",
      "rkhan@ssdspc.com",
      "romar@ssdspc.com",
      "ssawyer@ssdspc.com",
      "tbunton@ssdspc.com",
      "tplatts@ssdspc.com",
      "tthompson@ssdspc.com",
      "twood@ssdspc.com",
      "voicemail@ssdspc.com"
    ]
  },
  {
    "name": "EOD \u2014 Send Mario recap of completed work and tomorrow's priorities",
    "description": "Daily Task for Alvaro Gonzalez (RT-155)",
    "url": "https://docs.google.com/spreadsheets/d/1omO-ZV6eNns56OpoifD3T75PrAouWhSf6bYdByHs-Cg/edit?gid=1774295471#gid=1774295471",
    "team": "Admin Team, SuperAdmin",
    "assignee": "Alvaro Gonzalez",
    "code": "RT-155",
    "accessEmails": [
      "admin@ssdspc.com",
      "agonzalez@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "1-on-1 with Kevin \u2014 front desk metrics, MIPS progress, MA training, denial appeals",
    "description": "Daily Task for Alvaro Gonzalez (RT-156)",
    "url": "https://docs.google.com/spreadsheets/d/1omO-ZV6eNns56OpoifD3T75PrAouWhSf6bYdByHs-Cg/edit?gid=1774295471#gid=1774295471",
    "team": "Admin Team, SuperAdmin",
    "assignee": "Alvaro Gonzalez",
    "code": "RT-156",
    "accessEmails": [
      "admin@ssdspc.com",
      "agonzalez@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Address / forward all voicemails in Voicemail Log",
    "description": "Daily Task for Brittney Harrington (AD-2)",
    "url": "https://docs.google.com/spreadsheets/d/1Ej8wzt6U6C-x5Ex9bv0ZRBZs5RFff0Xpi3Zak4r8u4E/edit?usp=drivesdkgid=611001893#gid=611001893",
    "team": "Admin Team",
    "assignee": "Brittney Harrington",
    "code": "AD-2",
    "accessEmails": [
      "aadwell@ssdspc.com",
      "acochran@ssdspc.com",
      "admin@ssdspc.com",
      "adminhelp@ssdspc.com",
      "afloyd@ssdspc.com",
      "agamache@ssdspc.com",
      "agolightly@ssdspc.com",
      "agonzalez@ssdspc.com",
      "ajones@ssdspc.com",
      "aparameswaran@ssdspc.com",
      "appsheet@ssdspc.com",
      "arodriguez@ssdspc.com",
      "automation@ssdspc.com",
      "awalden@ssdspc.com",
      "ayoung@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "bhammonds@ssdspc.com",
      "bharrington@ssdspc.com",
      "bherrington@ssdspc.com",
      "bwscan@ssdspc.com",
      "cmartin@ssdspc.com",
      "cthomson@ssdspc.com",
      "dderamus@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "documents@ssdspc.com",
      "dpatel@ssdspc.com",
      "dwalters@ssdspc.com",
      "dyearwood@ssdspc.com",
      "ehenegar@ssdspc.com",
      "estephens@ssdspc.com",
      "fax@ssdspc.com",
      "games@ssdspc.com",
      "gmcmahan@ssdspc.com",
      "hangouts-chat-3548cceb17795147@ssdspc.com",
      "hangouts-chat-45b23cd19217da44@ssdspc.com",
      "hangouts-chat-8d3ba818a2189894@ssdspc.com",
      "hangouts-chat-a882a3b4a05f1865@ssdspc.com",
      "hdavlin@ssdspc.com",
      "hnicholson@ssdspc.com",
      "hwest@ssdspc.com",
      "jhagan@ssdspc.com",
      "jhamilton@ssdspc.com",
      "jniblack@ssdspc.com",
      "jpayton@ssdspc.com",
      "jreynolds@ssdspc.com",
      "jsaluja@ssdspc.com",
      "kcharles@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmcmurray@ssdspc.com",
      "kparker@ssdspc.com",
      "kparton@ssdspc.com",
      "lmarsh@ssdspc.com",
      "lsanford@ssdspc.com",
      "mbaker@ssdspc.com",
      "mbivins@ssdspc.com",
      "mdowning@ssdspc.com",
      "medmondson@ssdspc.com",
      "mfortner@ssdspc.com",
      "mgonzalez@ssdspc.com",
      "mhornsby@ssdspc.com",
      "mm@ssdspc.com",
      "mstewart@ssdspc.com",
      "nteague@ssdspc.com",
      "ocarter@ssdspc.com",
      "powen@ssdspc.com",
      "rhead@ssdspc.com",
      "rkhan@ssdspc.com",
      "romar@ssdspc.com",
      "scripts@ssdspc.com",
      "skhan@ssdspc.com",
      "sriggins@ssdspc.com",
      "ssawyer@ssdspc.com",
      "ssd-automation-service-account@workspace-automation-ssdspc.iam.gserviceaccount.com",
      "sync-sa@ssd-intranet-sync.iam.gserviceaccount.com",
      "tbunton@ssdspc.com",
      "tplatts@ssdspc.com",
      "tthompson@ssdspc.com",
      "twood@ssdspc.com",
      "voicemail@ssdspc.com"
    ]
  },
  {
    "name": "Review the Incoming fax log",
    "description": "Daily Task for Brittney Harrington (AD-3)",
    "url": "https://docs.google.com/spreadsheets/d/1zaPDKY9rj08HqOsmGHlz52JSf5IJQZtGmK_UusdE8yM/edit?usp=drivesdkgid=0#gid=0",
    "team": "Admin Team",
    "assignee": "Brittney Harrington",
    "code": "AD-3",
    "accessEmails": [
      "admin@ssdspc.com",
      "adminhelp@ssdspc.com",
      "agonzalez@ssdspc.com",
      "arodriguez@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "bharrington@ssdspc.com",
      "bwscan@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "documents@ssdspc.com",
      "fax@ssdspc.com",
      "jsaluja@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmatthews@ssdspc.com",
      "lsanford@ssdspc.com",
      "mm@ssdspc.com",
      "rkhan@ssdspc.com",
      "scripts@ssdspc.com",
      "skhan@ssdspc.com",
      "ssd-automation-service-account@workspace-automation-ssdspc.iam.gserviceaccount.com",
      "sync-sa@ssd-intranet-sync.iam.gserviceaccount.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Review repeat phone call / voicemail log data to try to identify upset patients",
    "description": "Daily Task for Brittney Harrington (AD-4)",
    "url": "https://docs.google.com/spreadsheets/d/1Ej8wzt6U6C-x5Ex9bv0ZRBZs5RFff0Xpi3Zak4r8u4E/edit?usp=drivesdkgid=611001893#gid=611001893",
    "team": "Admin Team",
    "assignee": "Brittney Harrington",
    "code": "AD-4",
    "accessEmails": [
      "aadwell@ssdspc.com",
      "acochran@ssdspc.com",
      "admin@ssdspc.com",
      "adminhelp@ssdspc.com",
      "afloyd@ssdspc.com",
      "agamache@ssdspc.com",
      "agolightly@ssdspc.com",
      "agonzalez@ssdspc.com",
      "ajones@ssdspc.com",
      "aparameswaran@ssdspc.com",
      "appsheet@ssdspc.com",
      "arodriguez@ssdspc.com",
      "automation@ssdspc.com",
      "awalden@ssdspc.com",
      "ayoung@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "bhammonds@ssdspc.com",
      "bharrington@ssdspc.com",
      "bherrington@ssdspc.com",
      "bwscan@ssdspc.com",
      "cmartin@ssdspc.com",
      "cthomson@ssdspc.com",
      "dderamus@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "documents@ssdspc.com",
      "dpatel@ssdspc.com",
      "dwalters@ssdspc.com",
      "dyearwood@ssdspc.com",
      "ehenegar@ssdspc.com",
      "estephens@ssdspc.com",
      "fax@ssdspc.com",
      "games@ssdspc.com",
      "gmcmahan@ssdspc.com",
      "hangouts-chat-3548cceb17795147@ssdspc.com",
      "hangouts-chat-45b23cd19217da44@ssdspc.com",
      "hangouts-chat-8d3ba818a2189894@ssdspc.com",
      "hangouts-chat-a882a3b4a05f1865@ssdspc.com",
      "hdavlin@ssdspc.com",
      "hnicholson@ssdspc.com",
      "hwest@ssdspc.com",
      "jhagan@ssdspc.com",
      "jhamilton@ssdspc.com",
      "jniblack@ssdspc.com",
      "jpayton@ssdspc.com",
      "jreynolds@ssdspc.com",
      "jsaluja@ssdspc.com",
      "kcharles@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmcmurray@ssdspc.com",
      "kparker@ssdspc.com",
      "kparton@ssdspc.com",
      "lmarsh@ssdspc.com",
      "lsanford@ssdspc.com",
      "mbaker@ssdspc.com",
      "mbivins@ssdspc.com",
      "mdowning@ssdspc.com",
      "medmondson@ssdspc.com",
      "mfortner@ssdspc.com",
      "mgonzalez@ssdspc.com",
      "mhornsby@ssdspc.com",
      "mm@ssdspc.com",
      "mstewart@ssdspc.com",
      "nteague@ssdspc.com",
      "ocarter@ssdspc.com",
      "powen@ssdspc.com",
      "rhead@ssdspc.com",
      "rkhan@ssdspc.com",
      "romar@ssdspc.com",
      "scripts@ssdspc.com",
      "skhan@ssdspc.com",
      "sriggins@ssdspc.com",
      "ssawyer@ssdspc.com",
      "ssd-automation-service-account@workspace-automation-ssdspc.iam.gserviceaccount.com",
      "sync-sa@ssd-intranet-sync.iam.gserviceaccount.com",
      "tbunton@ssdspc.com",
      "tplatts@ssdspc.com",
      "tthompson@ssdspc.com",
      "twood@ssdspc.com",
      "voicemail@ssdspc.com"
    ]
  },
  {
    "name": "Review Klara Voicemail inbox",
    "description": "Daily Task for Brittney Harrington (AD-12)",
    "url": "https://docs.google.com/spreadsheets/d/1Ej8wzt6U6C-x5Ex9bv0ZRBZs5RFff0Xpi3Zak4r8u4E/edit?usp=drivesdkgid=611001893#gid=611001893",
    "team": "Admin Team",
    "assignee": "Brittney Harrington",
    "code": "AD-12",
    "accessEmails": [
      "aadwell@ssdspc.com",
      "acochran@ssdspc.com",
      "admin@ssdspc.com",
      "adminhelp@ssdspc.com",
      "afloyd@ssdspc.com",
      "agamache@ssdspc.com",
      "agolightly@ssdspc.com",
      "agonzalez@ssdspc.com",
      "ajones@ssdspc.com",
      "aparameswaran@ssdspc.com",
      "appsheet@ssdspc.com",
      "arodriguez@ssdspc.com",
      "automation@ssdspc.com",
      "awalden@ssdspc.com",
      "ayoung@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "bhammonds@ssdspc.com",
      "bharrington@ssdspc.com",
      "bherrington@ssdspc.com",
      "bwscan@ssdspc.com",
      "cmartin@ssdspc.com",
      "cthomson@ssdspc.com",
      "dderamus@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "documents@ssdspc.com",
      "dpatel@ssdspc.com",
      "dwalters@ssdspc.com",
      "dyearwood@ssdspc.com",
      "ehenegar@ssdspc.com",
      "estephens@ssdspc.com",
      "fax@ssdspc.com",
      "games@ssdspc.com",
      "gmcmahan@ssdspc.com",
      "hangouts-chat-3548cceb17795147@ssdspc.com",
      "hangouts-chat-45b23cd19217da44@ssdspc.com",
      "hangouts-chat-8d3ba818a2189894@ssdspc.com",
      "hangouts-chat-a882a3b4a05f1865@ssdspc.com",
      "hdavlin@ssdspc.com",
      "hnicholson@ssdspc.com",
      "hwest@ssdspc.com",
      "jhagan@ssdspc.com",
      "jhamilton@ssdspc.com",
      "jniblack@ssdspc.com",
      "jpayton@ssdspc.com",
      "jreynolds@ssdspc.com",
      "jsaluja@ssdspc.com",
      "kcharles@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmcmurray@ssdspc.com",
      "kparker@ssdspc.com",
      "kparton@ssdspc.com",
      "lmarsh@ssdspc.com",
      "lsanford@ssdspc.com",
      "mbaker@ssdspc.com",
      "mbivins@ssdspc.com",
      "mdowning@ssdspc.com",
      "medmondson@ssdspc.com",
      "mfortner@ssdspc.com",
      "mgonzalez@ssdspc.com",
      "mhornsby@ssdspc.com",
      "mm@ssdspc.com",
      "mstewart@ssdspc.com",
      "nteague@ssdspc.com",
      "ocarter@ssdspc.com",
      "powen@ssdspc.com",
      "rhead@ssdspc.com",
      "rkhan@ssdspc.com",
      "romar@ssdspc.com",
      "scripts@ssdspc.com",
      "skhan@ssdspc.com",
      "sriggins@ssdspc.com",
      "ssawyer@ssdspc.com",
      "ssd-automation-service-account@workspace-automation-ssdspc.iam.gserviceaccount.com",
      "sync-sa@ssd-intranet-sync.iam.gserviceaccount.com",
      "tbunton@ssdspc.com",
      "tplatts@ssdspc.com",
      "tthompson@ssdspc.com",
      "twood@ssdspc.com",
      "voicemail@ssdspc.com"
    ]
  },
  {
    "name": "Review Cancer Policy Log",
    "description": "Daily Task for Brittney Harrington (AD-14)",
    "url": "https://docs.google.com/spreadsheets/d/1omO-ZV6eNns56OpoifD3T75PrAouWhSf6bYdByHs-Cg/edit?gid=1774295471#gid=1774295471",
    "team": "Admin Team",
    "assignee": "Brittney Harrington",
    "code": "AD-14",
    "accessEmails": [
      "admin@ssdspc.com",
      "agonzalez@ssdspc.com",
      "bharrington@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Lab Tracking Sheet - All lab results received were updated in tracking sheet",
    "description": "Daily Task for Brittney Harrington (AD-15)",
    "url": "https://docs.google.com/spreadsheets/d/1rmGaWR9e3y5PdNvGe2D5SDgKjJip4uyG34EQOxnIEGw/edit?usp=drivesdkgid=2005694930#gid=2005694930",
    "team": "Admin Team",
    "assignee": "Brittney Harrington",
    "code": "AD-15",
    "accessEmails": [
      "aadwell@ssdspc.com",
      "acochran@ssdspc.com",
      "admin@ssdspc.com",
      "adminhelp@ssdspc.com",
      "afloyd@ssdspc.com",
      "agamache@ssdspc.com",
      "agolightly@ssdspc.com",
      "agonzalez@ssdspc.com",
      "ajones@ssdspc.com",
      "aparameswaran@ssdspc.com",
      "appsheet@ssdspc.com",
      "arodriguez@ssdspc.com",
      "automation@ssdspc.com",
      "awalden@ssdspc.com",
      "ayoung@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "bhammonds@ssdspc.com",
      "bharrington@ssdspc.com",
      "bherrington@ssdspc.com",
      "bwscan@ssdspc.com",
      "cmartin@ssdspc.com",
      "cthomson@ssdspc.com",
      "dderamus@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "documents@ssdspc.com",
      "domain:ssdspc.com",
      "dpatel@ssdspc.com",
      "dwalters@ssdspc.com",
      "dyearwood@ssdspc.com",
      "ehenegar@ssdspc.com",
      "estephens@ssdspc.com",
      "fax@ssdspc.com",
      "games@ssdspc.com",
      "gmcmahan@ssdspc.com",
      "hdavlin@ssdspc.com",
      "hnicholson@ssdspc.com",
      "hwest@ssdspc.com",
      "jhagan@ssdspc.com",
      "jhamilton@ssdspc.com",
      "jniblack@ssdspc.com",
      "jpayton@ssdspc.com",
      "jreynolds@ssdspc.com",
      "jsaluja@ssdspc.com",
      "kcharles@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmcmurray@ssdspc.com",
      "kparker@ssdspc.com",
      "kparton@ssdspc.com",
      "lmarsh@ssdspc.com",
      "lsanford@ssdspc.com",
      "mbaker@ssdspc.com",
      "mbivins@ssdspc.com",
      "mdowning@ssdspc.com",
      "medmondson@ssdspc.com",
      "mfortner@ssdspc.com",
      "mgonzalez@ssdspc.com",
      "mhornsby@ssdspc.com",
      "mm@ssdspc.com",
      "mstewart@ssdspc.com",
      "nteague@ssdspc.com",
      "ocarter@ssdspc.com",
      "powen@ssdspc.com",
      "rhead@ssdspc.com",
      "rkhan@ssdspc.com",
      "romar@ssdspc.com",
      "scripts@ssdspc.com",
      "skhan@ssdspc.com",
      "sriggins@ssdspc.com",
      "ssawyer@ssdspc.com",
      "ssd-automation-service-account@workspace-automation-ssdspc.iam.gserviceaccount.com",
      "sync-sa@ssd-intranet-sync.iam.gserviceaccount.com",
      "tbunton@ssdspc.com",
      "tplatts@ssdspc.com",
      "tthompson@ssdspc.com",
      "twood@ssdspc.com",
      "voicemail@ssdspc.com"
    ]
  },
  {
    "name": "Wound Culture Tracking Sheet - All wound culture results updated tracking sheet",
    "description": "Daily Task for Brittney Harrington (AD-16)",
    "url": "https://docs.google.com/spreadsheets/d/1rmGaWR9e3y5PdNvGe2D5SDgKjJip4uyG34EQOxnIEGw/edit?usp=drivesdkgid=1231086265#gid=1231086265",
    "team": "Admin Team",
    "assignee": "Brittney Harrington",
    "code": "AD-16",
    "accessEmails": [
      "aadwell@ssdspc.com",
      "acochran@ssdspc.com",
      "admin@ssdspc.com",
      "adminhelp@ssdspc.com",
      "afloyd@ssdspc.com",
      "agamache@ssdspc.com",
      "agolightly@ssdspc.com",
      "agonzalez@ssdspc.com",
      "ajones@ssdspc.com",
      "aparameswaran@ssdspc.com",
      "appsheet@ssdspc.com",
      "arodriguez@ssdspc.com",
      "automation@ssdspc.com",
      "awalden@ssdspc.com",
      "ayoung@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "bhammonds@ssdspc.com",
      "bharrington@ssdspc.com",
      "bherrington@ssdspc.com",
      "bwscan@ssdspc.com",
      "cmartin@ssdspc.com",
      "cthomson@ssdspc.com",
      "dderamus@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "documents@ssdspc.com",
      "domain:ssdspc.com",
      "dpatel@ssdspc.com",
      "dwalters@ssdspc.com",
      "dyearwood@ssdspc.com",
      "ehenegar@ssdspc.com",
      "estephens@ssdspc.com",
      "fax@ssdspc.com",
      "games@ssdspc.com",
      "gmcmahan@ssdspc.com",
      "hdavlin@ssdspc.com",
      "hnicholson@ssdspc.com",
      "hwest@ssdspc.com",
      "jhagan@ssdspc.com",
      "jhamilton@ssdspc.com",
      "jniblack@ssdspc.com",
      "jpayton@ssdspc.com",
      "jreynolds@ssdspc.com",
      "jsaluja@ssdspc.com",
      "kcharles@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmcmurray@ssdspc.com",
      "kparker@ssdspc.com",
      "kparton@ssdspc.com",
      "lmarsh@ssdspc.com",
      "lsanford@ssdspc.com",
      "mbaker@ssdspc.com",
      "mbivins@ssdspc.com",
      "mdowning@ssdspc.com",
      "medmondson@ssdspc.com",
      "mfortner@ssdspc.com",
      "mgonzalez@ssdspc.com",
      "mhornsby@ssdspc.com",
      "mm@ssdspc.com",
      "mstewart@ssdspc.com",
      "nteague@ssdspc.com",
      "ocarter@ssdspc.com",
      "powen@ssdspc.com",
      "rhead@ssdspc.com",
      "rkhan@ssdspc.com",
      "romar@ssdspc.com",
      "scripts@ssdspc.com",
      "skhan@ssdspc.com",
      "sriggins@ssdspc.com",
      "ssawyer@ssdspc.com",
      "ssd-automation-service-account@workspace-automation-ssdspc.iam.gserviceaccount.com",
      "sync-sa@ssd-intranet-sync.iam.gserviceaccount.com",
      "tbunton@ssdspc.com",
      "tplatts@ssdspc.com",
      "tthompson@ssdspc.com",
      "twood@ssdspc.com",
      "voicemail@ssdspc.com"
    ]
  },
  {
    "name": "Call patients from the contact web form",
    "description": "Daily Task for Brittney Harrington (AD-17)",
    "url": "https://docs.google.com/spreadsheets/d/1omO-ZV6eNns56OpoifD3T75PrAouWhSf6bYdByHs-Cg/edit?gid=1774295471#gid=1774295471",
    "team": "Admin Team",
    "assignee": "Brittney Harrington",
    "code": "AD-17",
    "accessEmails": [
      "admin@ssdspc.com",
      "agonzalez@ssdspc.com",
      "bharrington@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Make second call attempts to patients from the Contact Web Form",
    "description": "Daily Task for Brittney Harrington (AD-11)",
    "url": "https://docs.google.com/spreadsheets/d/1omO-ZV6eNns56OpoifD3T75PrAouWhSf6bYdByHs-Cg/edit?gid=1774295471#gid=1774295471",
    "team": "Admin Team",
    "assignee": "Brittney Harrington",
    "code": "AD-11",
    "accessEmails": [
      "admin@ssdspc.com",
      "agonzalez@ssdspc.com",
      "bharrington@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Review the Incoming Referral Log",
    "description": "Daily Task for Tabatha Platts (AD-7) \u2014 Incoming Referral Dashboard - Master Incoming Referral List",
    "url": "https://docs.google.com/spreadsheets/d/1hAOhyS0Y_gTha-FlKAFz1UT7L9FKWuLORWAyQsX4lgw/edit#gid=0",
    "team": "Admin Team",
    "assignee": "Tabatha Platts",
    "code": "AD-7",
    "accessEmails": [
      "aadwell@ssdspc.com",
      "acochran@ssdspc.com",
      "admin@ssdspc.com",
      "agolightly@ssdspc.com",
      "agonzalez@ssdspc.com",
      "ajones@ssdspc.com",
      "appsheet@ssdspc.com",
      "arodriguez@ssdspc.com",
      "awalden@ssdspc.com",
      "bcurren@ssdspc.com",
      "bhammonds@ssdspc.com",
      "bherrington@ssdspc.com",
      "cthomson@ssdspc.com",
      "dderamus@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "dyearwood@ssdspc.com",
      "estephens@ssdspc.com",
      "fax@ssdspc.com",
      "gmcmahan@ssdspc.com",
      "hdavlin@ssdspc.com",
      "hnicholson@ssdspc.com",
      "jhagan@ssdspc.com",
      "jhamilton@ssdspc.com",
      "jniblack@ssdspc.com",
      "jpayton@ssdspc.com",
      "jreynolds@ssdspc.com",
      "jsaluja@ssdspc.com",
      "kcharles@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmcmurray@ssdspc.com",
      "kparker@ssdspc.com",
      "lmarsh@ssdspc.com",
      "mdowning@ssdspc.com",
      "medmondson@ssdspc.com",
      "mfortner@ssdspc.com",
      "mgonzalez@ssdspc.com",
      "mm@ssdspc.com",
      "mstewart@ssdspc.com",
      "ocarter@ssdspc.com",
      "powen@ssdspc.com",
      "rkhan@ssdspc.com",
      "romar@ssdspc.com",
      "ssawyer@ssdspc.com",
      "tbunton@ssdspc.com",
      "tplatts@ssdspc.com",
      "tthompson@ssdspc.com",
      "twood@ssdspc.com",
      "voicemail@ssdspc.com"
    ]
  },
  {
    "name": "Review Repeat Caller tab on Voicemail Log (>2 for day, >3 repeat calls for week)",
    "description": "Daily Task for Tabatha Platts (AD-5) \u2014 Voicemail Log - Repeat Caller Tab",
    "url": "https://docs.google.com/spreadsheets/d/1Ej8wzt6U6C-x5Ex9bv0ZRBZs5RFff0Xpi3Zak4r8u4E/edit?gid=611001893#gid=611001893",
    "team": "Admin Team",
    "assignee": "Tabatha Platts",
    "code": "AD-5",
    "accessEmails": [
      "aadwell@ssdspc.com",
      "acochran@ssdspc.com",
      "admin@ssdspc.com",
      "adminhelp@ssdspc.com",
      "afloyd@ssdspc.com",
      "agamache@ssdspc.com",
      "agolightly@ssdspc.com",
      "agonzalez@ssdspc.com",
      "ajones@ssdspc.com",
      "aparameswaran@ssdspc.com",
      "appsheet@ssdspc.com",
      "arodriguez@ssdspc.com",
      "automation@ssdspc.com",
      "awalden@ssdspc.com",
      "ayoung@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "bhammonds@ssdspc.com",
      "bherrington@ssdspc.com",
      "bwscan@ssdspc.com",
      "cmartin@ssdspc.com",
      "cthomson@ssdspc.com",
      "dderamus@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "documents@ssdspc.com",
      "dpatel@ssdspc.com",
      "dwalters@ssdspc.com",
      "dyearwood@ssdspc.com",
      "ehenegar@ssdspc.com",
      "estephens@ssdspc.com",
      "fax@ssdspc.com",
      "games@ssdspc.com",
      "gmcmahan@ssdspc.com",
      "hangouts-chat-3548cceb17795147@ssdspc.com",
      "hangouts-chat-45b23cd19217da44@ssdspc.com",
      "hangouts-chat-8d3ba818a2189894@ssdspc.com",
      "hangouts-chat-a882a3b4a05f1865@ssdspc.com",
      "hdavlin@ssdspc.com",
      "hnicholson@ssdspc.com",
      "hwest@ssdspc.com",
      "jhagan@ssdspc.com",
      "jhamilton@ssdspc.com",
      "jniblack@ssdspc.com",
      "jpayton@ssdspc.com",
      "jreynolds@ssdspc.com",
      "jsaluja@ssdspc.com",
      "kcharles@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmcmurray@ssdspc.com",
      "kparker@ssdspc.com",
      "kparton@ssdspc.com",
      "lmarsh@ssdspc.com",
      "lsanford@ssdspc.com",
      "mbaker@ssdspc.com",
      "mbivins@ssdspc.com",
      "mdowning@ssdspc.com",
      "medmondson@ssdspc.com",
      "mfortner@ssdspc.com",
      "mgonzalez@ssdspc.com",
      "mhornsby@ssdspc.com",
      "mm@ssdspc.com",
      "mstewart@ssdspc.com",
      "nteague@ssdspc.com",
      "ocarter@ssdspc.com",
      "powen@ssdspc.com",
      "rhead@ssdspc.com",
      "rkhan@ssdspc.com",
      "romar@ssdspc.com",
      "scripts@ssdspc.com",
      "skhan@ssdspc.com",
      "sriggins@ssdspc.com",
      "ssawyer@ssdspc.com",
      "ssd-automation-service-account@workspace-automation-ssdspc.iam.gserviceaccount.com",
      "sync-sa@ssd-intranet-sync.iam.gserviceaccount.com",
      "tbunton@ssdspc.com",
      "tplatts@ssdspc.com",
      "tthompson@ssdspc.com",
      "twood@ssdspc.com",
      "voicemail@ssdspc.com"
    ]
  },
  {
    "name": "Review the website request log (all forms from the website)",
    "description": "Daily Task for Tabatha Platts (AD-6) \u2014 Website Form Submissions - Appointment tab",
    "url": "https://docs.google.com/spreadsheets/d/18Hp0KC0E8q-NGk4ReAb32ebKHyOIp13XwNEa3EW6oTs/edit?gid=462378666#gid=462378666",
    "team": "Admin Team",
    "assignee": "Tabatha Platts",
    "code": "AD-6",
    "accessEmails": [
      "aadwell@ssdspc.com",
      "acochran@ssdspc.com",
      "admin@ssdspc.com",
      "agolightly@ssdspc.com",
      "agonzalez@ssdspc.com",
      "ajones@ssdspc.com",
      "appsheet@ssdspc.com",
      "arodriguez@ssdspc.com",
      "awalden@ssdspc.com",
      "bcurren@ssdspc.com",
      "bhammonds@ssdspc.com",
      "bherrington@ssdspc.com",
      "cthomson@ssdspc.com",
      "dderamus@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "dyearwood@ssdspc.com",
      "estephens@ssdspc.com",
      "fax@ssdspc.com",
      "gmcmahan@ssdspc.com",
      "hangouts-chat-f97baa00f008d03f@ssdspc.com",
      "hdavlin@ssdspc.com",
      "hnicholson@ssdspc.com",
      "jhagan@ssdspc.com",
      "jhamilton@ssdspc.com",
      "jniblack@ssdspc.com",
      "jpayton@ssdspc.com",
      "jreynolds@ssdspc.com",
      "jsaluja@ssdspc.com",
      "kcharles@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmcmurray@ssdspc.com",
      "kparker@ssdspc.com",
      "lmarsh@ssdspc.com",
      "mdowning@ssdspc.com",
      "medmondson@ssdspc.com",
      "mfortner@ssdspc.com",
      "mgonzalez@ssdspc.com",
      "mm@ssdspc.com",
      "mstewart@ssdspc.com",
      "ocarter@ssdspc.com",
      "powen@ssdspc.com",
      "rkhan@ssdspc.com",
      "romar@ssdspc.com",
      "ssawyer@ssdspc.com",
      "tbunton@ssdspc.com",
      "tplatts@ssdspc.com",
      "tthompson@ssdspc.com",
      "twood@ssdspc.com",
      "voicemail@ssdspc.com"
    ]
  },
  {
    "name": "End of Day - Help complete other admin team members' tasks (if needed)",
    "description": "Daily Task for Tabatha Platts (AD-13)",
    "url": "https://docs.google.com/spreadsheets/d/1omO-ZV6eNns56OpoifD3T75PrAouWhSf6bYdByHs-Cg/edit?gid=1774295471#gid=1774295471",
    "team": "Admin Team",
    "assignee": "Tabatha Platts",
    "code": "AD-13",
    "accessEmails": [
      "admin@ssdspc.com",
      "agonzalez@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "tbunton@ssdspc.com",
      "tplatts@ssdspc.com"
    ]
  },
  {
    "name": "Take a moment to review the agenda for the day: Maintenance items, IT tasks,  deliveries, travels, follow up with vendors, emails, chats and calls.",
    "description": "Daily Task for Adam Adwell (AD-21)",
    "url": "https://docs.google.com/spreadsheets/d/1omO-ZV6eNns56OpoifD3T75PrAouWhSf6bYdByHs-Cg/edit?gid=1774295471#gid=1774295471",
    "team": "Facilities Management, Admin Team",
    "assignee": "Adam Adwell",
    "code": "AD-21",
    "accessEmails": [
      "aadwell@ssdspc.com",
      "admin@ssdspc.com",
      "agonzalez@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Scan ALL received physical mail",
    "description": "Daily Task for Adam Adwell (AD-8) \u2014 Scanned Mail Log - Manual Mail Count",
    "url": "https://docs.google.com/spreadsheets/d/1_GkRicPW4sPidH6H6hIRUFNDypfHJpOs_xaWyTZafiU/edit?gid=1796154287#gid=1796154287",
    "team": "Facilities Management, Admin Team",
    "assignee": "Adam Adwell",
    "code": "AD-8",
    "accessEmails": [
      "aadwell@ssdspc.com",
      "admin@ssdspc.com",
      "adminhelp@ssdspc.com",
      "agonzalez@ssdspc.com",
      "arodriguez@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "bwscan@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "documents@ssdspc.com",
      "jsaluja@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmatthews@ssdspc.com",
      "lsanford@ssdspc.com",
      "mm@ssdspc.com",
      "rkhan@ssdspc.com",
      "scripts@ssdspc.com",
      "skhan@ssdspc.com",
      "ssd-automation-service-account@workspace-automation-ssdspc.iam.gserviceaccount.com",
      "sync-sa@ssd-intranet-sync.iam.gserviceaccount.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Add the count of the scanned mail to the Scanned Mail Log",
    "description": "Daily Task for Adam Adwell (AD-18) \u2014 Scanned Mail Log - Sheet - S25-329 - Active",
    "url": "https://docs.google.com/spreadsheets/d/1_GkRicPW4sPidH6H6hIRUFNDypfHJpOs_xaWyTZafiU/edit?gid=0#gid=0",
    "team": "Facilities Management, Admin Team",
    "assignee": "Adam Adwell",
    "code": "AD-18",
    "accessEmails": [
      "aadwell@ssdspc.com",
      "admin@ssdspc.com",
      "adminhelp@ssdspc.com",
      "agonzalez@ssdspc.com",
      "arodriguez@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "bwscan@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "documents@ssdspc.com",
      "jsaluja@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmatthews@ssdspc.com",
      "lsanford@ssdspc.com",
      "mm@ssdspc.com",
      "rkhan@ssdspc.com",
      "scripts@ssdspc.com",
      "skhan@ssdspc.com",
      "ssd-automation-service-account@workspace-automation-ssdspc.iam.gserviceaccount.com",
      "sync-sa@ssd-intranet-sync.iam.gserviceaccount.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Place outgoing mail in the Mailbox",
    "description": "Daily Task for Adam Adwell (AD-9)",
    "url": "https://docs.google.com/spreadsheets/d/1omO-ZV6eNns56OpoifD3T75PrAouWhSf6bYdByHs-Cg/edit?gid=1774295471#gid=1774295471",
    "team": "Facilities Management, Admin Team",
    "assignee": "Adam Adwell",
    "code": "AD-9",
    "accessEmails": [
      "aadwell@ssdspc.com",
      "admin@ssdspc.com",
      "agonzalez@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Log all outgoing Certified Mail",
    "description": "Daily Task for Adam Adwell (AD-10)",
    "url": "https://docs.google.com/spreadsheets/d/1omO-ZV6eNns56OpoifD3T75PrAouWhSf6bYdByHs-Cg/edit?gid=1774295471#gid=1774295471",
    "team": "Facilities Management, Admin Team",
    "assignee": "Adam Adwell",
    "code": "AD-10",
    "accessEmails": [
      "aadwell@ssdspc.com",
      "admin@ssdspc.com",
      "agonzalez@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Send a daily summary of tasks done",
    "description": "Daily Task for Adam Adwell (AD-19)",
    "url": "https://docs.google.com/spreadsheets/d/1omO-ZV6eNns56OpoifD3T75PrAouWhSf6bYdByHs-Cg/edit?gid=1774295471#gid=1774295471",
    "team": "Facilities Management, Admin Team",
    "assignee": "Adam Adwell",
    "code": "AD-19",
    "accessEmails": [
      "aadwell@ssdspc.com",
      "admin@ssdspc.com",
      "agonzalez@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Add the list of items received by mail every day",
    "description": "Daily Task for Adam Adwell (AD-20)",
    "url": "https://docs.google.com/spreadsheets/d/1omO-ZV6eNns56OpoifD3T75PrAouWhSf6bYdByHs-Cg/edit?gid=1774295471#gid=1774295471",
    "team": "Facilities Management, Admin Team",
    "assignee": "Adam Adwell",
    "code": "AD-20",
    "accessEmails": [
      "aadwell@ssdspc.com",
      "admin@ssdspc.com",
      "agonzalez@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Surgery Scheduling - Scheduling attempt counts to be sent Tuesday and Friday by 9am",
    "description": "Daily Task for Aleisha Jones (SS-1)",
    "url": "https://docs.google.com/spreadsheets/d/1omO-ZV6eNns56OpoifD3T75PrAouWhSf6bYdByHs-Cg/edit?gid=1774295471#gid=1774295471",
    "team": "Admin Team, Operations",
    "assignee": "Aleisha Jones",
    "code": "SS-1",
    "accessEmails": [
      "admin@ssdspc.com",
      "agonzalez@ssdspc.com",
      "ajones@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "End of Day - Help complete other admin team members' tasks (if needed)",
    "description": "Daily Task for Aleisha Jones (SS-2)",
    "url": "https://docs.google.com/spreadsheets/d/1omO-ZV6eNns56OpoifD3T75PrAouWhSf6bYdByHs-Cg/edit?gid=1774295471#gid=1774295471",
    "team": "Admin Team, Operations",
    "assignee": "Aleisha Jones",
    "code": "SS-2",
    "accessEmails": [
      "admin@ssdspc.com",
      "agonzalez@ssdspc.com",
      "ajones@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Check on Dr. M's Surgery Patient's from Previous Day",
    "description": "Daily Task for Dr. M's Team (SMA-1)",
    "url": "https://docs.google.com/spreadsheets/d/1omO-ZV6eNns56OpoifD3T75PrAouWhSf6bYdByHs-Cg/edit?gid=1774295471#gid=1774295471",
    "team": "Clinical, Providers",
    "assignee": "Dr. M's Team",
    "code": "SMA-1",
    "accessEmails": [
      "admin@ssdspc.com",
      "agonzalez@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "mm@ssdspc.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Check on Dr. M's Surgery Patient's from Previous Day",
    "description": "Daily Task for Dr. D's Team (SMA-2)",
    "url": "https://docs.google.com/spreadsheets/d/1omO-ZV6eNns56OpoifD3T75PrAouWhSf6bYdByHs-Cg/edit?gid=1774295471#gid=1774295471",
    "team": "Clinical, Providers",
    "assignee": "Dr. D's Team",
    "code": "SMA-2",
    "accessEmails": [
      "admin@ssdspc.com",
      "agonzalez@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "drd@ssdspc.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Check EMA Path Results Assigned to MA to Call in EMA",
    "description": "Daily Task for Dr. D's Team (SMA-14)",
    "url": "https://docs.google.com/spreadsheets/d/1omO-ZV6eNns56OpoifD3T75PrAouWhSf6bYdByHs-Cg/edit?gid=1774295471#gid=1774295471",
    "team": "Clinical, Providers",
    "assignee": "Dr. D's Team",
    "code": "SMA-14",
    "accessEmails": [
      "admin@ssdspc.com",
      "agonzalez@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "drd@ssdspc.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Check Surgery Voicemails",
    "description": "Daily Task for Dr. D's Team (SMA-15)",
    "url": "https://docs.google.com/spreadsheets/d/1Ej8wzt6U6C-x5Ex9bv0ZRBZs5RFff0Xpi3Zak4r8u4E/edit?gid=611001893#gid=611001893",
    "team": "Clinical, Providers",
    "assignee": "Dr. D's Team",
    "code": "SMA-15",
    "accessEmails": [
      "aadwell@ssdspc.com",
      "acochran@ssdspc.com",
      "admin@ssdspc.com",
      "adminhelp@ssdspc.com",
      "afloyd@ssdspc.com",
      "agamache@ssdspc.com",
      "agolightly@ssdspc.com",
      "agonzalez@ssdspc.com",
      "ajones@ssdspc.com",
      "aparameswaran@ssdspc.com",
      "appsheet@ssdspc.com",
      "arodriguez@ssdspc.com",
      "automation@ssdspc.com",
      "awalden@ssdspc.com",
      "ayoung@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "bhammonds@ssdspc.com",
      "bherrington@ssdspc.com",
      "bwscan@ssdspc.com",
      "cmartin@ssdspc.com",
      "cthomson@ssdspc.com",
      "dderamus@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "documents@ssdspc.com",
      "dpatel@ssdspc.com",
      "drd@ssdspc.com",
      "dwalters@ssdspc.com",
      "dyearwood@ssdspc.com",
      "ehenegar@ssdspc.com",
      "estephens@ssdspc.com",
      "fax@ssdspc.com",
      "games@ssdspc.com",
      "gmcmahan@ssdspc.com",
      "hangouts-chat-3548cceb17795147@ssdspc.com",
      "hangouts-chat-45b23cd19217da44@ssdspc.com",
      "hangouts-chat-8d3ba818a2189894@ssdspc.com",
      "hangouts-chat-a882a3b4a05f1865@ssdspc.com",
      "hdavlin@ssdspc.com",
      "hnicholson@ssdspc.com",
      "hwest@ssdspc.com",
      "jhagan@ssdspc.com",
      "jhamilton@ssdspc.com",
      "jniblack@ssdspc.com",
      "jpayton@ssdspc.com",
      "jreynolds@ssdspc.com",
      "jsaluja@ssdspc.com",
      "kcharles@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmcmurray@ssdspc.com",
      "kparker@ssdspc.com",
      "kparton@ssdspc.com",
      "lmarsh@ssdspc.com",
      "lsanford@ssdspc.com",
      "mbaker@ssdspc.com",
      "mbivins@ssdspc.com",
      "mdowning@ssdspc.com",
      "medmondson@ssdspc.com",
      "mfortner@ssdspc.com",
      "mgonzalez@ssdspc.com",
      "mhornsby@ssdspc.com",
      "mm@ssdspc.com",
      "mstewart@ssdspc.com",
      "nteague@ssdspc.com",
      "ocarter@ssdspc.com",
      "powen@ssdspc.com",
      "rhead@ssdspc.com",
      "rkhan@ssdspc.com",
      "romar@ssdspc.com",
      "scripts@ssdspc.com",
      "skhan@ssdspc.com",
      "sriggins@ssdspc.com",
      "ssawyer@ssdspc.com",
      "ssd-automation-service-account@workspace-automation-ssdspc.iam.gserviceaccount.com",
      "sync-sa@ssd-intranet-sync.iam.gserviceaccount.com",
      "tbunton@ssdspc.com",
      "tplatts@ssdspc.com",
      "tthompson@ssdspc.com",
      "twood@ssdspc.com",
      "voicemail@ssdspc.com"
    ]
  },
  {
    "name": "Check Surgery Team Text Line via Clearly App",
    "description": "Daily Task for Dr. D's Team (SMA-16)",
    "url": "https://docs.google.com/spreadsheets/d/1omO-ZV6eNns56OpoifD3T75PrAouWhSf6bYdByHs-Cg/edit?gid=1774295471#gid=1774295471",
    "team": "Clinical, Providers",
    "assignee": "Dr. D's Team",
    "code": "SMA-16",
    "accessEmails": [
      "admin@ssdspc.com",
      "agonzalez@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "drd@ssdspc.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Chceck EMA Tasks/Mail through EMA",
    "description": "Daily Task for Dr. D's Team (SMA-17)",
    "url": "https://docs.google.com/spreadsheets/d/1omO-ZV6eNns56OpoifD3T75PrAouWhSf6bYdByHs-Cg/edit?gid=1774295471#gid=1774295471",
    "team": "Clinical, Providers",
    "assignee": "Dr. D's Team",
    "code": "SMA-17",
    "accessEmails": [
      "admin@ssdspc.com",
      "agonzalez@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "drd@ssdspc.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Make Sure All Sites Were Added to Treated Spots Log under Pre-gen Maps and Treatment Log",
    "description": "Daily Task for Dr. D's Team (SMA-18)",
    "url": "https://docs.google.com/spreadsheets/d/1ifDXtZwCd8CK1Ag76MqomvIIm5IGx9qoliyKapzc9WE/edit?gid=1412037695#gid=1412037695",
    "team": "Clinical, Providers",
    "assignee": "Dr. D's Team",
    "code": "SMA-18",
    "accessEmails": [
      "aadwell@ssdspc.com",
      "acochran@ssdspc.com",
      "admin@ssdspc.com",
      "agolightly@ssdspc.com",
      "agonzalez@ssdspc.com",
      "ajones@ssdspc.com",
      "appsheet@ssdspc.com",
      "arodriguez@ssdspc.com",
      "awalden@ssdspc.com",
      "bcurren@ssdspc.com",
      "bhammonds@ssdspc.com",
      "bherrington@ssdspc.com",
      "cthomson@ssdspc.com",
      "dderamus@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "drd@ssdspc.com",
      "dyearwood@ssdspc.com",
      "estephens@ssdspc.com",
      "fax@ssdspc.com",
      "gmcmahan@ssdspc.com",
      "hangouts-chat-45b23cd19217da44@ssdspc.com",
      "hangouts-chat-a882a3b4a05f1865@ssdspc.com",
      "hdavlin@ssdspc.com",
      "hnicholson@ssdspc.com",
      "jhagan@ssdspc.com",
      "jhamilton@ssdspc.com",
      "jniblack@ssdspc.com",
      "jpayton@ssdspc.com",
      "jreynolds@ssdspc.com",
      "jsaluja@ssdspc.com",
      "kcharles@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmcmurray@ssdspc.com",
      "kparker@ssdspc.com",
      "lmarsh@ssdspc.com",
      "mdowning@ssdspc.com",
      "medmondson@ssdspc.com",
      "mfortner@ssdspc.com",
      "mgonzalez@ssdspc.com",
      "mm@ssdspc.com",
      "mstewart@ssdspc.com",
      "ocarter@ssdspc.com",
      "powen@ssdspc.com",
      "rkhan@ssdspc.com",
      "romar@ssdspc.com",
      "ssawyer@ssdspc.com",
      "tbunton@ssdspc.com",
      "tplatts@ssdspc.com",
      "tthompson@ssdspc.com",
      "twood@ssdspc.com",
      "voicemail@ssdspc.com"
    ]
  },
  {
    "name": "Update Surgery Dashboard - Dr. M's tab with counts of today's surgeries performed",
    "description": "Daily Task for Dr. D's Team (SMA-19)",
    "url": "https://docs.google.com/spreadsheets/d/1DE5JwiBoT23ygp-ufQCdQ3JYkBR9pl3Whod4__zLpPA/edit?gid=116542024#gid=116542024",
    "team": "Clinical, Providers",
    "assignee": "Dr. D's Team",
    "code": "SMA-19",
    "accessEmails": [
      "aadwell@ssdspc.com",
      "acochran@ssdspc.com",
      "admin@ssdspc.com",
      "agolightly@ssdspc.com",
      "agonzalez@ssdspc.com",
      "ajones@ssdspc.com",
      "appsheet@ssdspc.com",
      "arodriguez@ssdspc.com",
      "awalden@ssdspc.com",
      "bcurren@ssdspc.com",
      "bhammonds@ssdspc.com",
      "bherrington@ssdspc.com",
      "cthomson@ssdspc.com",
      "dderamus@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "drd@ssdspc.com",
      "dyearwood@ssdspc.com",
      "estephens@ssdspc.com",
      "fax@ssdspc.com",
      "gmcmahan@ssdspc.com",
      "hangouts-chat-45b23cd19217da44@ssdspc.com",
      "hangouts-chat-592f30e745662f04@ssdspc.com",
      "hangouts-chat-684d4ab8b6dcf50@ssdspc.com",
      "hdavlin@ssdspc.com",
      "hnicholson@ssdspc.com",
      "jhagan@ssdspc.com",
      "jhamilton@ssdspc.com",
      "jniblack@ssdspc.com",
      "jpayton@ssdspc.com",
      "jreynolds@ssdspc.com",
      "jsaluja@ssdspc.com",
      "kcharles@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmcmurray@ssdspc.com",
      "kparker@ssdspc.com",
      "lmarsh@ssdspc.com",
      "mdowning@ssdspc.com",
      "medmondson@ssdspc.com",
      "mfortner@ssdspc.com",
      "mgonzalez@ssdspc.com",
      "mm@ssdspc.com",
      "mstewart@ssdspc.com",
      "ocarter@ssdspc.com",
      "powen@ssdspc.com",
      "rkhan@ssdspc.com",
      "romar@ssdspc.com",
      "ssawyer@ssdspc.com",
      "tbunton@ssdspc.com",
      "tplatts@ssdspc.com",
      "tthompson@ssdspc.com",
      "twood@ssdspc.com",
      "voicemail@ssdspc.com"
    ]
  },
  {
    "name": "Send the Day's Orders via EMA",
    "description": "Daily Task for Dr. D's Team (SMA-20)",
    "url": "https://docs.google.com/spreadsheets/d/1omO-ZV6eNns56OpoifD3T75PrAouWhSf6bYdByHs-Cg/edit?gid=1774295471#gid=1774295471",
    "team": "Clinical, Providers",
    "assignee": "Dr. D's Team",
    "code": "SMA-20",
    "accessEmails": [
      "admin@ssdspc.com",
      "agonzalez@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "drd@ssdspc.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Send all prescriptions for the day",
    "description": "Daily Task for Dr. D's Team (SMA-21)",
    "url": "https://docs.google.com/spreadsheets/d/1DLOYM0VqVtGIm9HggOIZwlu8wqUlzZC79Bj_9Gx0VX4/edit?usp=drivesdkgid=1798082422#gid=1798082422",
    "team": "Clinical, Providers",
    "assignee": "Dr. D's Team",
    "code": "SMA-21",
    "accessEmails": [
      "aadwell@ssdspc.com",
      "acochran@ssdspc.com",
      "admin@ssdspc.com",
      "agolightly@ssdspc.com",
      "agonzalez@ssdspc.com",
      "ajones@ssdspc.com",
      "appsheet@ssdspc.com",
      "arodriguez@ssdspc.com",
      "awalden@ssdspc.com",
      "bcurren@ssdspc.com",
      "bhammonds@ssdspc.com",
      "bherrington@ssdspc.com",
      "cthomson@ssdspc.com",
      "dderamus@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "drd@ssdspc.com",
      "dyearwood@ssdspc.com",
      "estephens@ssdspc.com",
      "fax@ssdspc.com",
      "gmcmahan@ssdspc.com",
      "hdavlin@ssdspc.com",
      "hnicholson@ssdspc.com",
      "jhagan@ssdspc.com",
      "jhamilton@ssdspc.com",
      "jniblack@ssdspc.com",
      "jpayton@ssdspc.com",
      "jreynolds@ssdspc.com",
      "jsaluja@ssdspc.com",
      "kcharles@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmcmurray@ssdspc.com",
      "kparker@ssdspc.com",
      "lmarsh@ssdspc.com",
      "mdowning@ssdspc.com",
      "medmondson@ssdspc.com",
      "mfortner@ssdspc.com",
      "mgonzalez@ssdspc.com",
      "mm@ssdspc.com",
      "mstewart@ssdspc.com",
      "ocarter@ssdspc.com",
      "powen@ssdspc.com",
      "rkhan@ssdspc.com",
      "romar@ssdspc.com",
      "ssawyer@ssdspc.com",
      "ssdteam@ssdspc.com",
      "tbunton@ssdspc.com",
      "tplatts@ssdspc.com",
      "tthompson@ssdspc.com",
      "twood@ssdspc.com",
      "voicemail@ssdspc.com"
    ]
  },
  {
    "name": "Update Surgery Patients Needing Follow Up Dashboard",
    "description": "Daily Task for Dr. D's Team (SMA-22)",
    "url": "https://docs.google.com/spreadsheets/d/1ieC4wffNncQ3icOqSQ7g4kgxIxYMyZF1WOGQDQhIaJc/edit?gid=303491183#gid=303491183",
    "team": "Clinical, Providers",
    "assignee": "Dr. D's Team",
    "code": "SMA-22",
    "accessEmails": [
      "admin@ssdspc.com",
      "agonzalez@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "drd@ssdspc.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Update skin substitute inventory log and text rep",
    "description": "Daily Task for Dr. D's Team (SMA-23)",
    "url": "https://docs.google.com/spreadsheets/d/1omO-ZV6eNns56OpoifD3T75PrAouWhSf6bYdByHs-Cg/edit?gid=1774295471#gid=1774295471",
    "team": "Clinical, Providers",
    "assignee": "Dr. D's Team",
    "code": "SMA-23",
    "accessEmails": [
      "admin@ssdspc.com",
      "agonzalez@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "drd@ssdspc.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Update Status in EMA for path/biopses that were treated (inc cancelations/no shows)",
    "description": "Daily Task for Dr. D's Team (SMA-24)",
    "url": "https://docs.google.com/spreadsheets/d/1omO-ZV6eNns56OpoifD3T75PrAouWhSf6bYdByHs-Cg/edit?gid=1774295471#gid=1774295471",
    "team": "Clinical, Providers",
    "assignee": "Dr. D's Team",
    "code": "SMA-24",
    "accessEmails": [
      "admin@ssdspc.com",
      "agonzalez@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "drd@ssdspc.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Break Down Rooms Completely and Check if Cabinet Items Need Restocking",
    "description": "Daily Task for Dr. D's Team (SMA-27)",
    "url": "https://docs.google.com/spreadsheets/d/1omO-ZV6eNns56OpoifD3T75PrAouWhSf6bYdByHs-Cg/edit?gid=1774295471#gid=1774295471",
    "team": "Clinical, Providers",
    "assignee": "Dr. D's Team",
    "code": "SMA-27",
    "accessEmails": [
      "admin@ssdspc.com",
      "agonzalez@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "drd@ssdspc.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Clean & Restock exam rooms",
    "description": "Daily Task for Emma's Team (CMA-2)",
    "url": "https://docs.google.com/spreadsheets/d/1omO-ZV6eNns56OpoifD3T75PrAouWhSf6bYdByHs-Cg/edit?gid=1774295471#gid=1774295471",
    "team": "Clinical, Nursing",
    "assignee": "Emma's Team",
    "code": "CMA-2",
    "accessEmails": [
      "admin@ssdspc.com",
      "agonzalez@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "estephens@ssdspc.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Stock biopsy trays",
    "description": "Daily Task for Emma's Team (CMA-22)",
    "url": "https://docs.google.com/spreadsheets/d/1omO-ZV6eNns56OpoifD3T75PrAouWhSf6bYdByHs-Cg/edit?gid=1774295471#gid=1774295471",
    "team": "Clinical, Nursing",
    "assignee": "Emma's Team",
    "code": "CMA-22",
    "accessEmails": [
      "admin@ssdspc.com",
      "agonzalez@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "estephens@ssdspc.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "MIPS - Fix any MIPS Visits that need to be fixed for your team",
    "description": "Daily Task for Emma's Team (CMA-23)",
    "url": "https://script.google.com/a/macros/ssdspc.com/s/AKfycbxvI8IKjxMy6tKpMNCfdgXN939_4bVcOU4MQ9z7twFq1Aj7ap67SjMeeIj8464lsmcp/exec?title=Dermatitis%3A+Improvement+in+Patient-Reported+Itch+Severity&name=JOHNSTON%2C+JERRY&date=05%2F19%2F2025&provider=Stephens%2C+Emma&mrn=53138&facility=Trussville",
    "team": "Clinical, Nursing",
    "assignee": "Emma's Team",
    "code": "CMA-23",
    "accessEmails": [
      "admin@ssdspc.com",
      "agonzalez@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "estephens@ssdspc.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Voicemail Log - Respond to all voicemails for your team",
    "description": "Daily Task for Emma's Team (CMA-24)",
    "url": "https://docs.google.com/spreadsheets/d/1Ej8wzt6U6C-x5Ex9bv0ZRBZs5RFff0Xpi3Zak4r8u4E/edit?gid=611001893#gid=611001893",
    "team": "Clinical, Nursing",
    "assignee": "Emma's Team",
    "code": "CMA-24",
    "accessEmails": [
      "aadwell@ssdspc.com",
      "acochran@ssdspc.com",
      "admin@ssdspc.com",
      "adminhelp@ssdspc.com",
      "afloyd@ssdspc.com",
      "agamache@ssdspc.com",
      "agolightly@ssdspc.com",
      "agonzalez@ssdspc.com",
      "ajones@ssdspc.com",
      "aparameswaran@ssdspc.com",
      "appsheet@ssdspc.com",
      "arodriguez@ssdspc.com",
      "automation@ssdspc.com",
      "awalden@ssdspc.com",
      "ayoung@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "bhammonds@ssdspc.com",
      "bherrington@ssdspc.com",
      "bwscan@ssdspc.com",
      "cmartin@ssdspc.com",
      "cthomson@ssdspc.com",
      "dderamus@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "documents@ssdspc.com",
      "dpatel@ssdspc.com",
      "dwalters@ssdspc.com",
      "dyearwood@ssdspc.com",
      "ehenegar@ssdspc.com",
      "estephens@ssdspc.com",
      "fax@ssdspc.com",
      "games@ssdspc.com",
      "gmcmahan@ssdspc.com",
      "hangouts-chat-3548cceb17795147@ssdspc.com",
      "hangouts-chat-45b23cd19217da44@ssdspc.com",
      "hangouts-chat-8d3ba818a2189894@ssdspc.com",
      "hangouts-chat-a882a3b4a05f1865@ssdspc.com",
      "hdavlin@ssdspc.com",
      "hnicholson@ssdspc.com",
      "hwest@ssdspc.com",
      "jhagan@ssdspc.com",
      "jhamilton@ssdspc.com",
      "jniblack@ssdspc.com",
      "jpayton@ssdspc.com",
      "jreynolds@ssdspc.com",
      "jsaluja@ssdspc.com",
      "kcharles@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmcmurray@ssdspc.com",
      "kparker@ssdspc.com",
      "kparton@ssdspc.com",
      "lmarsh@ssdspc.com",
      "lsanford@ssdspc.com",
      "mbaker@ssdspc.com",
      "mbivins@ssdspc.com",
      "mdowning@ssdspc.com",
      "medmondson@ssdspc.com",
      "mfortner@ssdspc.com",
      "mgonzalez@ssdspc.com",
      "mhornsby@ssdspc.com",
      "mm@ssdspc.com",
      "mstewart@ssdspc.com",
      "nteague@ssdspc.com",
      "ocarter@ssdspc.com",
      "powen@ssdspc.com",
      "rhead@ssdspc.com",
      "rkhan@ssdspc.com",
      "romar@ssdspc.com",
      "scripts@ssdspc.com",
      "skhan@ssdspc.com",
      "sriggins@ssdspc.com",
      "ssawyer@ssdspc.com",
      "ssd-automation-service-account@workspace-automation-ssdspc.iam.gserviceaccount.com",
      "sync-sa@ssd-intranet-sync.iam.gserviceaccount.com",
      "tbunton@ssdspc.com",
      "tplatts@ssdspc.com",
      "tthompson@ssdspc.com",
      "twood@ssdspc.com",
      "voicemail@ssdspc.com"
    ]
  },
  {
    "name": "Incoming Fax Log - Take care of all incoming faxes for your team",
    "description": "Daily Task for Emma's Team (CMA-25)",
    "url": "https://docs.google.com/spreadsheets/d/1A7y3cwOAjwzZgtzTcr1q41fOtCpVedQTDHGUZKozBMc/edit?gid=307646613#gid=307646613",
    "team": "Clinical, Nursing",
    "assignee": "Emma's Team",
    "code": "CMA-25",
    "accessEmails": [
      "aadwell@ssdspc.com",
      "acochran@ssdspc.com",
      "admin@ssdspc.com",
      "adminhelp@ssdspc.com",
      "afloyd@ssdspc.com",
      "agamache@ssdspc.com",
      "agolightly@ssdspc.com",
      "agonzalez@ssdspc.com",
      "ajones@ssdspc.com",
      "aparameswaran@ssdspc.com",
      "appsheet@ssdspc.com",
      "arodriguez@ssdspc.com",
      "automation@ssdspc.com",
      "awalden@ssdspc.com",
      "ayoung@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "bhammonds@ssdspc.com",
      "bherrington@ssdspc.com",
      "bwscan@ssdspc.com",
      "cmartin@ssdspc.com",
      "cthomson@ssdspc.com",
      "dderamus@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "documents@ssdspc.com",
      "domain:ssdspc.com",
      "dpatel@ssdspc.com",
      "dwalters@ssdspc.com",
      "dyearwood@ssdspc.com",
      "ehenegar@ssdspc.com",
      "estephens@ssdspc.com",
      "fax@ssdspc.com",
      "games@ssdspc.com",
      "gmcmahan@ssdspc.com",
      "hdavlin@ssdspc.com",
      "hnicholson@ssdspc.com",
      "hwest@ssdspc.com",
      "jhagan@ssdspc.com",
      "jhamilton@ssdspc.com",
      "jniblack@ssdspc.com",
      "jpayton@ssdspc.com",
      "jreynolds@ssdspc.com",
      "jsaluja@ssdspc.com",
      "kcharles@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmcmurray@ssdspc.com",
      "kparker@ssdspc.com",
      "kparton@ssdspc.com",
      "lmarsh@ssdspc.com",
      "lsanford@ssdspc.com",
      "mbaker@ssdspc.com",
      "mbivins@ssdspc.com",
      "mdowning@ssdspc.com",
      "medmondson@ssdspc.com",
      "mfortner@ssdspc.com",
      "mgonzalez@ssdspc.com",
      "mhornsby@ssdspc.com",
      "mm@ssdspc.com",
      "mstewart@ssdspc.com",
      "nteague@ssdspc.com",
      "ocarter@ssdspc.com",
      "powen@ssdspc.com",
      "rhead@ssdspc.com",
      "rkhan@ssdspc.com",
      "romar@ssdspc.com",
      "scripts@ssdspc.com",
      "skhan@ssdspc.com",
      "sriggins@ssdspc.com",
      "ssawyer@ssdspc.com",
      "ssd-automation-service-account@workspace-automation-ssdspc.iam.gserviceaccount.com",
      "sync-sa@ssd-intranet-sync.iam.gserviceaccount.com",
      "tbunton@ssdspc.com",
      "tplatts@ssdspc.com",
      "tthompson@ssdspc.com",
      "twood@ssdspc.com",
      "voicemail@ssdspc.com"
    ]
  },
  {
    "name": "Contact patients who have a benign path report (assigned by provider)",
    "description": "Daily Task for Emma's Team (CMA-26)",
    "url": "https://docs.google.com/spreadsheets/d/1omO-ZV6eNns56OpoifD3T75PrAouWhSf6bYdByHs-Cg/edit?gid=1774295471#gid=1774295471",
    "team": "Clinical, Nursing",
    "assignee": "Emma's Team",
    "code": "CMA-26",
    "accessEmails": [
      "admin@ssdspc.com",
      "agonzalez@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "estephens@ssdspc.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "All medications requiring a PA are sent via PA Google Form",
    "description": "Daily Task for Emma's Team (CMA-27)",
    "url": "https://docs.google.com/spreadsheets/d/1FZu7DIVr3IOnk6jSN_1L5hw2-lKbjkLlnsZIMbFOu-4/edit?gid=0#gid=0",
    "team": "Clinical, Nursing",
    "assignee": "Emma's Team",
    "code": "CMA-27",
    "accessEmails": [
      "aadwell@ssdspc.com",
      "admin@ssdspc.com",
      "adminhelp@ssdspc.com",
      "afloyd@ssdspc.com",
      "agamache@ssdspc.com",
      "agolightly@ssdspc.com",
      "agonzalez@ssdspc.com",
      "ajones@ssdspc.com",
      "aparameswaran@ssdspc.com",
      "appsheet@ssdspc.com",
      "automation@ssdspc.com",
      "awalden@ssdspc.com",
      "ayoung@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "bhammonds@ssdspc.com",
      "bherrington@ssdspc.com",
      "bwscan@ssdspc.com",
      "cmartin@ssdspc.com",
      "cthomson@ssdspc.com",
      "dderamus@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "documents@ssdspc.com",
      "dpatel@ssdspc.com",
      "dwalters@ssdspc.com",
      "ehenegar@ssdspc.com",
      "estephens@ssdspc.com",
      "fax@ssdspc.com",
      "games@ssdspc.com",
      "gmcmahan@ssdspc.com",
      "hwest@ssdspc.com",
      "jhagan@ssdspc.com",
      "jniblack@ssdspc.com",
      "jpayton@ssdspc.com",
      "jreynolds@ssdspc.com",
      "kcharles@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmcmurray@ssdspc.com",
      "kparker@ssdspc.com",
      "kparton@ssdspc.com",
      "lmarsh@ssdspc.com",
      "lsanford@ssdspc.com",
      "mbaker@ssdspc.com",
      "mbivins@ssdspc.com",
      "mdowning@ssdspc.com",
      "mfortner@ssdspc.com",
      "mgonzalez@ssdspc.com",
      "mhornsby@ssdspc.com",
      "mm@ssdspc.com",
      "mstewart@ssdspc.com",
      "nteague@ssdspc.com",
      "powen@ssdspc.com",
      "rhead@ssdspc.com",
      "rkhan@ssdspc.com",
      "romar@ssdspc.com",
      "scripts@ssdspc.com",
      "skhan@ssdspc.com",
      "sriggins@ssdspc.com",
      "ssawyer@ssdspc.com",
      "ssd-automation-service-account@workspace-automation-ssdspc.iam.gserviceaccount.com",
      "sync-sa@ssd-intranet-sync.iam.gserviceaccount.com",
      "tbunton@ssdspc.com",
      "tplatts@ssdspc.com",
      "twood@ssdspc.com",
      "voicemail@ssdspc.com"
    ]
  },
  {
    "name": "All lab tests ordered were submitted via the Lab Test Google Form",
    "description": "Daily Task for Emma's Team (CMA-28)",
    "url": "https://docs.google.com/forms/d/e/1FAIpQLSegQ2iJyahjsyQXK2zPksAkvlGLxmuSlQaKTFlsL4at-QbPAg/viewform?usp=dialog",
    "team": "Clinical, Nursing",
    "assignee": "Emma's Team",
    "code": "CMA-28",
    "accessEmails": [
      "admin@ssdspc.com",
      "agonzalez@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "estephens@ssdspc.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "All wound cultures performed were submitted via the Wound Culture Google Form",
    "description": "Daily Task for Emma's Team (CMA-29)",
    "url": "https://docs.google.com/forms/d/e/1FAIpQLSdIyoO60kNzVMEZxdbRBInHdekXcy9BUQJyTDGa17Gp3gTiDA/viewform",
    "team": "Clinical, Nursing",
    "assignee": "Emma's Team",
    "code": "CMA-29",
    "accessEmails": [
      "admin@ssdspc.com",
      "agonzalez@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "estephens@ssdspc.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Draw up lidocaine for next day",
    "description": "Daily Task for Emma's Team (CMA-30)",
    "url": "https://docs.google.com/spreadsheets/d/1omO-ZV6eNns56OpoifD3T75PrAouWhSf6bYdByHs-Cg/edit?gid=1774295471#gid=1774295471",
    "team": "Clinical, Nursing",
    "assignee": "Emma's Team",
    "code": "CMA-30",
    "accessEmails": [
      "admin@ssdspc.com",
      "agonzalez@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "estephens@ssdspc.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "EOD - Check work email and respond to any admin requests (google forms surveys, etc)",
    "description": "Daily Task for Emma's Team (CMA-31)",
    "url": "https://docs.google.com/spreadsheets/d/1KMsidrbBLL_cc1vmiSozSopW4AMIGTDHMgSNDs0kGYw/edit?usp=drivesdkgid=509629444#gid=509629444",
    "team": "Clinical, Nursing",
    "assignee": "Emma's Team",
    "code": "CMA-31",
    "accessEmails": [
      "aadwell@ssdspc.com",
      "admin@ssdspc.com",
      "agonzalez@ssdspc.com",
      "arodriguez@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "estephens@ssdspc.com",
      "jsaluja@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmatthews@ssdspc.com",
      "mm@ssdspc.com",
      "rkhan@ssdspc.com",
      "skhan@ssdspc.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "EOD - Send lab orders on EMA",
    "description": "Daily Task for Emma's Team (CMA-81)",
    "url": "https://docs.google.com/spreadsheets/d/1omO-ZV6eNns56OpoifD3T75PrAouWhSf6bYdByHs-Cg/edit?gid=1774295471#gid=1774295471",
    "team": "Clinical, Nursing",
    "assignee": "Emma's Team",
    "code": "CMA-81",
    "accessEmails": [
      "admin@ssdspc.com",
      "agonzalez@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "estephens@ssdspc.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "EOD - Make sure all prescriptions have been successfully sent to patients' pharmacies",
    "description": "Daily Task for Emma's Team (CMA-32)",
    "url": "https://docs.google.com/spreadsheets/d/1DLOYM0VqVtGIm9HggOIZwlu8wqUlzZC79Bj_9Gx0VX4/edit?usp=drivesdkgid=1798082422#gid=1798082422",
    "team": "Clinical, Nursing",
    "assignee": "Emma's Team",
    "code": "CMA-32",
    "accessEmails": [
      "aadwell@ssdspc.com",
      "acochran@ssdspc.com",
      "admin@ssdspc.com",
      "agolightly@ssdspc.com",
      "agonzalez@ssdspc.com",
      "ajones@ssdspc.com",
      "appsheet@ssdspc.com",
      "arodriguez@ssdspc.com",
      "awalden@ssdspc.com",
      "bcurren@ssdspc.com",
      "bhammonds@ssdspc.com",
      "bherrington@ssdspc.com",
      "cthomson@ssdspc.com",
      "dderamus@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "dyearwood@ssdspc.com",
      "estephens@ssdspc.com",
      "fax@ssdspc.com",
      "gmcmahan@ssdspc.com",
      "hdavlin@ssdspc.com",
      "hnicholson@ssdspc.com",
      "jhagan@ssdspc.com",
      "jhamilton@ssdspc.com",
      "jniblack@ssdspc.com",
      "jpayton@ssdspc.com",
      "jreynolds@ssdspc.com",
      "jsaluja@ssdspc.com",
      "kcharles@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmcmurray@ssdspc.com",
      "kparker@ssdspc.com",
      "lmarsh@ssdspc.com",
      "mdowning@ssdspc.com",
      "medmondson@ssdspc.com",
      "mfortner@ssdspc.com",
      "mgonzalez@ssdspc.com",
      "mm@ssdspc.com",
      "mstewart@ssdspc.com",
      "ocarter@ssdspc.com",
      "powen@ssdspc.com",
      "rkhan@ssdspc.com",
      "romar@ssdspc.com",
      "ssawyer@ssdspc.com",
      "ssdteam@ssdspc.com",
      "tbunton@ssdspc.com",
      "tplatts@ssdspc.com",
      "tthompson@ssdspc.com",
      "twood@ssdspc.com",
      "voicemail@ssdspc.com"
    ]
  },
  {
    "name": "EOD - Take all instruments to lab and clean them; do NOT leave them submerged!",
    "description": "Daily Task for Emma's Team (CMA-33)",
    "url": "https://docs.google.com/spreadsheets/d/1omO-ZV6eNns56OpoifD3T75PrAouWhSf6bYdByHs-Cg/edit?gid=1774295471#gid=1774295471",
    "team": "Clinical, Nursing",
    "assignee": "Emma's Team",
    "code": "CMA-33",
    "accessEmails": [
      "admin@ssdspc.com",
      "agonzalez@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "estephens@ssdspc.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "EOD - Plug in iPads to charge overnight",
    "description": "Daily Task for Emma's Team (CMA-34)",
    "url": "https://docs.google.com/spreadsheets/d/1omO-ZV6eNns56OpoifD3T75PrAouWhSf6bYdByHs-Cg/edit?gid=1774295471#gid=1774295471",
    "team": "Clinical, Nursing",
    "assignee": "Emma's Team",
    "code": "CMA-34",
    "accessEmails": [
      "admin@ssdspc.com",
      "agonzalez@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "estephens@ssdspc.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Hand the paper notes back to the Front Desk to count the daily biopsies",
    "description": "Daily Task for Emma's Team (CMA-59)",
    "url": "https://docs.google.com/spreadsheets/d/1f8h-c7c2TEzzRbrofGxH8VvJqpsjx4IWiRr5JY7t170/edit?usp=drivesdkgid=1788297381#gid=1788297381",
    "team": "Clinical, Nursing",
    "assignee": "Emma's Team",
    "code": "CMA-59",
    "accessEmails": [
      "admin@ssdspc.com",
      "agonzalez@ssdspc.com",
      "arodriguez@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "estephens@ssdspc.com",
      "hangouts-chat-a882a3b4a05f1865@ssdspc.com",
      "jsaluja@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmatthews@ssdspc.com",
      "mm@ssdspc.com",
      "rkhan@ssdspc.com",
      "skhan@ssdspc.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Outgoing Referral Requests",
    "description": "Daily Task for Emma's Team (CMA-128)",
    "url": "https://forms.gle/dQx5PmMYMRqygYw59",
    "team": "Clinical, Nursing",
    "assignee": "Emma's Team",
    "code": "CMA-128",
    "accessEmails": [
      "admin@ssdspc.com",
      "agonzalez@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "estephens@ssdspc.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Clean & Restock exam rooms",
    "description": "Daily Task for Kaitlyn's Team (CMA-8)",
    "url": "https://docs.google.com/spreadsheets/d/1omO-ZV6eNns56OpoifD3T75PrAouWhSf6bYdByHs-Cg/edit?gid=1774295471#gid=1774295471",
    "team": "Clinical, Nursing",
    "assignee": "Kaitlyn's Team",
    "code": "CMA-8",
    "accessEmails": [
      "admin@ssdspc.com",
      "agonzalez@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "kmatthews@ssdspc.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Stock biopsy trays",
    "description": "Daily Task for Kaitlyn's Team (CMA-9)",
    "url": "https://docs.google.com/spreadsheets/d/1omO-ZV6eNns56OpoifD3T75PrAouWhSf6bYdByHs-Cg/edit?gid=1774295471#gid=1774295471",
    "team": "Clinical, Nursing",
    "assignee": "Kaitlyn's Team",
    "code": "CMA-9",
    "accessEmails": [
      "admin@ssdspc.com",
      "agonzalez@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "kmatthews@ssdspc.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "MIPS - Fix any MIPS Visits that need to be fixed for your team",
    "description": "Daily Task for Kaitlyn's Team (CMA-17)",
    "url": "https://script.google.com/a/macros/ssdspc.com/s/AKfycbxvI8IKjxMy6tKpMNCfdgXN939_4bVcOU4MQ9z7twFq1Aj7ap67SjMeeIj8464lsmcp/exec?title=Dermatitis%3A+Improvement+in+Patient-Reported+Itch+Severity&name=JOHNSTON%2C+JERRY&date=05%2F19%2F2025&provider=Stephens%2C+Emma&mrn=53138&facility=Trussville",
    "team": "Clinical, Nursing",
    "assignee": "Kaitlyn's Team",
    "code": "CMA-17",
    "accessEmails": [
      "admin@ssdspc.com",
      "agonzalez@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "kmatthews@ssdspc.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Voicemail Log - Respond to all voicemails for your team",
    "description": "Daily Task for Kaitlyn's Team (CMA-12)",
    "url": "https://docs.google.com/spreadsheets/d/1Ej8wzt6U6C-x5Ex9bv0ZRBZs5RFff0Xpi3Zak4r8u4E/edit?gid=611001893#gid=611001893",
    "team": "Clinical, Nursing",
    "assignee": "Kaitlyn's Team",
    "code": "CMA-12",
    "accessEmails": [
      "aadwell@ssdspc.com",
      "acochran@ssdspc.com",
      "admin@ssdspc.com",
      "adminhelp@ssdspc.com",
      "afloyd@ssdspc.com",
      "agamache@ssdspc.com",
      "agolightly@ssdspc.com",
      "agonzalez@ssdspc.com",
      "ajones@ssdspc.com",
      "aparameswaran@ssdspc.com",
      "appsheet@ssdspc.com",
      "arodriguez@ssdspc.com",
      "automation@ssdspc.com",
      "awalden@ssdspc.com",
      "ayoung@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "bhammonds@ssdspc.com",
      "bherrington@ssdspc.com",
      "bwscan@ssdspc.com",
      "cmartin@ssdspc.com",
      "cthomson@ssdspc.com",
      "dderamus@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "documents@ssdspc.com",
      "dpatel@ssdspc.com",
      "dwalters@ssdspc.com",
      "dyearwood@ssdspc.com",
      "ehenegar@ssdspc.com",
      "estephens@ssdspc.com",
      "fax@ssdspc.com",
      "games@ssdspc.com",
      "gmcmahan@ssdspc.com",
      "hangouts-chat-3548cceb17795147@ssdspc.com",
      "hangouts-chat-45b23cd19217da44@ssdspc.com",
      "hangouts-chat-8d3ba818a2189894@ssdspc.com",
      "hangouts-chat-a882a3b4a05f1865@ssdspc.com",
      "hdavlin@ssdspc.com",
      "hnicholson@ssdspc.com",
      "hwest@ssdspc.com",
      "jhagan@ssdspc.com",
      "jhamilton@ssdspc.com",
      "jniblack@ssdspc.com",
      "jpayton@ssdspc.com",
      "jreynolds@ssdspc.com",
      "jsaluja@ssdspc.com",
      "kcharles@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmatthews@ssdspc.com",
      "kmcmurray@ssdspc.com",
      "kparker@ssdspc.com",
      "kparton@ssdspc.com",
      "lmarsh@ssdspc.com",
      "lsanford@ssdspc.com",
      "mbaker@ssdspc.com",
      "mbivins@ssdspc.com",
      "mdowning@ssdspc.com",
      "medmondson@ssdspc.com",
      "mfortner@ssdspc.com",
      "mgonzalez@ssdspc.com",
      "mhornsby@ssdspc.com",
      "mm@ssdspc.com",
      "mstewart@ssdspc.com",
      "nteague@ssdspc.com",
      "ocarter@ssdspc.com",
      "powen@ssdspc.com",
      "rhead@ssdspc.com",
      "rkhan@ssdspc.com",
      "romar@ssdspc.com",
      "scripts@ssdspc.com",
      "skhan@ssdspc.com",
      "sriggins@ssdspc.com",
      "ssawyer@ssdspc.com",
      "ssd-automation-service-account@workspace-automation-ssdspc.iam.gserviceaccount.com",
      "sync-sa@ssd-intranet-sync.iam.gserviceaccount.com",
      "tbunton@ssdspc.com",
      "tplatts@ssdspc.com",
      "tthompson@ssdspc.com",
      "twood@ssdspc.com",
      "voicemail@ssdspc.com"
    ]
  },
  {
    "name": "Incoming Fax Log - Take care of all incoming faxes for your team",
    "description": "Daily Task for Kaitlyn's Team (CMA-13)",
    "url": "https://docs.google.com/spreadsheets/d/1A7y3cwOAjwzZgtzTcr1q41fOtCpVedQTDHGUZKozBMc/edit?gid=307646613#gid=307646613",
    "team": "Clinical, Nursing",
    "assignee": "Kaitlyn's Team",
    "code": "CMA-13",
    "accessEmails": [
      "aadwell@ssdspc.com",
      "acochran@ssdspc.com",
      "admin@ssdspc.com",
      "adminhelp@ssdspc.com",
      "afloyd@ssdspc.com",
      "agamache@ssdspc.com",
      "agolightly@ssdspc.com",
      "agonzalez@ssdspc.com",
      "ajones@ssdspc.com",
      "aparameswaran@ssdspc.com",
      "appsheet@ssdspc.com",
      "arodriguez@ssdspc.com",
      "automation@ssdspc.com",
      "awalden@ssdspc.com",
      "ayoung@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "bhammonds@ssdspc.com",
      "bherrington@ssdspc.com",
      "bwscan@ssdspc.com",
      "cmartin@ssdspc.com",
      "cthomson@ssdspc.com",
      "dderamus@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "documents@ssdspc.com",
      "domain:ssdspc.com",
      "dpatel@ssdspc.com",
      "dwalters@ssdspc.com",
      "dyearwood@ssdspc.com",
      "ehenegar@ssdspc.com",
      "estephens@ssdspc.com",
      "fax@ssdspc.com",
      "games@ssdspc.com",
      "gmcmahan@ssdspc.com",
      "hdavlin@ssdspc.com",
      "hnicholson@ssdspc.com",
      "hwest@ssdspc.com",
      "jhagan@ssdspc.com",
      "jhamilton@ssdspc.com",
      "jniblack@ssdspc.com",
      "jpayton@ssdspc.com",
      "jreynolds@ssdspc.com",
      "jsaluja@ssdspc.com",
      "kcharles@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmatthews@ssdspc.com",
      "kmcmurray@ssdspc.com",
      "kparker@ssdspc.com",
      "kparton@ssdspc.com",
      "lmarsh@ssdspc.com",
      "lsanford@ssdspc.com",
      "mbaker@ssdspc.com",
      "mbivins@ssdspc.com",
      "mdowning@ssdspc.com",
      "medmondson@ssdspc.com",
      "mfortner@ssdspc.com",
      "mgonzalez@ssdspc.com",
      "mhornsby@ssdspc.com",
      "mm@ssdspc.com",
      "mstewart@ssdspc.com",
      "nteague@ssdspc.com",
      "ocarter@ssdspc.com",
      "powen@ssdspc.com",
      "rhead@ssdspc.com",
      "rkhan@ssdspc.com",
      "romar@ssdspc.com",
      "scripts@ssdspc.com",
      "skhan@ssdspc.com",
      "sriggins@ssdspc.com",
      "ssawyer@ssdspc.com",
      "ssd-automation-service-account@workspace-automation-ssdspc.iam.gserviceaccount.com",
      "sync-sa@ssd-intranet-sync.iam.gserviceaccount.com",
      "tbunton@ssdspc.com",
      "tplatts@ssdspc.com",
      "tthompson@ssdspc.com",
      "twood@ssdspc.com",
      "voicemail@ssdspc.com"
    ]
  },
  {
    "name": "Contact patients who have a benign path report (assigned by provider)",
    "description": "Daily Task for Kaitlyn's Team (CMA-14)",
    "url": "https://docs.google.com/spreadsheets/d/1omO-ZV6eNns56OpoifD3T75PrAouWhSf6bYdByHs-Cg/edit?gid=1774295471#gid=1774295471",
    "team": "Clinical, Nursing",
    "assignee": "Kaitlyn's Team",
    "code": "CMA-14",
    "accessEmails": [
      "admin@ssdspc.com",
      "agonzalez@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "kmatthews@ssdspc.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "All medications requiring a PA are sent via PA Google Form",
    "description": "Daily Task for Kaitlyn's Team (CMA-15)",
    "url": "https://docs.google.com/spreadsheets/d/1rmGaWR9e3y5PdNvGe2D5SDgKjJip4uyG34EQOxnIEGw/edit?gid=0#gid=0",
    "team": "Clinical, Nursing",
    "assignee": "Kaitlyn's Team",
    "code": "CMA-15",
    "accessEmails": [
      "aadwell@ssdspc.com",
      "acochran@ssdspc.com",
      "admin@ssdspc.com",
      "adminhelp@ssdspc.com",
      "afloyd@ssdspc.com",
      "agamache@ssdspc.com",
      "agolightly@ssdspc.com",
      "agonzalez@ssdspc.com",
      "ajones@ssdspc.com",
      "aparameswaran@ssdspc.com",
      "appsheet@ssdspc.com",
      "arodriguez@ssdspc.com",
      "automation@ssdspc.com",
      "awalden@ssdspc.com",
      "ayoung@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "bhammonds@ssdspc.com",
      "bherrington@ssdspc.com",
      "bwscan@ssdspc.com",
      "cmartin@ssdspc.com",
      "cthomson@ssdspc.com",
      "dderamus@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "documents@ssdspc.com",
      "domain:ssdspc.com",
      "dpatel@ssdspc.com",
      "dwalters@ssdspc.com",
      "dyearwood@ssdspc.com",
      "ehenegar@ssdspc.com",
      "estephens@ssdspc.com",
      "fax@ssdspc.com",
      "games@ssdspc.com",
      "gmcmahan@ssdspc.com",
      "hdavlin@ssdspc.com",
      "hnicholson@ssdspc.com",
      "hwest@ssdspc.com",
      "jhagan@ssdspc.com",
      "jhamilton@ssdspc.com",
      "jniblack@ssdspc.com",
      "jpayton@ssdspc.com",
      "jreynolds@ssdspc.com",
      "jsaluja@ssdspc.com",
      "kcharles@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmatthews@ssdspc.com",
      "kmcmurray@ssdspc.com",
      "kparker@ssdspc.com",
      "kparton@ssdspc.com",
      "lmarsh@ssdspc.com",
      "lsanford@ssdspc.com",
      "mbaker@ssdspc.com",
      "mbivins@ssdspc.com",
      "mdowning@ssdspc.com",
      "medmondson@ssdspc.com",
      "mfortner@ssdspc.com",
      "mgonzalez@ssdspc.com",
      "mhornsby@ssdspc.com",
      "mm@ssdspc.com",
      "mstewart@ssdspc.com",
      "nteague@ssdspc.com",
      "ocarter@ssdspc.com",
      "powen@ssdspc.com",
      "rhead@ssdspc.com",
      "rkhan@ssdspc.com",
      "romar@ssdspc.com",
      "scripts@ssdspc.com",
      "skhan@ssdspc.com",
      "sriggins@ssdspc.com",
      "ssawyer@ssdspc.com",
      "ssd-automation-service-account@workspace-automation-ssdspc.iam.gserviceaccount.com",
      "sync-sa@ssd-intranet-sync.iam.gserviceaccount.com",
      "tbunton@ssdspc.com",
      "tplatts@ssdspc.com",
      "tthompson@ssdspc.com",
      "twood@ssdspc.com",
      "voicemail@ssdspc.com"
    ]
  },
  {
    "name": "All lab tests ordered were submitted via the Lab Test Google Form",
    "description": "Daily Task for Kaitlyn's Team (CMA-20)",
    "url": "https://docs.google.com/forms/d/e/1FAIpQLSegQ2iJyahjsyQXK2zPksAkvlGLxmuSlQaKTFlsL4at-QbPAg/viewform?usp=dialog",
    "team": "Clinical, Nursing",
    "assignee": "Kaitlyn's Team",
    "code": "CMA-20",
    "accessEmails": [
      "admin@ssdspc.com",
      "agonzalez@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "kmatthews@ssdspc.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "All wound cultures performed were submitted via the Wound Culture Google Form",
    "description": "Daily Task for Kaitlyn's Team (CMA-21)",
    "url": "https://docs.google.com/forms/d/e/1FAIpQLSdIyoO60kNzVMEZxdbRBInHdekXcy9BUQJyTDGa17Gp3gTiDA/viewform",
    "team": "Clinical, Nursing",
    "assignee": "Kaitlyn's Team",
    "code": "CMA-21",
    "accessEmails": [
      "admin@ssdspc.com",
      "agonzalez@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "kmatthews@ssdspc.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "EOD - Check work email and respond to any admin requests (google forms surveys, etc)",
    "description": "Daily Task for Kaitlyn's Team (CMA-16)",
    "url": "https://docs.google.com/spreadsheets/d/1KMsidrbBLL_cc1vmiSozSopW4AMIGTDHMgSNDs0kGYw/edit?usp=drivesdkgid=509629444#gid=509629444",
    "team": "Clinical, Nursing",
    "assignee": "Kaitlyn's Team",
    "code": "CMA-16",
    "accessEmails": [
      "aadwell@ssdspc.com",
      "admin@ssdspc.com",
      "agonzalez@ssdspc.com",
      "arodriguez@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "jsaluja@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmatthews@ssdspc.com",
      "mm@ssdspc.com",
      "rkhan@ssdspc.com",
      "skhan@ssdspc.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "EOD - Send lab orders on EMA",
    "description": "Daily Task for Kaitlyn's Team (CMA-82)",
    "url": "https://docs.google.com/spreadsheets/d/1omO-ZV6eNns56OpoifD3T75PrAouWhSf6bYdByHs-Cg/edit?gid=1774295471#gid=1774295471",
    "team": "Clinical, Nursing",
    "assignee": "Kaitlyn's Team",
    "code": "CMA-82",
    "accessEmails": [
      "admin@ssdspc.com",
      "agonzalez@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "kmatthews@ssdspc.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "EOD - Make sure all prescriptions have been successfully sent to patients' pharmacies",
    "description": "Daily Task for Kaitlyn's Team (CMA-10)",
    "url": "https://docs.google.com/spreadsheets/d/1DLOYM0VqVtGIm9HggOIZwlu8wqUlzZC79Bj_9Gx0VX4/edit?usp=drivesdkgid=1798082422#gid=1798082422",
    "team": "Clinical, Nursing",
    "assignee": "Kaitlyn's Team",
    "code": "CMA-10",
    "accessEmails": [
      "aadwell@ssdspc.com",
      "acochran@ssdspc.com",
      "admin@ssdspc.com",
      "agolightly@ssdspc.com",
      "agonzalez@ssdspc.com",
      "ajones@ssdspc.com",
      "appsheet@ssdspc.com",
      "arodriguez@ssdspc.com",
      "awalden@ssdspc.com",
      "bcurren@ssdspc.com",
      "bhammonds@ssdspc.com",
      "bherrington@ssdspc.com",
      "cthomson@ssdspc.com",
      "dderamus@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "dyearwood@ssdspc.com",
      "estephens@ssdspc.com",
      "fax@ssdspc.com",
      "gmcmahan@ssdspc.com",
      "hdavlin@ssdspc.com",
      "hnicholson@ssdspc.com",
      "jhagan@ssdspc.com",
      "jhamilton@ssdspc.com",
      "jniblack@ssdspc.com",
      "jpayton@ssdspc.com",
      "jreynolds@ssdspc.com",
      "jsaluja@ssdspc.com",
      "kcharles@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmatthews@ssdspc.com",
      "kmcmurray@ssdspc.com",
      "kparker@ssdspc.com",
      "lmarsh@ssdspc.com",
      "mdowning@ssdspc.com",
      "medmondson@ssdspc.com",
      "mfortner@ssdspc.com",
      "mgonzalez@ssdspc.com",
      "mm@ssdspc.com",
      "mstewart@ssdspc.com",
      "ocarter@ssdspc.com",
      "powen@ssdspc.com",
      "rkhan@ssdspc.com",
      "romar@ssdspc.com",
      "ssawyer@ssdspc.com",
      "ssdteam@ssdspc.com",
      "tbunton@ssdspc.com",
      "tplatts@ssdspc.com",
      "tthompson@ssdspc.com",
      "twood@ssdspc.com",
      "voicemail@ssdspc.com"
    ]
  },
  {
    "name": "EOD - Take all instruments to lab and clean them; do NOT leave them submerged!",
    "description": "Daily Task for Kaitlyn's Team (CMA-11)",
    "url": "https://docs.google.com/spreadsheets/d/1omO-ZV6eNns56OpoifD3T75PrAouWhSf6bYdByHs-Cg/edit?gid=1774295471#gid=1774295471",
    "team": "Clinical, Nursing",
    "assignee": "Kaitlyn's Team",
    "code": "CMA-11",
    "accessEmails": [
      "admin@ssdspc.com",
      "agonzalez@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "kmatthews@ssdspc.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "EOD - Plug in iPads to charge overnight",
    "description": "Daily Task for Kaitlyn's Team (CMA-18)",
    "url": "https://docs.google.com/spreadsheets/d/1omO-ZV6eNns56OpoifD3T75PrAouWhSf6bYdByHs-Cg/edit?gid=1774295471#gid=1774295471",
    "team": "Clinical, Nursing",
    "assignee": "Kaitlyn's Team",
    "code": "CMA-18",
    "accessEmails": [
      "admin@ssdspc.com",
      "agonzalez@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "kmatthews@ssdspc.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Review Daily email with MIPS metric and fix any listed visits",
    "description": "Daily Task for Kaitlyn's Team (CMA-58)",
    "url": "https://docs.google.com/spreadsheets/d/1omO-ZV6eNns56OpoifD3T75PrAouWhSf6bYdByHs-Cg/edit?gid=1774295471#gid=1774295471",
    "team": "Clinical, Nursing",
    "assignee": "Kaitlyn's Team",
    "code": "CMA-58",
    "accessEmails": [
      "admin@ssdspc.com",
      "agonzalez@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "kmatthews@ssdspc.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Hand the paper notes back to the Front Desk to count the daily biopsies",
    "description": "Daily Task for Kaitlyn's Team (CMA-62)",
    "url": "https://docs.google.com/spreadsheets/d/1f8h-c7c2TEzzRbrofGxH8VvJqpsjx4IWiRr5JY7t170/edit?usp=drivesdkgid=1788297381#gid=1788297381",
    "team": "Clinical, Nursing",
    "assignee": "Kaitlyn's Team",
    "code": "CMA-62",
    "accessEmails": [
      "admin@ssdspc.com",
      "agonzalez@ssdspc.com",
      "arodriguez@ssdspc.com",
      "backup@ssdspc.com",
      "bcurren@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "hangouts-chat-a882a3b4a05f1865@ssdspc.com",
      "jsaluja@ssdspc.com",
      "khenriquez@ssdspc.com",
      "kmatthews@ssdspc.com",
      "mm@ssdspc.com",
      "rkhan@ssdspc.com",
      "skhan@ssdspc.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Outgoing Referral Requests",
    "description": "Daily Task for Kaitlyn's Team (CMA-127)",
    "url": "https://forms.gle/dQx5PmMYMRqygYw59",
    "team": "Clinical, Nursing",
    "assignee": "Kaitlyn's Team",
    "code": "CMA-127",
    "accessEmails": [
      "admin@ssdspc.com",
      "agonzalez@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "kmatthews@ssdspc.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Clean & Restock exam rooms",
    "description": "Daily Task for Dena's Team (CMA-3)",
    "url": "https://docs.google.com/spreadsheets/d/1omO-ZV6eNns56OpoifD3T75PrAouWhSf6bYdByHs-Cg/edit?gid=1774295471#gid=1774295471",
    "team": "Clinical, Nursing",
    "assignee": "Dena's Team",
    "code": "CMA-3",
    "accessEmails": [
      "admin@ssdspc.com",
      "agonzalez@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "dyearwood@ssdspc.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "Stock biopsy trays",
    "description": "Daily Task for Dena's Team (CMA-35)",
    "url": "https://docs.google.com/spreadsheets/d/1omO-ZV6eNns56OpoifD3T75PrAouWhSf6bYdByHs-Cg/edit?gid=1774295471#gid=1774295471",
    "team": "Clinical, Nursing",
    "assignee": "Dena's Team",
    "code": "CMA-35",
    "accessEmails": [
      "admin@ssdspc.com",
      "agonzalez@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "dyearwood@ssdspc.com",
      "tbunton@ssdspc.com"
    ]
  },
  {
    "name": "MIPS - Fix any MIPS Visits that need to be fixed for your team",
    "description": "Daily Task for Dena's Team (CMA-36)",
    "url": "https://script.google.com/a/macros/ssdspc.com/s/AKfycbxvI8IKjxMy6tKpMNCfdgXN939_4bVcOU4MQ9z7twFq1Aj7ap67SjMeeIj8464lsmcp/exec?title=Dermatitis%3A+Improvement+in+Patient-Reported+Itch+Severity&name=JOHNSTON%2C+JERRY&date=05%2F19%2F2025&provider=Stephens%2C+Emma&mrn=53138&facility=Trussville",
    "team": "Clinical, Nursing",
    "assignee": "Dena's Team",
    "code": "CMA-36",
    "accessEmails": [
      "admin@ssdspc.com",
      "agonzalez@ssdspc.com",
      "dev@southernskiesdermatology.com",
      "dyearwood@ssdspc.com",
      "tbunton@ssdspc.com"
    ]
  }
];
